"use strict";


function gisAerial(options) {
  this.options = options;
}

gisAerial.prototype.showAerialMap = function () {
  const lat = this.options.lat;
  const lon = this.options.lon;
  let global_parid = this.options.parid;




  let chosenMapLayers = this.options.chosenMapLayers?.length > 0
    ? [...this.options.chosenMapLayers]
    : [];

  let chosenPriorYearMapLayer = this.options.chosenPriorYearMapLayer?.length > 0
    ? [...this.options.chosenPriorYearMapLayer]
    : [];

  let chosenStormLayerIndex = this.options.chosenStormLayerIndex?.length > 0
    ? [...this.options.chosenStormLayerIndex]
    : [];


  require([
    'esri/Map',
    'esri/views/MapView',
    "esri/layers/ImageryLayer",
    'esri/layers/ImageryTileLayer',
    'esri/layers/MapImageLayer',
    'esri/layers/WMTSLayer',
    'esri/layers/GroupLayer',
    'esri/layers/FeatureLayer',
    'esri/widgets/LayerList',
    'esri/widgets/Swipe',
    'esri/widgets/Popup',
    'esri/request',
    'esri/Graphic',
    'esri/layers/GraphicsLayer',
    'esri/widgets/Sketch',
    'esri/widgets/Sketch/SketchViewModel',
    'esri/rest/support/IdentifyParameters',
    'esri/rest/identify',
    'esri/rest/support/Query',
    'esri/rest/query',
    'esri/core/reactiveUtils',
    'esri/widgets/Expand',
    'esri/geometry/geometryEngine',
    'esri/widgets/Measurement',
    'esri/widgets/Print',
    'esri/widgets/Print/PrintViewModel',
    'esri/widgets/ScaleBar',
    'esri/identity/IdentityManager',
    'esri/widgets/Search',
    'esri/geometry/Extent',
    'esri/widgets/Search/SearchSource',
    'esri/core/promiseUtils',
  ], function (
    Map,
    MapView,
    ImageryLayer,
    ImageryTileLayer,
    MapImageLayer,
    WMTSLayer,
    GroupLayer,
    FeatureLayer,
    LayerList,
    Swipe,
    Popup,
    esriRequest,
    Graphic,
    GraphicsLayer,
    Sketch,
    SketchViewModel,
    IdentifyParameters,
    identify,
    Query,
    query,
    reactiveUtils,
    Expand,
    geometryEngine,
    Measurement,
    Print,
    PrintViewModel,
    ScaleBar,
    IdentityManager,
    Search,
    Extent,
    SearchSource,
    promiseUtils
  ) {
    const AlertMessageOptions = Object.freeze({
      Default: 1,
      AerialImageryNotAvailable: 2,
      MapLayersNotAvailable: 3,
    });

    let alertUser = AlertMessageOptions.Default;
    let alertContainer = document.createElement('div');

    const ChosenSelectionMethodOptions = Object.freeze({
      None: 0,
      Condominium: 1,
      Cooperative: 2,
      ParcelId: 3,
      Sketch: 4,
      Subdivision: 5,
    });
    let chosenSelectionMethod = ChosenSelectionMethodOptions.None;

    const ChosenUnitTypes = Object.freeze({
      Feet: 'feet',
      Kilometers: 'kilometers',
      Meters: 'meters',
      Miles: 'miles',
    });
    let unitType = ChosenUnitTypes.Feet;

    const ConveyanceTypes = Object.freeze({
      Condominiums: 'condominiums',
      Cooperatives: 'cooperatives',
      Subdivisions: 'subdivisions',
    });
    let chosenConveyanceType;

    const PaoAlertAutoDismissSpeed = Object.freeze({
      Fast: 'fast',
      Medium: 'medium',
      Slow: 'slow',
    });


    const SKETCH_GROUP2_TITLE = 'Use a sketch tool';
    const SKETCH_GROUP2_TITLE_NOTIFY = '(zoom in to enable)';
    const BUFFER_RESULTS_HEADING = 'Buffer Results';
    const MAX_DATAGRID_ITEMS = 15;
    const COLOR_VAR_BRAND_BLUE = '--calcite-ui-brand-press';
    const bufferWidgetInactiveTitle = 'Select parcels for mailing labels/list.';


    let MAX_QUERY_RECORDCOUNT = 0;
    let sketchViewModel;
    let sketchGeometry;
    let sketchPointGeometry;
    let layerListExpand;
    let subjectParSubdivision;
    let identifyParams;
    let currentProgressBar;

    let activeWidget = {
      buttonId: '',
      containerId: '',
      state: 'inactive',
      worksMinimized: false,
      showTitleBar: false,
      lastActiveButton: '',
    };

    let measure_widget = null;
    let swipeWidget = null;

    let modalActive = false;
    let zoomIsFar = false;
    let distanceConstraintSet = false;
    let isRural = false;

    let totalProgressSteps = 0;

    let sketchIdentifyDoneFlag = false;

    let goto_target_params = {
      target: null,
      center: null,
      scale: null,
      zoom: null
    };

    let current_parcel_feature = null;

    let userSelectedMethod = {
      id: '',
      label: '',
      value: ''
    };

    let primaryPanel = '';
    let layerList = '';
    let resetStateLength = 0;
    let bufferWasReset = false;
    let printExpand;
    let searchWidget = null;
    let accordionIdList = [];
    let bufferedData = {
      cols: [],
      rows: [],
    };
    let subjectParcels = {
      cols: [],
      rows: [],
    };

    const DG_ADDR_COLUMNS = [
      'PARID',
      'PAR_MAIL_LABEL1',
      'PAR_MAIL_LABEL2',
      'PAR_MAIL_LABEL3',
      'PAR_MAIL_LABEL4',
      'PAR_MAIL_LABEL5',
      'PAR_MAIL_LABEL6',
    ];

    let sliderBlockStateKeepClosed = false;


    let dgData = [];

    let imageryTileLayerMetaUrls = [];

    let bufferSize = 0;

    let queried_parids_in_subject_property = null;

    let bufferLayerViewUpdatingFlag = false;

    let waitingForResults = false;

    let blockUpdateDataTable = false;

    let latestYearAerialUrl = paoDetails.gis.services.latestYearAerial.url;
    let priorYearAerialsUrl = paoDetails.gis.services.priorYearAerials.url;
    let mapLayerAndLabelsUrl = paoDetails.gis.services.mapLayerAndLabels.url;
    let districtPLSSLayersUrl = paoDetails.gis.services.districtPLSSLayers.url;

    let postHeleneImageryUrl = paoDetails.gis.services.postHeleneImagery.url;
    let postHeleneImageryEnabled = paoDetails.gis.services.postHeleneImagery.enabled;

    let postMiltonImageryUrl = paoDetails.gis.services.postMiltonImagery.url;
    let postMiltonImageryEnabled = paoDetails.gis.services.postMiltonImagery.enabled;

    let printServiceUrl = paoDetails.gis.services.printService.url;

    let parcelSearchUrl = `${mapLayerAndLabelsUrl}/${paoDetails.gis.services.mapLayerAndLabels.indices.parcelSearch}`;
    let condominiumsUrl = `${mapLayerAndLabelsUrl}/${paoDetails.gis.services.mapLayerAndLabels.indices.condominiums}`;
    let cooperativesUrl = `${mapLayerAndLabelsUrl}/${paoDetails.gis.services.mapLayerAndLabels.indices.cooperatives}`;
    let subdivisionsUrl = `${mapLayerAndLabelsUrl}/${paoDetails.gis.services.mapLayerAndLabels.indices.subdivisions}`;

    let taxParcelTypesSelectedString = '';
    let taxParcelTypesDefaultString = '';
    let taxParcelTypeColors = '';
    let includeSubjectParcelsOn = true;
    let chosenMethodValue = '';
    let chosenMethodTextLabel = '';
    let activeAccordionId = '';
    let activeDataAccordionItem = '';
    let setupDataTableFlag = false;
    let mapsLoadedSuccessfully = false;

    IdentityManager.on('dialog-create', () => {
      IdentityManager.dialog.open = false;
      alertUser = AlertMessageOptions.AerialImageryNotAvailable;
      userAlert();
      fixBaseLayerFont(map);
    });

    const map = new Map({
      basemap: 'streets-vector',
    });

    let priorYearAerials = null;
    let _swipeLeadingLayer = null;
    let _swipeTrailingLayer = null;

    const GROUPLAYER_TITLE_STORMS = 'STORMS';



    let currentMapYear = 0;

    let url_meta = latestYearAerialUrl + '/?f=pjson';
    esriRequest(url_meta, {
      responseType: 'json',
      timeout: 5000,
    })
      .then(function (response) {
        var service_description = response?.data?.serviceDescription;
        if (service_description?.length > 0)
          currentMapYear = service_description;
      })
    ['catch']((error) => { });

    let url = priorYearAerialsUrl + '/?f=pjson';
    esriRequest(url, {
      responseType: 'json',
      timeout: 5000,
    })
      .then(function (response) {
        var regex = /^[0-9]{4}$/;
        var years = [];
        $.each(response.data.folders, function (index, value) {
          if (regex.exec(value) !== null) {
            if (currentMapYear === 0 || value <= currentMapYear) {
              years.push(value);
            }
          }
        });

        let tileServers = [];
        years.forEach(function (year) {
          var layerUrl =
            priorYearAerialsUrl +
            '/' +
            year +
            '/AERIAL_' +
            year +
            (year > 2002 ? '_RGB' : '_BW') +
            '/ImageServer';
          var tlay = new ImageryTileLayer({
            url: layerUrl,
            title: year,
          });


          imageryTileLayerMetaUrls[`YR_${year}`] = {
            layerUrl: `${layerUrl}/?f=pjson`
          };

          tileServers.push(tlay);
        });

        return tileServers;
      })
      .then(function (tileServers) {


        priorYearAerials = new GroupLayer({
          title: 'Aerials',
          visible: true,
          visibilityMode: 'exclusive',
          layers: tileServers,
        });
        map.add(priorYearAerials);

        map.reorder(priorYearAerials, 0);

        _swipeTrailingLayer = priorYearAerials;

        setMapLayersVisibility();


        mapsLoadedSuccessfully = tileServers.length > 0;
      })
    ['catch']((error) => {
      if (error.message === 'Timeout exceeded') {
        doLogException('esriRequest', error);
      }
      alertUser = AlertMessageOptions.AerialImageryNotAvailable;
      userAlert();
      if (!mapsLoadedSuccessfully) {
        fixBaseLayerFont(map);
      }
    });

    let groupStorms = [];

    const postHeleneImagery = new ImageryLayer({
      url: postHeleneImageryUrl,
      layer: "postHelene",
      title: "Post Helene Imagery",
      visible: false
    });
    if (postHeleneImageryEnabled) {
      map.add(postHeleneImagery);
      groupStorms.push(postHeleneImagery);
    }

    const postMiltonImagery = new ImageryLayer({
      url: postMiltonImageryUrl,
      layer: "postMilton",
      title: "Post Milton Imagery",
      visible: false
    });
    if (postMiltonImageryEnabled) {
      map.add(postMiltonImagery);
      groupStorms.push(postMiltonImagery);
    }

    const mapGroupLayerStorms = new GroupLayer({
      title: 'Storms',
      visible: false,
      layers: [...groupStorms]
    });
    if (groupStorms?.length > 0)
      map.add(mapGroupLayerStorms);

    const mapLayerAndLabels = new MapImageLayer({
      url: mapLayerAndLabelsUrl,
      legendEnabled: true,
      visible: true,
      title: 'Map Layers & Labels',
    });
    map.add(mapLayerAndLabels);

    const districtPLSSLayers = new MapImageLayer({
      url: districtPLSSLayersUrl,
      legendEnabled: true,
      visible: true,
      title: 'Districts & PLSS Layers',
    });
    map.add(districtPLSSLayers);

    let padding = {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    };


    let animationOptions = {
      animate: true, 
      duration: 400, 
      easing: 'linear', 
      speedFactor: 0.5, 
    };

    if (paoDetails.gis.displayPage === 'fullaerial') {
      padding['top'] = 55;
    }

    let default_popup = {
      viewModel: {
        actions: {
          zoom: false,
        },
        actionsMenuEnabled: false,    
        includeDefaultActions: false, 
      },
      dockEnabled: false, 
      dockOptions: {
        buttonEnabled: false,
        breakpoint: false,
      },
      visibleElements: {
        featureNavigation: true,
        closeButton: true,
      },
    };


    let view = new MapView({
      map: map,
      container: 'aerialMapViewer',
      center: [lon, lat],
      zoom: 12,
      navigation: {
        momentumEnabled: !paoDetails.support.isMobileDevice,
        mouseWheelZoomEnabled: !paoDetails.support.isMobileDevice,
        browserTouchPanEnabled: true, 
      },
      padding: padding,
      constraints: {
        maxScale: 0,
        minScale: 300000,
      },
      popup: default_popup,
    });

    const measurement = new Measurement();



    const mapEl = document.querySelector('#aerialMapViewer');

    const queryFeatureLayer = new FeatureLayer({
      url: parcelSearchUrl,
      geometryType: 'polygon',
      title: 'featureLayer-hideinlist',
      spatialReference: {
        wkid: 102659,
      },
      outFields: [
        'OBJECTID',
        'PARID',
        'PAR_MAIL_LABEL1',
        'PAR_MAIL_LABEL2',
        'PAR_MAIL_LABEL3',
        'PAR_MAIL_LABEL4',
        'PAR_MAIL_LABEL5',
        'PAR_MAIL_LABEL6',
        'PAR_SUBDIVISION',
        'TAXPARCELTYPE',
      ],
    });

    const createSearchWidgetPopupTemplate = async () => {

      let template = await new PaoPopupTemplate();

      template.contentType = 'default';

      template.IsGoToParcel = true;


      if (activeWidget?.buttonId === 'bufferButton') {
        if (chosenSelectionMethod === ChosenSelectionMethodOptions.None || chosenSelectionMethod === ChosenSelectionMethodOptions.ParcelId) {
          template.IsGoToBufferParcel = true;
        }
      }
      return template.template();

    };

    const sketchLayer = new GraphicsLayer({
      title: 'sketchLayer-hideinlist',
    });
    const bufferLayer = new GraphicsLayer({
      title: 'bufferLayer-hideinlist',
    });



    let invalidSymbol = {
      type: 'simple-fill',
      style: 'diagonal-cross',
      color: 'rgba(255, 0, 0, 1)',
      outline: {
        color: 'rgba(255, 0, 05, 1)',
        width: 4, 
      },
    };
    let pointSymbol = {
      type: 'simple-marker',
      style: 'circle',
      color: 'rgba(255, 77, 106, 1)',
      size: 8,
      outline: {
        color: 'rgba(255, 255, 255, 1)',
        width: 1, 
      },
    };
    let polylineSymbol = {
      type: 'simple-line',
      color: [211, 132, 80, 0.7],
      width: 6
    };
    let polygonSymbol = {
      type: 'simple-fill',
      color: [150, 150, 150, 0.2],
      outline: {
        color: [252, 251, 253],
        width: 2
      },
    };
    let lineAcqua = [66, 244, 206, 1];
    let lineWhite = [255, 255, 255, 1];
    let symbolLineAcqua = {
      type: 'simple-fill',
      style: 'none',
      outline: {
        color: lineAcqua,
        width: 2,
      },
    };

    function fixBaseLayerFont(map) {
      let maplayers = map.layers.filter((a) => {
        try {
          return (
            a.title === 'Map Layers & Labels' ||
            a.title === 'Districts & PLSS Layers'
          );
        } catch (error) {
          console.error('maplayers: ' + error);
        }
      });
      let aerials = map.layers.filter(function (a) {
        try {
          return a.title === 'Aerials';
        } catch (error) {
          console.error('aerials: ' + error);
        }
      });
      try {
        LayerListAdjustBasemapFont(aerials, maplayers);
      } catch (error) {
        console.error('LayerListAdjustBasemapFont: ' + error);
      }
    }

    function doCursor(c) {
      mapEl.style.cursor = c;
    }

    view.when(() => {
      afterMaploaded();
    })
      .catch((error) => {
        let tf = error.name.includes("webgl");
        doLogException('view.when', error, tf);
      });

    const afterMaploaded = async () => {
      try {

        handleViewWatches();

        sketchViewModel = new SketchViewModel({
          view: view,
          layer: sketchLayer,
          pointSymbol: pointSymbol,
          polylineSymbol: polylineSymbol,
          polygonSymbol: polygonSymbol,
          snappingOptions: {
            enabled: true,
            featureSources: [{ layer: sketchLayer, enabled: true }],
          },
          mode: 'click',
          updateOnGraphicClick: false,
          defaultCreateOptions: {
            hasZ: false,
            enableScaling: false,
            enableRotation: false,
            toggleToolOnClick: false, 
            shapeOperation: 'none',
          },
        });

        let measure_widget_label;

        sketchViewModel.on('create', (event) => {

          if (event.state === 'start') {

            let dv = document.createElement('div');
            dv.setAttribute('id', 'pao-measurements-widget');
            dv.setAttribute('class', 'esri-widget d-none');
            document.body.appendChild(dv);

            measure_widget_label = document.getElementById('pao-measurements-widget');
            if (measure_widget_label) {
              measure_widget_label.classList.remove('d-none');
              view.ui.add(measure_widget_label, 'manual');
            }
          }

          if (event.state === 'active') {
            if (measure_widget_label) {
              async function getArea(polygon) {
                let unit = `square-${unitType}`;
                let abv = await getChosenBufferUnitTypeAbbrv();
                const planarArea = geometryEngine.planarArea(polygon, unit);
                measure_widget_label.innerHTML = `<div style='margin: 2px;'><b>${userSelectedMethod.label.replace('Parcels By', '')} Planar Area</b></div><div>${planarArea.toFixed(2)}${abv}\xB2</div>`;
              }
              getArea(event.graphic.geometry);
            }
          }

          if (event.state === 'complete') {

            bufferLayer.remove(event.graphic);
            view.graphics.removeAll();
            showTaxParcelTypesList();
            showBufferSlider();

            identifyParams.returnGeometry = true;
            identifyParams.geometry = event.graphic.geometry;
            identifyParams.mapExtent = view.extent;

            buildAccordionContainer();

            identify
              .identify(mapLayerAndLabelsUrl, identifyParams)
              .then((response) => {
                let results = response.results;

                sketchIdentifyDoneFlag = true;

                sortMineral(results);

                let feature = results.map((result, i) => {
                  let feature = result.feature;
                  let layerName = result.layerName;
                  let lat = feature?.geometry?.centroid?.latitude;
                  let lng = feature?.geometry?.centroid?.longitude;
                  toggleDistanceConstraints(isParcelRural(lat, lng));
                  feature.attributes.layerName = layerName;
                  return feature;
                });
                if (response.results?.length > 0) {
                  getChosenBufferUnitTypeAbbrv()
                    .then(applyConveyanceRule)
                    .catch((error) => doLogException('getChosenBufferUnitTypeAbbrv', error));
                }
                if (feature && feature[0]) {
                  if (event.graphic.geometry.type === 'point') {
                    sketchGeometry = feature[0].geometry;
                  } else {
                    sketchGeometry = event.graphic.geometry;
                  }
                  sketchPointGeometry = event.graphic.geometry;

                  if (!bufferLayerViewUpdatingFlag) {
                    queryLayerView();
                  } else {

                    let alert_id = PaoInfo.showAlert({
                      title: 'Your results will appear shortly.',
                      message: '',
                      scale: 's',
                      placement: 'bottom',
                      auto_close: false,
                      auto_close_speed: null,
                      icon: 'timer'
                    });

                    const handle = setInterval(() => {
                      if (!bufferLayerViewUpdatingFlag) {
                        document.getElementById(alert_id).open = false;
                        queryLayerView();
                        clearInterval(handle);
                      }
                    }, 400);
                  }
                }
              }).catch((error) => {
                doLogException('sketchViewModel->identify', error);
              });
          }
        });

        await mapReady();

        if (paoDetails.gis.launchBufferWidget) {
          bufferTool();
        }

      } catch (error) {
        doLogException('afterMaploaded', error);
      }
    };

    function handleViewWatches() {

      reactiveUtils.watch(
        () => [
          view?.updating,
          view?.stationary,
          view?.navigating,
          view?.interacting,
          view?.zoom,
        ],
        ([updating, stationary, navigating, interacting, zoom]) => {


          let bc = document.getElementById('pao-buffer-container');
          if (bc && bc.hasAttribute('hidden') && bc.hidden)
            return;

          disableBufferExportTool(updating, interacting, zoom);

        }
      );
    }

    view.watch('fatalError', function (error) {
      if (error) {
        console.error(
          'Fatal Error! View has lost its WebGL context. Attempting to recover...'
        );
        view.tryFatalErrorRecovery();
      }
    });

    function sortMineral(results) {


      results.sort((a, b) => {
        return a.feature.attributes.PARID > b.feature.attributes.PARID ? 1 : -1;
      });

      results.sort((a, b) => {
        if (
          (a.feature.attributes.TAXPARCELTYPE === 'MINERAL RIGHT') &
          (b.feature.attributes.TAXPARCELTYPE === 'PARCEL')
        )
          return 1;
        else return -1;
      });

      results.sort((a, b) => {
        if (a.feature.attributes.TAXPARCELTYPE === 'MINERAL RIGHT') return 0;

        if (
          (a.feature.attributes.TAXPARCELTYPE === 'CONDO UNIT') &
          (b.feature.attributes.TAXPARCELTYPE === 'PARCEL')
        )
          return 1;
        else return -1;
      });
    }

    const updateView = ({ showViewHeaderTitle: showTitle }) => {
      return new Promise((resolve) => {
        if (detectMobileDevice()) showTitle = false;
        setViewHeaderTitle(showTitle);

        resolve(true);
      }).catch((error) => doLogException('updateView', error));
    };

    const setViewHeaderTitle = (showTitle) => {
      if (!showTitle) {
        document.querySelector('#header-title').setAttribute('hidden', '');
        view.padding = {
          top: 0,
        };
      } else {
        document.querySelector('#header-title').removeAttribute('hidden');
        view.padding = {
          top: 55,
        };
      }
    };

    const addlayerListExpand = () => {
      layerListExpand = new Expand({
        content: (layerList = new LayerList({
          view: view,
          listItemCreatedFunction: (event) => {
            let item = event.item;
            let key = item.title.toUpperCase().replace(/ /g, '');

            if (item.layer.type === 'group' || item.layer.type === 'tile') {
              if (key === 'AERIALS') {
                reactiveUtils.when(
                  () => !item.layer.visible,
                  () => {
                    layerListFormat(item);
                    map.layers.getItemAt(1).visible = false;
                    trackVisibleMapLayers();
                    var yr_label = document.getElementById('aerial_year_label');
                    if (yr_label)
                      yr_label.classList.add('d-none')
                  }
                );
                reactiveUtils.when(
                  () => item.layer.visible,
                  () => {
                    layerListFormat(item);
                    trackVisibleMapLayers();
                    var yr_label = document.getElementById('aerial_year_label');
                    if (yr_label)
                      yr_label.classList.remove('d-none')
                  }
                );

                reactiveUtils
                  .whenOnce(() => item.layer.visible)
                  .then(() => {
                    layerListFormat(item);

                    if (chosenPriorYearMapLayer?.length > 0) {
                      const [yearIndex = null] = chosenPriorYearMapLayer;
                      if (yearIndex)
                        view.map.allLayers.items[yearIndex].visible = true;
                    }
                  });

                reactiveUtils.watch(
                  () => item.layer.layers.filter((layer) => layer.visible),
                  (newVisibleLayers, oldVisibleLayers) => {
                    addChosenPriorYearMapLayer(newVisibleLayers, oldVisibleLayers);
                  }
                ); 
              } 

              if (key === GROUPLAYER_TITLE_STORMS) {
                const stormLayer = item.layer;
                reactiveUtils.watch(
                  () => {
                    return stormLayer.visible;
                  },
                  (visibleGroupLayer) => {
                    if (visibleGroupLayer) {
                      item.open = true;
                      trackVisibleMapLayers();
                    } else {
                      item.open = false;
                      stormLayer.layers.forEach(sublayer => {
                        if (sublayer.visible) sublayer.visible = false;
                      });
                    }
                  }
                );

                reactiveUtils.watch(
                  () => {
                    if (stormLayer.visible) {
                      return stormLayer.layers.filter(sublayer => sublayer.visible);
                    } else {
                      stormLayer.visible = false;
                      return null;
                    }
                  },
                  (visibleSublayers) => {
                    if (!visibleSublayers) return;
                    const _indices = visibleSublayers.map(sublayer =>
                      stormLayer.layers.indexOf(sublayer)
                    );
                    let indices_length = Object.keys(_indices.items).length;
                    if (indices_length > 0) {
                      chosenStormLayerIndex = [];
                      chosenStormLayerIndex.push(..._indices.items);
                      _swipeLeadingLayer = stormLayer.layers.items[_indices.items[0]];
                    }
                    _swipeTrailingLayer = priorYearAerials;

                    if (indices_length === 2) {
                      _swipeLeadingLayer = stormLayer.layers.items[_indices.items[0]];
                      _swipeTrailingLayer = stormLayer.layers.items[_indices.items[1]];
                    }

                    if (indices_length > 0 && !swipeWidget)
                      addSwipeWidget();
                  }
                );
              } 
            } 

            if (item.layer.type === 'imagery') {
              key = item.layer.title.toUpperCase().replace(/ /g, '');
              if (key === 'POSTHELENEIMAGERY' || key === 'POSTMILTONIMAGERY') {
                item.title = item.layer.title;

                reactiveUtils.watch(
                  () => {
                    return item.layer.visible;
                  },
                  (visibleImageryLayer) => {

                    const groupLayerStorms = view.map.layers.find(layer => layer.title === 'Storms');

                    if (groupLayerStorms && groupLayerStorms instanceof GroupLayer) {

                      const stormLayersVisible = groupLayerStorms.layers.items.filter((layer) => layer.visible);

                      if (stormLayersVisible?.length === 0)
                        chosenStormLayerIndex = [];

                      groupLayerStorms.visible = visibleImageryLayer || chosenStormLayerIndex?.length > 0;
                    }

                    if (!visibleImageryLayer) {

                      if (swipeWidget)
                        removeSwipeWidget();
                    }
                    trackVisibleMapLayers();
                  }
                );
              }
            }

            if (item.layer.type === 'map-image') {
              if (key === 'MAPLAYERS&LABELS' || 'DISTRICTS&PLSSLAYERS') {
                if (
                  item.layer.allSublayers &&
                  item.layer.allSublayers.length > 0
                ) {
                  item.layer.allSublayers.forEach((item) => {
                    if (item.title === 'Parcel Search') {
                      item.listMode = 'hide';
                    }
                    if (item.sublayers && item.sublayers.length > 0) {
                      item.sublayers.forEach((item) => {
                        item.listMode = 'hide';
                      });
                    } 
                  }); 
                } 

                if (item.layer.type != 'group') {
                  let keyIndex = map.layers.findIndex((item) => {
                    let k = item.title.toUpperCase().replace(/ /g, '');
                    return k === key;
                  });
                  if (keyIndex) {
                    let featureLayer = map.layers.getItemAt(keyIndex);
                    item.panel = {
                      content: 'legend',
                      layerInfos: [
                        {
                          layer: featureLayer,
                          title: 'Manatee County Property Appraiser',
                        },
                      ],
                      open: false,
                    };
                  }
                } 

                reactiveUtils.when(
                  () => !item.layer.visible,
                  () => {
                    trackVisibleMapLayers();
                  }
                );
                reactiveUtils.when(
                  () => item.layer.visible,
                  () => {
                    trackVisibleMapLayers();
                  }
                );
              } 
            } 

            if (
              item.layer.type !== 'map-image' &&
              item.layer.type !== 'wms' &&
              item.layer.type !== 'tile'
            ) {
              switch (key) {
                case 'BUFFERLAYER-HIDEINLIST':
                case 'SKETCHLAYER-HIDEINLIST':
                case 'FEATURELAYER-HIDEINLIST':
                  item.layer.listMode = 'hide';
                  break;
              }
            }
          },
        })), 
        view: view,
        autoCollapse: true,
        expanded: false,
        expandTooltip: 'Map Layers',
        group: 'top-right',
        mode: 'floating',
      });
    };

    const addChosenPriorYearMapLayer = (newVisibleLayers, oldVisibleLayers) => {
      const added = newVisibleLayers.filter((layer) => !oldVisibleLayers.includes(layer));
      const addedIndices = added.map((layer) => view.map.allLayers.findIndex((l) => l === layer));
      const [yearChosenIndex = null] = addedIndices;
      chosenPriorYearMapLayer = [];
      if (yearChosenIndex >= 0)
        chosenPriorYearMapLayer.push(yearChosenIndex);
    };

    const watchVisibleAerialLayer = async () => {
      let vml = view.map?.layers?.items;
      if (vml[0]?.layers?.items?.length > 0) {
        vml[0]?.layers.forEach((layer) => {
          reactiveUtils.watch(() => layer.visible, (visible) => {
            if (layer.visible) {
              var s_url = imageryTileLayerMetaUrls[`YR_${layer.title}`].layerUrl;
              esriRequest(s_url, {
                responseType: 'json',
                timeout: 5000,
              })
                .then(function (response) {
                  var end_date = '';
                  var beg_date = '';
                  var el = document.getElementById('aerial_year_label');
                  if (el) {
                    var dt = response?.data?.description;
                    if (dt) {
                      var aerial_dates = dt.split('-');
                      if (aerial_dates?.length > 1) {
                        beg_date = aerial_dates[0];
                        el.classList.add('aerial-year');
                      } else {
                        el.classList.remove('aerial-year');
                      }
                      if (aerial_dates?.length > 1)
                        end_date = aerial_dates[1];

                      if (isValidDate(beg_date)) {
                        beg_date = new Date(beg_date).toLocaleDateString('en-US');
                      }
                      if (isValidDate(end_date)) {
                        end_date = new Date(end_date).toLocaleDateString('en-US');
                      }
                    }
                    var hyph = '';
                    if (end_date?.length > 0)
                      hyph = ' - ';

                    el.innerText = `${beg_date}${hyph}${end_date}`;
                  }
                }).catch((error) => doLogException('watchVisibleAerialLayer', error));
            }
          });
        });
      }
    };

    const setMapLayersVisibility = () => {
      if (chosenMapLayers?.length > 0) {
        map.layers.forEach((layer, layer_index) => {
          layer.visible = false;
          chosenMapLayers.forEach((chosen_index) => {
            if (chosen_index === layer_index) {
              layer.visible = true;
              if (layer?.title.toUpperCase() === GROUPLAYER_TITLE_STORMS) {
                if (chosenStormLayerIndex?.length > 0) {
                  chosenStormLayerIndex.forEach((storm_layer) => {
                    layer.layers.items[storm_layer].visible = true;
                  });
                  _swipeLeadingLayer = layer?.layers.items[0];
                  addSwipeWidget();
                }
              }
            }
          });
        });
      }
    };

    const parcelQueryBuffer = async () => {
      return new Promise((resolve) => {
        addQueryFeatureLayer()
          .then(addQueryBuffer)
          .then(() => {
            resolve(true);
          })
          .catch((error) => {
            doLogException('parcelQueryBuffer->addQueryFeatureLayer', error);
            resolve(false);
          });
      }).catch((error) => doLogException('parcelQueryBuffer', error));
    };

    function clearDataTable() {
      let table = $('#pao-table-buffer').DataTable();
      table.clear();

      bufferedData = {
        cols: [],
        rows: [],
      };

      if (includeSubjectParcelsOn && subjectParcels?.rows)
        table.rows.add(subjectParcels.rows).draw();
    }

    const updateDataTable = async (featureSet) => {
      try {
        blockUpdateDataTable = true;

        const graphics = featureSet.features;
        let result = {
          cols: [],
          rows: [],
        };
        let address_columns = featureSet.fields.filter((field) => {
          switch (field.name.toUpperCase()) {
            case 'PARID':
            case 'PAR_MAIL_LABEL1':
            case 'PAR_MAIL_LABEL2':
            case 'PAR_MAIL_LABEL3':
            case 'PAR_MAIL_LABEL4':
            case 'PAR_MAIL_LABEL5':
            case 'PAR_MAIL_LABEL6':
            case 'TAXPARCELTYPE':
              return field.name;
            default:
              return false;
          }
        });
        let columns = address_columns.map((field) => {
          switch (field.name.toUpperCase()) {
            case 'PARID':
            case 'PAR_MAIL_LABEL1':
            case 'PAR_MAIL_LABEL2':
            case 'PAR_MAIL_LABEL3':
            case 'PAR_MAIL_LABEL4':
            case 'PAR_MAIL_LABEL5':
            case 'PAR_MAIL_LABEL6':
            case 'TAXPARCELTYPE':
              return {
                title: field.name,
              };
            default:
              return false;
          }
        });

        result.cols = columns;
        await graphics.map((feature, i) => {
          let row = [];
          return Object.entries(feature.attributes).forEach((entry) => {
            switch (entry[0].toUpperCase()) {
              case 'PARID':
              case 'PAR_MAIL_LABEL1':
              case 'PAR_MAIL_LABEL2':
              case 'PAR_MAIL_LABEL3':
              case 'PAR_MAIL_LABEL4':
              case 'PAR_MAIL_LABEL5':
              case 'PAR_MAIL_LABEL6':
              case 'TAXPARCELTYPE':
                const [key, value] = entry;
                row.push(value);
                result.rows[i] = row;
                return result;
              default:
            }
          });
        });

        let filtered = {
          cols: result.cols,
          rows: [],
        };

        bufferedData = {
          cols: result.cols,
          rows: result.rows,
        };

        filtered.rows = result.rows.filter((val, idx, arr) => {
          if (!lookupSubjectParid(val[0])) return true;
          return includeSubjectParcelsOn;
        });

        const values = !filtered.rows.filter((value) =>
          subjectParcels.rows.includes(value)
        );
        if (values?.length > 0) filtered.rows.push(values);

        let unitTypeAbbrv = await getChosenBufferUnitTypeAbbrv();

        let dgKeyColection = {
          index: dgData[activeDataAccordionItem]?.index,
          cols: filtered.cols,
          rows: filtered.rows, 
          subjects: subjectParcels.rows,
          taxParcelTypeList: dgData[activeDataAccordionItem].taxParcelTypeList, 
          chosenSelectionMethod: chosenSelectionMethod,
          chosenMethodValue: chosenMethodValue,
          unitTypeAbbrv: unitTypeAbbrv,
          includeSubjectParcelsOn: includeSubjectParcelsOn,
          bufferSize: bufferSize,
          isRural: isRural
        };
        await loadAccordionDataTable(dgKeyColection);

        let arr = await getDistinctParcelsFromData();
        await updateTablePageInfoHeader(arr);

        let table = $('#pao-table-buffer').DataTable();
        table.clear();
        table.rows.add(dgData[activeDataAccordionItem]?.rows).draw();

      } catch (error) {
        doLogException('updateDataTable', error);
      }
    };

    const lookupSubjectParid = (parid) => {
      return subjectParcels?.rows.some((item) => {
        return item[0] === parid;
      });
    };

    const lookupAccordionParid = (id) => {
      return accordionIdList.includes(id);
    };

    const getCountOfAllAddresses = async () => {
      return new Promise((resolve, reject) => {
        let n = 0;
        Object.keys(dgData).forEach((e, i, a) => {
          n += dgData[e].rows.length;
        });
        resolve(n);
      }).catch((error) => doLogException('getCountOfAllAddresses', error));
    };

    const updateDataItemsIncludedState = async (includeSubjectParcelsOn) => {
      return new Promise((resolve, reject) => {
        Object.keys(dgData).forEach((e, i, a) => {
          dgData[e].includeSubjectParcelsOn = includeSubjectParcelsOn;
        });
        resolve(true);
      }).catch((error) => doLogException('getCountOfAllAddresses', error));
    };

    const updateAccordionItemsDescription = (subject_parcels_included) => {
      (async () => {
        try {
          for await (let e of Object.keys(dgData)) {

            let accordion_item = document.getElementById(e);
            if (accordion_item) {

              let item_row_count = 0;

              let buffer_size = dgData[e].bufferSize;

              dgData[e].includeSubjectParcelsOn = subject_parcels_included;

              let subject_count = dgData[e].subjects.parids?.length;

              let unit_type_abbrv = dgData[e].unitTypeAbbrv;

              const { taxParcelTypeList } = dgData[e];
              if (taxParcelTypeList) {
                let a = Object.keys(taxParcelTypeList).forEach((p) => {
                  let r = p.replace(/_/g, ' ');
                  if (taxParcelTypesSelectedString.includes(r)) {

                    item_row_count += taxParcelTypeList[p].parids?.length + taxParcelTypeList[p].subjects?.length;
                    if (!includeSubjectParcelsOn)
                      if (item_row_count > 0)
                        item_row_count -= taxParcelTypeList[p].subjects?.length;
                  }
                });
              }
              accordionItemDescription(accordion_item, item_row_count, buffer_size, unit_type_abbrv);
            }
          }
        } catch (error) {
          doLogException('updateAccordionItemsDescription', error);
        }
      })();
    };

    const updateTaxTypeLabelSums = () => {
      let sums = {};
      if (Object.keys(dgData)?.length > 0) {
        Object.keys(dgData).forEach((e) => {
          const { taxParcelTypeList } = dgData[e];
          Object.keys(taxParcelTypeList).forEach((p) => {
            let r = p.replace(/_/g, ' ');
            if (taxParcelTypesSelectedString.includes(r)) {
              if (dgData[e].taxParcelTypeList[p]) {

                let p_count = dgData[e].taxParcelTypeList[p].parids?.length;
                let s_count = dgData[e].taxParcelTypeList[p].subjects?.length;

                let x = includeSubjectParcelsOn ? p_count + s_count : p_count;

                if (sums[p] > 0) {
                  let y = x + parseInt(sums[p]);
                  sums[p] = parseInt(new Intl.NumberFormat('en-IN').format(y));
                } else {
                  sums[p] = parseInt(new Intl.NumberFormat('en-IN').format(x));
                }
              }
            }
          });
        });

        let pickListItems = document.querySelectorAll('#pao-taxparceltypes-list>calcite-pick-list-item');
        if (pickListItems) {
          Array.from(pickListItems).filter(f => {
            if (!Array.from(sums).includes(f.attributes.value.value.replace(/ /g, '_'))) {
              f.attributes.label.value = f.attributes.value.value;
            }
          });
        }

        if (Object.keys(sums)?.length > 0) {
          Object.keys(sums).forEach((e) => {
            let pickListItems = document.querySelectorAll('#pao-taxparceltypes-list>calcite-pick-list-item');
            if (pickListItems) {
              pickListItems.forEach((item) => {
                let val = item.attributes.value.value; 
                let t = e.replace(/_/g, ' ');
                if (val === t) {
                  if (sums[e]) {
                    let desc = `${val} (${sums[e]})`;
                    item.label = item.value = desc;
                  } else {
                    item.label = val; 
                  }
                }
              });
            }
          });
        }
      }
    };

    const accordionItemDescription = (accordion_item, item_row_count, fixed_buffer_size, unit_type_abbrv) => {
      item_row_count = parseInt(new Intl.NumberFormat('en-IN').format(item_row_count));
      accordion_item.description = `${item_row_count} parcel${item_row_count === 0
        || item_row_count > 1 ? 's' : ''} ${fixed_buffer_size} ${unit_type_abbrv} from subject.`;
    };

    const updateAccordionItemDescription = async () => {
      return new Promise((resolve, reject) => {
        let accordion_item = document.getElementById(activeDataAccordionItem);
        if (accordion_item) {
          let unit_type_abbrv = dgData[activeDataAccordionItem].unitTypeAbbrv;
          let item_row_count = dgData[activeDataAccordionItem]?.rows.length;
          let fixed_buffer_size = fixedBufferSizeScale(bufferSize);
          accordionItemDescription(accordion_item, item_row_count, fixed_buffer_size, unit_type_abbrv);
        }
        resolve(true);

      }).catch((error) => doLogException('updateAccordionItemDescription', error));
    };

    const visibleSubjectParcelsCount = async () => {
      return new Promise((resolve, reject) => {
        let n = 0;
        Object.keys(dgData).forEach((e) => {
          n += dgData[e].subjects.parids.length;
        });
        n = new Intl.NumberFormat('en-IN').format(n);
        resolve(n);
      }).catch((error) => doLogException('visibleSubjectParcelsCount', error));
    };

    function exportToFile(event, file_type, export_item = false) {
      try {
        currentProgressBar = 'progress-export';
        toggleProgressBarVisibility(1);
        totalProgressSteps = 6;
        stepProgressBar();

        let mDate = moment();
        let unitTypeAbbrv = dgData[activeDataAccordionItem].unitTypeAbbrv;
        let report_name_prefix = '';
        if (
          chosenSelectionMethod === ChosenSelectionMethodOptions.ParcelId &&
          accordionIdList?.length === 1
        ) {
          report_name_prefix = chosenMethodValue; 
        } else {
          let ellipse = '';
          if (chosenMethodTextLabel.length > 30) ellipse = '_';

          if (
            chosenSelectionMethod === ChosenSelectionMethodOptions.ParcelId &&
            accordionIdList?.length > 1
          ) {
            report_name_prefix = 'parcels';
          } else {
            report_name_prefix = `${chosenMethodTextLabel
              .toLowerCase()
              .replace(/\s/g, '_')
              .replace('-', '')
              .substring(0, 30)}`;
          }
        }
        let tmp_buffersize = (Math.floor(bufferSize * 100) / 100).toFixed(0);
        let fileName =
          `${report_name_prefix}_${tmp_buffersize}${unitTypeAbbrv}`.replace(
            '.',
            '_'
          );
        let parcelsData = {
          parids: [],
        };
        let distinctParcelsData = {
          parids: [],
          file_name: fileName,
        };

        parcelsData.parids = getParcelsData();

        stepProgressBar();

        distinctParcelsData.parids = [...new Set(parcelsData.parids)];

        if (distinctParcelsData.parids?.length === 0) {
          stepProgressBar(true);
          PaoWarning.showAlert({
            title: 'Nothing to print.',
            message: '',
            scale: 's',
            placement: 'bottom',
            auto_close: true,
            auto_close_speed: PaoAlertAutoDismissSpeed.Fast,
          });
          return;
        }

        if (!(distinctParcelsData.parids.length > 0)) {
          toggleProgressBarVisibility(0);
          return;
        }

        let json = JSON.stringify(distinctParcelsData);

        let p1 = new Promise((resolve) => {
          resolve(exportLabels(json, file_type));
        }).catch((error) => doLogException('exportToFile->p1', error));
        p1.then((result) => {
          stepProgressBar(true);
          PaoSuccess.showAlert({
            title: `Your ${file_type} file was successfully downloaded.`,
            message: `File name: ${fileName}.${file_type.toLowerCase()}`,
            scale: 's',
            placement: 'bottom',
            auto_close: true,
            auto_close_speed: PaoAlertAutoDismissSpeed.Medium,
          });
        });
        p1.catch((error) => {
          stepProgressBar(true);
          doLogException('ExportToFileException', error);
        });
      } catch (error) {
        stepProgressBar(true);
        doLogException('ExportToFileException', error);
      }
    }

    const getDistinctParcelsFromData = async () => {
      let parcelsData = {
        parids: [],
      };
      let tmp = await getParcelsData();
      parcelsData.parids = [...new Set(tmp)];
      return parcelsData;
    };

    const deleteAccordionItem = async (id) => {

      try {
        let node = document.getElementById(id);
        node?.remove();
        if (dgData[activeDataAccordionItem] && getdgDataItemRowsCount() > 0) {
          let deleted_accordion_index = dgData[node.id]?.index;

          delete dgData[node.id];

          let filtered = accordionIdList.filter((val, idx, arr) => {
            return val !== node.id;
          });
          accordionIdList = filtered;

          if (Object.keys(dgData)?.length > 0)
            await moveToAcccordionItem(deleted_accordion_index);
        }
        if (Object.keys(dgData)?.length === 0) {
          resetBufferFilters(0);
        }
        closeModal();
      } catch (error) {
        doLogException('DeleteAccordionItem', error);
      }
    };

    const moveToAcccordionItem = (deleted_accordion_index) => {

      let id = Object.keys(dgData).find(
        (key) => dgData[key].index - 1 > deleted_accordion_index
      );
      if (!id) {
        id = Object.keys(dgData).find(
          (key) => dgData[key].index > deleted_accordion_index
        );
        if (!id) {
          id = Object.keys(dgData).find(
            (key) => deleted_accordion_index > dgData[key].index
          );
        }
      }
      if (id) switchAccordionData(id);
    };

    function toggleProgressBarVisibility(visibility) {
      let progress = document.getElementById(currentProgressBar);
      if (progress) {
        if (visibility === 1) {
          progress.classList.remove('d-none');
        }
        if (visibility === 0) setTimeout(resetProgressBar, 250); 
      }
    }

    function stepProgressBar(toMax = false) {
      if (toMax) toggleProgressBarVisibility(0);
      let progress = document.getElementById(currentProgressBar);
      let step = 0;
      if (progress) {
        if (progress.hasChildNodes()) {
          let children = progress.childNodes;
          children.forEach((child) => {
            let n = child.getAttribute('data-progress');
            step = parseInt(n);
            if (!isNaN(step)) {
              let maxval = child.getAttribute('aria-valuemax');
              if (maxval > step) {
                step += Math.floor(maxval / totalProgressSteps);
                if (toMax) step = maxval;
                child.setAttribute('aria-valuenow', step);
                child.setAttribute('data-progress', step);
                child.style.width = `${step}%`;
                if (toMax) toggleProgressBarVisibility(0);
              }
            } else {
              step = 0;
            }
          });
        }
      }
      return step;
    }

    function resetProgressBar() {
      let progress = document.getElementById(currentProgressBar);
      if (progress) {
        progress.classList.add('d-none');
        if (progress.hasChildNodes()) {
          let children = progress.childNodes;
          children.forEach((child) => {
            child.setAttribute('data-progress', '0');
            child.setAttribute('aria-valuenow', '0');
            child.style.width = '0%';
          });
          currentProgressBar = '';
        }
      }
    }

    const getdgDataItemRowsCount = () => {
      let tmp = 0;
      if (dgData[activeDataAccordionItem]?.rows?.length)
        tmp = dgData[activeDataAccordionItem].rows.length;

      return tmp;
    };

    const updateTablePageInfoHeader = async (distinctParids) => {
      try {
        if (dgData[activeDataAccordionItem]) {

          let distinct_parids_count = distinctParids.parids?.length;

          let max_part = '';
          if (distinct_parids_count >= MAX_QUERY_RECORDCOUNT) {
            let m = new Intl.NumberFormat('en-IN').format(MAX_QUERY_RECORDCOUNT);
            max_part = `Max ${m} subject parcels reached.`;
          }

          distinct_parids_count = new Intl.NumberFormat('en-IN').format(distinct_parids_count);

          let accordion_item = document.getElementById(activeDataAccordionItem);

          if (accordion_item) {

            let item_row_count = dgData[activeDataAccordionItem]?.rows.length;

            let unit_type_abbrv = dgData[activeDataAccordionItem].unitTypeAbbrv;

            let subject_parcel_count = subjectParcels?.rows?.length;

            let fixed_buffer_size = fixedBufferSizeScale(bufferSize);

            let header = document.getElementById('pao-accordion-block');
            if (header?.hasAttribute('heading')) {
              if (max_part?.length > 0) {
                await changeHeadingStyle('pao-accordion-block', '--calcite-ui-danger');
                header.attributes['heading'].value = max_part;
              } else if (header.attributes['heading'].value !== BUFFER_RESULTS_HEADING) {
                await changeHeadingStyle('pao-accordion-block', '--calcite-ui-text-2');
                header.attributes['heading'].value = BUFFER_RESULTS_HEADING;
              }

              let selected_part = '';
              let included_part = '';
              let unique_part = '';
              let included_word_part = '';

              let total_subjects_count = 0;


              selected_part = `Selected ${distinct_parids_count} parcel${distinct_parids_count === 0 || distinct_parids_count > 1 ? 's' : ''
                }`;

              if (includeSubjectParcelsOn) {
                included_word_part = ', including ';
              }

              total_subjects_count = await visibleSubjectParcelsCount();

              if (!includeSubjectParcelsOn) {
                included_word_part = ', excluding ';
              }

              if (included_word_part.length > 0) {
                included_part = `${total_subjects_count} subject propert${total_subjects_count === 0 || total_subjects_count > 1 ? 'ies' : 'y'
                  }`;
              }


              let json = JSON.stringify(distinctParids);

              let queried_parids_count = await distinctAddressCount(json);
              queried_parids_count = new Intl.NumberFormat('en-IN').format(queried_parids_count);
              unique_part = `; ${queried_parids_count} unique mailing address${queried_parids_count > 1 ? 'es' : ''}.`


              let punc1 = '.'; 
              if (included_word_part?.length === 0 && unique_part?.length > 0) {
                punc1 = '';
              }
              if (included_word_part?.length > 0) {
                punc1 = '';
              }
              if (unique_part?.length === 0)
                unique_part = '.';

              header.description = `${selected_part}${punc1}${included_word_part}${included_part}${unique_part}`;
            }
          }
        }
      } catch (error) {
        doLogException('updateTablePageInfoHeader', error);
      }
    };

    function getParcelsData(id) {
      try {
        let tmp = [];
        let total_rows = [];

        if (id?.length > 0 && dgData[id]?.rows?.length > 0) {
          tmp[id] = dgData[id];
        } else {
          tmp = dgData;
        }
        if (tmp) {
          let tmp_subjects = [];
          if (includeSubjectParcelsOn) {
            Object.keys(tmp).forEach((key) => {
              Object.keys(tmp[key].taxParcelTypeList).forEach((p) => {
                let r = p.replace(/_/g, ' ');
                if (taxParcelTypesSelectedString.includes(r)) {
                  tmp[key].taxParcelTypeList[p].subjects.forEach((parid) => {
                    tmp_subjects.push(parid);
                  });
                }
              });
            });
          }

          if (includeSubjectParcelsOn) 
            total_rows = [...new Set(tmp_subjects)];

          Object.keys(tmp).forEach((key) => {
            Object.keys(tmp[key].taxParcelTypeList).forEach((p) => {
              let r = p.replace(/_/g, ' ');
              if (taxParcelTypesSelectedString.includes(r)) {
                tmp[key].taxParcelTypeList[p].parids.forEach(parid => {
                  total_rows.push(parid);
                });
              }
            });
          });
          return total_rows;
        }
        return null;

      } catch (error) {
        doLogException('getParcelsData', error);
      }
    }

    const getBufferControlItemsByMethod = () => {
      let arr = [];
      arr.push('pao-buffer-unit');
      arr.push('pao-buffer-slider');
      arr.push('pao-control-reset');
      arr.push('pao-accordion-block');
      arr.push('pao-buffer-slider-block');
      arr.push('pao-component-container');
      arr.push('pao-subject-parcel-group');
      arr.push('pao-taxparceltypes-block');
      arr.push('pao-subject-parcel-label');
      arr.push('pao-accordion-data-panel');
      arr.push('pao-accordion-data-container');
      arr.push('pao-parcel-export-method-block');
      switch (chosenSelectionMethod) {
        case ChosenSelectionMethodOptions.Condominium:
        case ChosenSelectionMethodOptions.Cooperative:
        case ChosenSelectionMethodOptions.Subdivision:
          break;
        case ChosenSelectionMethodOptions.ParcelId:
          arr.push('pao-parcel-search-go');
          arr.push('pao-parcel-search-input');
          break;
        case ChosenSelectionMethodOptions.Sketch:
          break;
      }
      return arr;
    }

    const getChosenSelectionMethodName = (pluralize = false) => {
      let s = ''; 
      if (pluralize) s = 's';

      switch (chosenSelectionMethod) {
        case ChosenSelectionMethodOptions.Condominium:
          return `Condominium${s}`;
        case ChosenSelectionMethodOptions.Cooperative:
          return `Cooperative${s}`;
        case ChosenSelectionMethodOptions.ParcelId:
          return `ParcelId${s}`;
        case ChosenSelectionMethodOptions.Sketch:
          return `Sketch${s}`;
        case ChosenSelectionMethodOptions.Subdivision:
          return `Subdivision${s}`;
        default:
          return '';
      }
    };

    function updateBufferPolygon(buffer_size) {
      try {
        let geometry = sketchGeometry; 

        const bufferGeometry = geometryEngine.geodesicBuffer(
          geometry,     
          buffer_size,  
          unitType,     
          false         
        );

        if (bufferLayer.graphics?.length === 0) {



          bufferLayer.add(
            new Graphic({
              geometry: bufferGeometry,
              symbol: sketchViewModel.polygonSymbol,
            })
          );
        } else {
          bufferLayer.remove(bufferGeometry);
          bufferLayer.graphics.getItemAt(0).geometry = bufferGeometry;
        }
        view.map.add(bufferLayer);
      } catch (error) {
        console.error(error);
      }
    }

    function clearGeometry() {
      sketchGeometry = null;
      sketchPointGeometry = null;
      sketchViewModel.cancel();
      sketchLayer.removeAll();
      bufferLayer.removeAll();
      view.graphics.removeAll();
      if (!activeAccordionId === '')
        bufferSize = 0;
    }

    function sketchGeometryMode() {
      if (bufferSize === 0)
        if (chosenSelectionMethod === ChosenSelectionMethodOptions.ParcelId)
          return sketchGeometry;

      if (sketchPointGeometry) {
        if (bufferSize) {
          return sketchGeometry;
        } else {
          return sketchPointGeometry;
        }
      } else {
        return sketchGeometry;
      }
    }

    const addrow = (attributes) => {
      let row = [];
      let obj = attributes;


      let _fields = Object.keys(obj)
        .filter((key) => DG_ADDR_COLUMNS.includes(key))
        .reduce((cur, key) => {
          return Object.assign(cur, { [key]: obj[key] });
        }, {});

      row.push(_fields.PARID);
      row.push(_fields.PAR_MAIL_LABEL1);
      row.push(_fields.PAR_MAIL_LABEL2);
      row.push(_fields.PAR_MAIL_LABEL3);
      row.push(_fields.PAR_MAIL_LABEL4);
      row.push(_fields.PAR_MAIL_LABEL5);
      row.push(_fields.PAR_MAIL_LABEL6);
      row.push(_fields.TAXPARCELTYPE);
      return row;
    };

    function queryLayerView() {
      try {
        if (!bufferLayerViewUpdatingFlag && queryFeatureLayer) {
          if (waitingForResults) {
            disableEnableTaxParcelTypesBlock(waitingForResults);
            disableEnableSubjectParcelGroupState(waitingForResults);
          }
          if (!waitingForResults) {
            const queryObject = queryFeatureLayer.createQuery();
            queryObject.geometry = sketchGeometryMode();
            queryObject.units = unitType;
            queryObject.distance = bufferSize;
            queryObject.spatialRelationship = 'intersects';
            queryObject.returnGeometry = true;
            queryObject.outSpatialReference = view.spatialReference;
            queryObject.returnQueryGeometry = true;
            queryObject.outFields = [
              'OBJECTID',
              'PARID',
              'PAR_MAIL_LABEL1',
              'PAR_MAIL_LABEL2',
              'PAR_MAIL_LABEL3',
              'PAR_MAIL_LABEL4',
              'PAR_MAIL_LABEL5',
              'PAR_MAIL_LABEL6',
              'PAR_SUBDIVISION',
              'TAXPARCELTYPE'
            ];
            queryObject.orderByFields = ['TAXPARCELTYPE', 'PAR_SUBDIVISION'];

            let andWhere = '';
            let taxWhere = '';
            let idWhere = '';
            let is_rural = false;

            if (!distanceConstraintSet) {
              if (dgData[activeAccordionId]?.isRural) {
                isRural = dgData[activeAccordionId].isRural;
              } else {
                let centroid = queryObject.geometry?.centroid;
                if (centroid) {
                  let lat = centroid?.latitude;
                  let lng = centroid?.longitude;
                  isRural = isParcelRural(lat, lng);
                }
              }
              toggleDistanceConstraints(isRural);
            }

            if (subjectParSubdivision?.length > 0 && bufferSize === 0) {
              andWhere = `AND ${subjectParSubdivision}`;
            }
            if (taxParcelTypesSelectedString !== '') {
              taxWhere = `TAXPARCELTYPE IN(${taxParcelTypesSelectedString})`.trim();
            } else {
              taxWhere = `TAXPARCELTYPE NOT IN(${taxParcelTypesDefaultString})`.trim();
            }
            if (bufferSize === 0) {
              if (chosenSelectionMethod === ChosenSelectionMethodOptions.ParcelId) {
                idWhere = `AND PARID='${chosenMethodValue}'`
              }
            }
            queryObject.where = `${taxWhere} ${andWhere} ${idWhere}`;

            let bufferSymbolData = [];
            let sub_count = {};
            const typeList = {}
            const typeListObj = {
              parids: [],
              subjects: []
            };

            if (dgData[activeDataAccordionItem]) {
              const { taxParcelTypeList } = dgData[activeDataAccordionItem];
              if (taxParcelTypeList) {
                Object.keys(taxParcelTypeList).forEach((element) => {
                  if (dgData[activeDataAccordionItem].bufferSize > bufferSize || !includeSubjectParcelsOn) {
                    dgData[activeDataAccordionItem].taxParcelTypeList[element].parids = [];
                  }
                  typeList[element] = dgData[activeDataAccordionItem].taxParcelTypeList[element];
                });
              }
            }
            waitingForResults = true;

            queryFeatureLayer
              .queryFeatures(queryObject)
              .then((layerView) => {

                view.graphics.removeAll();
                let newlayerView = layerView;

                if (sketchIdentifyDoneFlag) {
                  let subjectParcels = {
                    cols: [],
                    rows: [],
                  };
                }
                let sketch_subject_rows = [];

                layerView.features.forEach((feature, index, arr) => {
                  let par = feature.attributes.PARID;
                  let p = feature.attributes.PAR_SUBDIVISION;
                  let t = feature.attributes.TAXPARCELTYPE.replace(/\s/g, "_");
                  sub_count[p] = (sub_count[p] || 0) + 1;

                  if (!typeList.hasOwnProperty(t)) {
                    typeList[t] = typeListObj;

                    dgData[activeDataAccordionItem].taxParcelTypeList = typeList;
                  }
                  if (sketchIdentifyDoneFlag)
                    sketch_subject_rows.push(addrow(feature.attributes));

                });

                if (sketchIdentifyDoneFlag)
                  fillSubjectParcelsData(sketch_subject_rows);

                sketchIdentifyDoneFlag = false;

                layerView.features.forEach((feature) => {

                  let par = feature.attributes.PARID;
                  let sub = feature.attributes.PAR_SUBDIVISION;
                  let isSubject = false;

                  if (sketchIdentifyDoneFlag) {
                    isSubject = true;
                  } else {
                    isSubject = lookupSubjectParid(par);
                  }

                  let tax_parcel_type = feature.attributes.TAXPARCELTYPE;
                  let tax_parcel_type_nospace = tax_parcel_type.replace(/\s/g, '_');
                  let symbolColor = '';

                  if (dgData[activeDataAccordionItem].hasOwnProperty('taxParcelTypeList')) {
                    let clone1 = structuredClone(dgData[activeDataAccordionItem].taxParcelTypeList[tax_parcel_type_nospace]);
                    if (clone1) {
                      if (!isSubject) {
                        let parids = clone1.parids;
                        parids.push(par);
                        clone1.parids = [...new Set(parids)];
                      }
                      if (isSubject && !clone1.subjects.includes(par))
                        clone1.subjects.push(par);

                      dgData[activeDataAccordionItem].taxParcelTypeList[tax_parcel_type_nospace] = clone1;
                    }
                  }
                  let skip = isSubject && !includeSubjectParcelsOn;
                  if (skip === false) {
                    if (bufferSymbolData.find((n) => (n.sub === sub) & (n.tax === 'CONDO_UNIT')))
                      if (sub_count[sub] > 1) return; 

                    if (taxParcelTypeColors?.length > 0) {
                      let rgb = taxParcelTypeColors.filter((obj) => {
                        if (obj)
                          if (Object.keys(obj)[0] === tax_parcel_type)
                            return obj[tax_parcel_type];
                      });
                      if (rgb && rgb.length > 0) symbolColor = rgb[0][tax_parcel_type];
                    }
                    let symbolFill = {
                      type: 'simple-fill',
                      outline: {
                        color: lineWhite,
                        width: 1,
                      },
                      color: symbolColor,
                    };
                    let symbol = symbolFill;
                    let g = new Graphic({
                      geometry: feature.geometry,
                      symbol: symbol,
                    });
                    view.graphics.add(g);
                  }
                  bufferSymbolData.push({
                    par: par,
                    sub: sub,
                    tax: tax_parcel_type_nospace
                  });
                });
                if (!blockUpdateDataTable || bufferSize === 0) {
                  updateDataTable(newlayerView)
                    .then(ScrollLastAccordionIntoView)
                    .then(() => {
                      blockUpdateDataTable = false;
                      waitingForResults = false;
                      disableEnableTaxParcelTypesBlock(waitingForResults);
                      disableEnableSubjectParcelGroupState(waitingForResults);
                    })
                    .catch((error) => {
                      doLogException('`queryLayerView`', error);
                    });
                }
                return true;
              })
              .catch((error) => {
                waitingForResults = false;
                if (error.message.indexOf('featureResult') > -1) {
                  setTimeout(() => {
                    queryLayerView();
                    return true;
                  }, 350);
                } else if (error.message.indexOf('taxParcelTypeList') > -1) {
                  return true; 
                } else {
                  console.error(error.message);
                  return true;
                }
              });
          }
        }
      } catch (error) {
        doLogException('queryFeatureLayer', error)
      }
    }

    function getSubjectParidsFromGeometry(subjectWhere) {
      return new Promise((resolve) => {
        let queryObject = new Query({
          geometry: sketchGeometry,
          units: unitType,
          distance: 0,
          spatialRelationship: 'intersects', 
          outSpatialReference: view.spatialReference,
          returnQueryGeometry: true,
          returnDistinctValues: true, 
          orderByFields: ['PARID'],
          outFields: [
            'PARID',
            'PAR_MAIL_LABEL1',
            'PAR_MAIL_LABEL2',
            'PAR_MAIL_LABEL3',
            'PAR_MAIL_LABEL4',
            'PAR_MAIL_LABEL5',
            'PAR_MAIL_LABEL6',
            'TAXPARCELTYPE'
          ],
          where: subjectWhere,
        });
        query
          .executeQueryJSON(parcelSearchUrl, queryObject)
          .then(setConveyanceSubjectData)
          .then(() => {
            resolve(true);
          })
          .catch((error) => {
            doLogException(
              'getSubjectParidsFromGeometry->executeQueryJSON',
              error
            );
            resolve(false);
          });
      }).catch((error) =>
        doLogException('getSubjectParidsFromGeometry', error)
      );
    }

    function getQueriedParidsInSubjectProperty(subjectWhere) {
      return new Promise((resolve) => {
        let queryObject = new Query({
          geometry: sketchGeometry,
          units: unitType,
          distance: 0,
          spatialRelationship: 'intersects', 
          outSpatialReference: view.spatialReference,
          returnQueryGeometry: true,
          returnDistinctValues: true, 
          outFields: ['PARID'],
          where: subjectWhere,
        });
        query
          .executeForCount(parcelSearchUrl, queryObject)
          .then((queryRecordCount) => {
            if (!queryRecordCount) {
              queryRecordCount = 0;
            }
            resolve(queryRecordCount);
          })
          .catch((error) => {
            doLogException(
              'getQueriedParidsInSubjectProperty->executeQueryJSON',
              error
            );
            resolve(false);
          });
      }).catch((error) =>
        doLogException('getQueriedParidsInSubjectProperty', error)
      );
    }

    const applyConveyanceRule = async (unitTypeAbbrv) => {
      return new Promise((resolve) => {
        if (chosenSelectionMethod === ChosenSelectionMethodOptions.ParcelId) {
        } else {
          includeSubjectParcelsOn = true;
        }

        if (dgData[activeDataAccordionItem])
          includeSubjectParcelsOn = dgData[activeDataAccordionItem].includeSubjectParcelsOn;

        let idx = dgData[activeDataAccordionItem] ? dgData[activeDataAccordionItem]?.index : getNextAccordionIndex();

        let accordionItemBufferSize = 0;
        let type_list = {};

        if (dgData[activeDataAccordionItem]) {
          accordionItemBufferSize = dgData[activeDataAccordionItem]?.bufferSize;
          type_list = dgData[activeDataAccordionItem].hasOwnProperty('taxParcelTypeList') ? dgData[activeDataAccordionItem].taxParcelTypeList : {};
        }
        let dgKeyColection = {
          index: idx,
          cols: subjectParcels.cols,
          rows: subjectParcels.rows,
          subjects: subjectParcels.rows,
          taxParcelTypeList: type_list,
          chosenSelectionMethod: chosenSelectionMethod,
          chosenMethodValue: chosenMethodValue,
          unitTypeAbbrv: unitTypeAbbrv,
          includeSubjectParcelsOn: includeSubjectParcelsOn,
          bufferSize: accordionItemBufferSize,
          isRural: isRural
        };
        loadAccordionDataTable(dgKeyColection);

        if (bufferSize > 0)
          updateBufferPolygon(bufferSize);

        let table = $('#pao-table-buffer').DataTable();
        table.clear();
        table.rows.add(dgData[activeDataAccordionItem].rows);

        toggleSubjectParcelsRadioGroup();
        setZoomConstraints();

        resolve(true);
      }).catch((error) => {
        doLogException('applyConveyanceRule', error);
        resolve(false);
      });
    };

    const getNextAccordionIndex = () => {
      if (Object.keys(dgData)?.length === 0) return 0;
      const max = Math.max(...Object.keys(dgData).map((x) => dgData[x].index));
      return max + 1;
    };

    const setConveyanceSubjectData = (featureSet) => {
      return new Promise((resolve) => {
        const data = featureSet.features;
        let result = {
          cols: [],
          rows: [],
        };
        let columns = featureSet.fields.filter((field) => {
          switch (field.name.toUpperCase()) {
            case 'PARID':
            case 'PAR_MAIL_LABEL1':
            case 'PAR_MAIL_LABEL2':
            case 'PAR_MAIL_LABEL3':
            case 'PAR_MAIL_LABEL4':
            case 'PAR_MAIL_LABEL5':
            case 'PAR_MAIL_LABEL6':
            case 'TAXPARCELTYPE':
              return field.name;
            default:
              return false;
          }
        });
        result.cols = columns;
        data.map((feature, i) => {
          let row = [];
          return Object.entries(feature.attributes).forEach((entry) => {
            switch (entry[0].toUpperCase()) {
              case 'PARID':
              case 'PAR_MAIL_LABEL1':
              case 'PAR_MAIL_LABEL2':
              case 'PAR_MAIL_LABEL3':
              case 'PAR_MAIL_LABEL4':
              case 'PAR_MAIL_LABEL5':
              case 'PAR_MAIL_LABEL6':
              case 'TAXPARCELTYPE':
                const [key, value] = entry;
                row.push(value);
                result.rows[i] = row;
                return result;
              default:
            }
          });
        });
        fillSubjectParcelsData(result.rows);
        resolve(featureSet);
      }).catch((error) => { doLogException('setConveyanceSubjectData', error); });
    };

    let debouncedRunQuery = promiseUtils.debounce(function () {
      if (!sketchGeometry) return;
      updateBufferPolygon(bufferSize);
      if (bufferSize === 0) {
        view.graphics.removeAll();
        clearDataTable();
        updateBufferPolygon(bufferSize);
        const handle = setInterval(() => {
          if (!bufferLayerViewUpdatingFlag) {
            clearInterval(handle);
            queryLayerView();
          }
        }, 1000);
        return;
      }
      return promiseUtils.eachAlways([queryLayerView()]);
    });

    function runQuery() {
      debouncedRunQuery().catch((error) => {
        if (error.name === 'AbortError') return;
      });
    }

    const delay = (ms) => {
      return new Promise((resolve) => setTimeout(resolve, ms));
    };

    const styleAccordionItem = async () => {
      try {
        await customElements.whenDefined('calcite-accordion-item');
        await delay(250);
        if (activeDataAccordionItem?.length > 0) {
          let node = document.querySelector(`#${activeDataAccordionItem}`);
          if (node) {
            let el = node.shadowRoot.querySelector('.header');
            if (el) {
              el.style.setProperty('background-color', 'rgb(27, 54, 93)');
              el.style.setProperty('border', '1px solid rgb(23, 134, 180)');
              el.style.setProperty('margin-bottom', '2px');
            }
            el = node.shadowRoot.querySelector('.heading');
            if (el) el.style.setProperty('color', 'var(--calcite-ui-warning)');

            el = node.shadowRoot.querySelector('.description');
            if (el)
              el.style.setProperty('color', 'rgb(255, 255, 255)');
          }
        }
      } catch (error) {
        doLogException('styleAccordionItem', error);
      }
    };

    const removeButtonOutline = async (id) => {
      await customElements.whenDefined('calcite-block');
      await delay(200);
      let node = document.querySelector(`#${id}`);
      if (node) {
        let el = node.shadowRoot.querySelector('.header-container>button');
        if (el) {
          el.style.setProperty('outline', 'none');

          el = node.shadowRoot.querySelector('.header-container>button.toggle');
          if (el)
            el.style.setProperty('background-color', 'var(--calcite-ui-foreground-1)');
        }
      }
    };

    const changeHeadingStyle = async (id, color_var) => {
      await customElements.whenDefined('calcite-block');
      await delay(200);
      let node = document.querySelector(`#${id}`);
      if (node) {
        let el = node.shadowRoot.querySelector('.heading');
        if (el) {
          el.style.setProperty('color', `var(${color_var})`);
        }
      }
    };


    const removeAllButtonOutline = async () => {
      await customElements.whenDefined('calcite-block');
      await delay(200);
      let nodes = document.querySelectorAll('calcite-block');
      if (nodes) {
        nodes.forEach((p) => {
          let el = p.shadowRoot.querySelector('.header-container>button');
          if (el)
            el.style.setProperty('outline', 'none');
        });
      }
    };


    function bufferValueChanged(event) {
      let el = document.getElementById('pao-buffer-slider');
      if (el) {
        if (el.hasAttribute('disabled')) {
          el.value = bufferSize;
          return;
        }
        if (!el.hasAttribute('disabled')) {
          bufferSize = event.target.value;
          bufferSize = fixedBufferSizeScale(bufferSize);
          if (bufferLayerViewUpdatingFlag === false) {
            if (bufferSize === dgData[activeDataAccordionItem].bufferSize) {
              updateBufferPolygon(bufferSize);
              return;
            }
            runQuery();
          }
        }
      }
    }

    function setBlockDescription(block_id, block_state, block_description) {
      if (block_state)
        document.getElementById(block_id).setAttribute('description', ' ');
      if (!block_state)
        document
          .getElementById(block_id)
          .setAttribute('description', block_description);
    }

    function setupTableBuffer() {
      return new Promise((resolve) => {

        let data = { cols: [], rows: [] };

        if (Object.keys(dgData)?.length > 0) {
          if (dgData[activeDataAccordionItem])
            data = dgData[activeDataAccordionItem];
        }

        let dtClass = 'display compact table table-bordered table-striped table-hover trans-font';

        $('#pao-datatable').remove();

        let table = document.createElement('table');
        table.setAttribute('id', 'pao-table-buffer');
        table.setAttribute('class', dtClass);
        table.setAttribute('cellspacing', '0');
        table.style.width = '100%';

        let scrollObj = true;

        if (detectMobileDevice()) {
          scrollObj = false;
          responsiveObj = {
            details: {
              type: 'inline',
              display: $.fn.dataTable.Responsive.display.childRowImmediate,
            },
          };
        }

        let dvData = document.createElement('div');
        dvData.setAttribute('id', 'pao-datatable');
        dvData.appendChild(table);

        let accordion = document.getElementById('pao-accordion-data-container');
        if (accordion) {
          let heading_value; 
          if (chosenSelectionMethod === ChosenSelectionMethodOptions.ParcelId) {
            heading_value = `Parcel ${chosenMethodValue}`;
          } else {
            heading_value = chosenMethodTextLabel;
          }

          let accordion_item = document.getElementById(activeDataAccordionItem);
          if (accordion_item) {
            accordion_item.appendChild(dvData);

          } else {
            accordionIdList.push(activeDataAccordionItem);

            let items = document.querySelectorAll('calcite-accordion-item');
            items.forEach((attr) => {
              attr.removeAttribute('expanded');
            });
            accordion_item = document.createElement('calcite-accordion-item');
            accordion_item.setAttribute('id', `${activeDataAccordionItem}`);
            accordion_item.setAttribute('heading', heading_value);
            accordion_item.setAttribute('description', ' ');
            accordion_item.setAttribute('expanded', '');
            accordion_item.addEventListener('click', accordionItemClicked);


            let toolbarTrash = buildToolbarItemTrash();
            if (toolbarTrash) accordion_item.appendChild(toolbarTrash);

            accordion_item.appendChild(dvData);
            accordion.appendChild(accordion_item);
          }
        }

        if (detectMobileDevice())
          $('#pao-table-buffer').removeAttr('width').addClass('dt-responsive');

        $('#pao-table-buffer').DataTable({
          data: data.rows,
          columns: data.cols,
          serverSide: false, 
          destroy: true,
          autoWidth: false, 
          fixedColumns: false,
          deferRender: true,



          colReorder: {
            enable: false,
          },
          ordering: true,
          order: [[1, 'asc']], 
          language: {
            emptyTable:
              '<span style="color:#6699cc;font-size:1rem;font-weight:500"><i class="fal fa-wine-glass"></i> No Data</span>',
          },
          columns: [null, null],
          columnDefs: [
            {
              targets: 0,
              orderable: true,
              width: '1%',
              title: '',
              data: null,
              createdCell: function (cell, cellData, rowData, rowIndex, colIndex) {

                let sp = lookupSubjectParid(rowData[0]);

                let r = rowData[7]; 
                let rgba = '';
                taxParcelTypeColors.find((obj) => {
                  if (obj)
                    if (Object.keys(obj)[0] === r) {
                      rgba = obj[r].replace(/0.4/g, '0.7');
                    }
                })

                let span = document.createElement('span');
                span.style.display = 'block';
                span.style.height = '15px';
                span.style.width = '15px';
                span.style.borderRadius = '50%';
                span.style.backgroundColor = rgba;
                span.style.border = sp ? '3px solid rgb(27, 54, 93)' : `1px solid ${rgba}`;
                $(cell).children('a').append(span);

              },
              render: function (data, type, row, meta) {
                let sp = lookupSubjectParid(data[0]);
                if (type === 'type' || type === 'sort') if (sp) return meta.row; 
                return `<a href="/parcel/?parid=${data[0]}" 
                                     target="_blank" data-toggle="tooltip" 
                                     title="Click to open${sp ? ' subject' : ''
                  } parcel ${data[0]} in a new tab." 
                                     aria-label="Click to open${sp ? ' subject' : ''
                  } parcel ${data[0]} in a new tab."></a>`;
              },
            },
            {
              targets: 1,
              orderable: true,
              className: 'text-top',
              width: '10%',
              title: 'Parcel Id',
              render: function (data, type, row, meta) {

                let sp = lookupSubjectParid(data[0]);
                return `<a href="/parcel/?parid=${row[0]}" 
                                     target="_blank" data-toggle="tooltip" 
                                     title="Click to open${sp ? ' subject' : ''
                  } parcel ${row[0]} in a new tab." 
                                     aria-label="Click to open${sp ? ' subject' : ''
                  } parcel ${row[0]} in a new tab.">${row[0]}</a>`;

              },
            },
            {
              targets: 2,
              orderable: true,
              className: 'text-top',
              width: 'auto',
              title: 'Address',
              render: function (data, type, row, meta) {
                let adr = '';
                if (row[1] !== null) adr = row[1];
                if (row[2] !== null) adr += ' ' + row[2];
                if (row[3] !== null) adr += ' ' + row[3];
                if (row[4] !== null) adr += ' ' + row[4];
                if (row[5] !== null) adr += ' ' + row[5];
                if (row[6] !== null) adr += ' ' + row[6];
                return adr;
              },
            },
          ],
          rowCallback: function (row, data, displayNum, displayIndex, dataIndex) {
          },
          info: false,
          scrollX: scrollObj,
          scrollY: function () {
            return ($(window).height() * 3.05) / 100 + 'vh';
          },
          scrollCollapse: true,


          paging: false, 
          lengthChange: false, 


          searching: false,
          processing: true,
          stateSave: true,    
          stateDuration: -1,  
        });

        let dt = $('#pao-table-buffer').DataTable();

        dt.columns.adjust().responsive.recalc().draw();

        $('#pao-table-buffer_wrapper .dataTables_scrollBody').css({
          'max-height': '285px',
        });

        setupDataTableFlag = true;
        resolve(true);
      }).catch((error) => { doLogException('DataTable', error); });
    }

    function accordionItemClicked(event) {
      let target = event.currentTarget;
      distanceConstraintSet = false;
      if (target.id != activeDataAccordionItem) switchAccordionData(target.id);
    }

    const ScrollLastAccordionIntoView = () => {
      return; 
      if (Object.keys(dgData)?.length === 1) return;

      let el = document.getElementById('pao-buffer-container');
      el.scrollTo({
        top: el.scrollHeight,
        behavior: 'auto',
      });

    };

    function switchAccordionData(id) {
      activeAccordionId = id; 


      if (dgData[id]) {
        bufferSize = dgData[id].bufferSize;
        queryChosenSelectionMethod(
          dgData[id].chosenSelectionMethod,
          dgData[id].chosenMethodValue,
          dgData[id].bufferSize
        );
      }

      let accordion_item = document.getElementById(activeAccordionId);
      if (accordion_item) accordion_item.setAttribute('expanded', '');
    }

    function resetTaxParcelTypesBlock() {
      document.querySelector('#pao-taxparceltypes-block').removeAttribute('open');
    }

    function toggleAccordionBlockDescription() {
      let block = document.getElementById('pao-accordion-block');
      if (block)
        if (!block.open) block.setAttribute('description', 'Click to open');
        else block.removeAttribute('description');
    }

    const loadAccordionDataTable = (dgKeyColection) => {

      let subjects = {
        parids: []
      };

      subjectParcels.rows.forEach((val) => {
        subjects.parids.push(val[0]);
      });

      dgData[activeDataAccordionItem] = {
        index: dgKeyColection.index,
        cols: dgKeyColection.cols,
        rows: dgKeyColection.rows,
        subjects: subjects,
        taxParcelTypeList: dgKeyColection.taxParcelTypeList,
        chosenSelectionMethod: dgKeyColection.chosenSelectionMethod,
        chosenMethodValue: dgKeyColection.chosenMethodValue,
        unitTypeAbbrv: dgKeyColection.unitTypeAbbrv,
        includeSubjectParcelsOn: dgKeyColection.includeSubjectParcelsOn,
        bufferSize: dgKeyColection.bufferSize,
        isRural: dgKeyColection.isRural
      };

      let bufferSize_total = 0;
      Object.keys(dgData).forEach((e, i, a) => {
        bufferSize_total += dgData[e].bufferSize;
      });

      bufferSize_total > 0 ? document.getElementById('pao-buffer-unit').setAttribute('disabled', '')
        : document.getElementById('pao-buffer-unit').removeAttribute('disabled');

      if (Object.keys(dgData)?.length > 0) {
        updateAccordionItemsDescription(includeSubjectParcelsOn);
        updateTaxTypeLabelSums();
      }
    };

    const fillSubjectParcelsData = (rows) => {
      subjectParcels = {
        cols: DG_ADDR_COLUMNS,
        rows: rows,
      };
    };

    function buildAccordionContainer() {
      return new Promise((resolve, reject) => {
        let block = document.getElementById('pao-accordion-block');
        if (block) {
          let container = document.getElementById(
            'pao-accordion-data-container'
          );
          if (!container) {
            document.getElementById('pao-accordion-label').hidden = true;

            let accordion = document.createElement('calcite-accordion');
            accordion.setAttribute('id', 'pao-accordion-data-container');
            accordion.setAttribute('selection-mode', 'single');
            accordion.classList.add('accordion');

            let toolbar = buildToolbar();
            if (toolbar) accordion.appendChild(toolbar);

            block.appendChild(accordion);

            let scrollto = document.createElement('div');
            scrollto.setAttribute('id', 'pao-scrollto-bottom');
            scrollto.classList.add('d-none');
            block.appendChild(scrollto);
          }
          styleAccordionItem();
          setupTableBuffer().then(() => {
            resolve(true);
          });
        }
      }).catch((error) => {
        doLogException('buildAccordionContainer', error);
        resolve(false);
      });
    }

    function setupDataTable() {
      return new Promise((resolve, reject) => {
        let flx = document.createElement('div');
        let progress = document.createElement('div');
        progress.setAttribute('class', 'progress d-none');
        progress.setAttribute('id', 'progress-export');
        progress.style.height = '4px';

        let progressbar = document.createElement('progress-bar');
        progressbar.setAttribute('class', 'progress-bar');
        progressbar.setAttribute('role', 'progressbar');
        progressbar.setAttribute('data-progress', '0');
        progressbar.setAttribute('aria-valuenow', '0');
        progressbar.setAttribute('aria-valuemin', '0');
        progressbar.setAttribute('aria-valuemax', '100');
        progressbar.style.width = '0%';

        progress.appendChild(progressbar);
        flx.appendChild(progress);

        let panel = document.createElement('calcite-panel');
        panel.setAttribute('id', 'pao-accordion-data-panel');
        panel.setAttribute('height-scale', '1');

        let block = document.createElement('calcite-block');
        block.setAttribute('id', 'pao-accordion-block');
        block.setAttribute('heading', BUFFER_RESULTS_HEADING);
        block.setAttribute('description', ''); 
        block.setAttribute('open', '');
        block.style.scrollbarGutter = 'stable';
        block.addEventListener(
          'calciteBlockToggle',
          toggleAccordionBlockDescription
        );
        block.appendChild(flx);

        let label = document.createElement('div');
        label.setAttribute('id', 'pao-accordion-label');
        label.setAttribute('alignment', 'center');
        label.style.width = '100%';
        label.style.textAlign = 'center';
        label.style.backgroundColor = 'rgba(214,246,239,0.5)';
        label.innerHTML = `${accordionLabelText()}`;
        block.appendChild(label);

        let slot = document.createElement('calcite-icon');
        slot.setAttribute('scale', 's');
        slot.setAttribute('slot', 'icon');
        slot.setAttribute('icon', 'console');
        block.appendChild(slot);
        panel.appendChild(block);

        let container = document.getElementById('pao-buffer-container');
        if (container) container.appendChild(panel);
      })
        .then(() => {
          resolve(true);
        }).catch((error) => { doLogException('setupDataTable', error); });
    } 

    const queryFeatureSet = (parid) => {
      return new Promise((resolve) => {
        let queryObject = new Query({
          returnGeometry: true,
          outSpatialReference: view.spatialReference,
          outFields: [paoDetails.gis.queryFields],
          orderByFields: ['PARID'],
          where: `PARID='${parid}'`,
        });
        query
          .executeQueryJSON(parcelSearchUrl, queryObject)
          .then(setParcelFeatures)
          .then(() => {
            doCursor('auto');
            resolve(true);
          })
        ['catch'](promiseRejected);
      }).catch((error) => {
        resolve(true);
      });
    };

    function setParcelFeatures(featureSet) {
      return new Promise((resolve) => {
        if (paoDetails.gis.ownerSwitched || paoDetails.gis.displayPage !== 'fullaerial') {
          if (!featureSet?.features.length > 0) {
            view.goTo({
              target: view.extent,
              zoom: 12
            }, animationOptions);

            let content =
              "<div><div class='pao-esri-pop-content-not-found'>Aerial Not Found</div><div class='pao-esri-pop-sub-content-not-found'>An aerial for this parcel was not found, or is not currently available.</div><div>";
            closeVisiblePopup();

            let cls = view.popup?.container?.className;
            if (cls)
              view.popup.container.className = cls + ' map-not-found-popup';

            view.popup.dockOptions.buttonEnabled = false;


            view.openPopup({
              title: `<span class='pao-esri-pop-title-not-found pao-blue'>Parcel Id: ${global_parid}</span>`,
              location: view.center,
              content: content,
            });
            resolve(true);

          } else {
            view.graphics.removeAll();
            featureSet.features.forEach((feature) => {
              current_parcel_feature = feature;
              goto_target_params.target = feature.geometry;
              goto_target_params.scale = null;
              goto_target_params.center = null;

              doViewGoto(feature)
                .then(() => {
                  addGraphics(feature, symbolLineAcqua);
                  resolve(true);
                })
            });
          }
        } else {
          resolve(true);
        }
      }).catch((error) => {
        resolve(true);
      });
    }

    const addGraphicModeSketchGeometry = async (featureSet) => {
      try {
        return await new Promise((resolve) => {
          clearGeometry();
          if (featureSet?.features[0]) {
            doViewGoto(featureSet.features[0])
              .then(() => {
                addGraphics(featureSet.features[0], symbolLineAcqua);
                sketchGeometry = featureSet.features[0].geometry;
                resolve(featureSet);
              })
          }
        });
      } catch (error) {
        doLogException('addGraphicModeSketchGeometry', error);
        return false;
      }
    };

    function addGraphics(feature, symbol) {
      try {
        let g = new Graphic({
          geometry: feature.geometry,
          attributes: feature.attributes,
          symbol: symbol,
        });
        view.graphics.add(g);
      } catch (error) { doLogException('addGraphics', error); }
    }

    function doViewGoto(feature) {
      return new Promise((resolve) => {
        try {

          let skipZoom = Object.keys(dgData)?.length > 0;

          let zoom = view.zoom;
          let center = [feature.geometry.centroid.longitude, feature.geometry.centroid.latitude];

          if (activeWidget?.buttonId === 'bufferButton') {
            let expand_extent_size = 1.75;

            switch (chosenSelectionMethod) {
              case ChosenSelectionMethodOptions.ParcelId:
                zoom = paoDetails.gis.zoomLevelParcelId + 2;
                break;
              case ChosenSelectionMethodOptions.Condominium:
              case ChosenSelectionMethodOptions.Cooperative:
              case ChosenSelectionMethodOptions.Subdivision:
                goto_target_params.zoom = view.zoom;
                goto_target_params.scale = view.scale;
                zoom = paoDetails.gis.zoomLevelConveyanceType + 1;
                if (queried_parids_in_subject_property < 10)
                  zoom = zoom + 1;
                if (queried_parids_in_subject_property > 300)
                  zoom = zoom - 1;
                break;
              default:
                zoom = paoDetails.gis.zoomLevelDefault;
            }

            if (Object.keys(dgData)?.length > 0) {
              expand_extent_size = 0;
            }
            let extent = feature.geometry.extent;
            let clone_extent = extent.clone();

            view.goTo({
              target: feature.geometry.extent,
              extent: clone_extent.expand(expand_extent_size),
              center: [center],
              zoom: !skipZoom ? zoom : view.zoom
            }, animationOptions)
              .then(() => {
                resolve(true);
              });

          } else {

            if (paoDetails.gis.ownerSwitched) {

              view.goTo({
                target: feature.geometry.extent,
                scale: goto_target_params.scale
              }, animationOptions)
                .then(() => {
                  resolve(true);
                });

            } else {

              view.goTo({
                target: goto_target_params.target,
                scale: goto_target_params.scale
              }, animationOptions)
                .then(() => {
                  goto_target_params.scale = view.scale;
                  goto_target_params.center = view.center;
                  resolve(true);
                });
            }
          }
        } catch (error) {
          console.error('doViewGoto: ' + error);
          resolve(true);
        }
      }).catch((error) => {
        console.error('doViewGoto: ' + error)
        resolve(true);
      });
    }

    function addQueryBuffer() {
      return new Promise((resolve) => {
        mapLayerAndLabels.load().then(() => {
          view.whenLayerView(queryFeatureLayer).then((layerView) => {
            try {
              layerView.layer.capabilities.query.supportsQueryGeometry = true;
              MAX_QUERY_RECORDCOUNT = layerView.layer.capabilities.query?.maxRecordCount;

              bufferLayerViewUpdatingFlag = true;

              reactiveUtils
                .whenOnce(() => !layerView.updating)
                .then(() => {
                  if (bufferLayerViewUpdatingFlag) {

                    bufferLayerViewUpdatingFlag = false;
                    if (chosenSelectionMethod !== ChosenSelectionMethodOptions.Sketch) {
                      queryLayerView();
                      return true;
                    }
                  }
                })
                .then(() => {
                  resolve(true);
                });

            } catch (error) {
              doLogException('view.whenLayerView', error);
              resolve(true);
            }
          });
        });
      }).catch((error) => doLogException('addQueryBuffer', error));
    }

    function addQueryFeatureLayer() {
      return new Promise((resolve) => {
        if (queryFeatureLayer) {
          map.add(queryFeatureLayer);
          resolve(true);
        }
      }).catch((error) => { doLogException('addQueryFeatureLayer', error); });

    }


    function promiseRejected(error) {
      doLogException('Promise rejected', error);
      return false;
    }

    const setUpGraphicClickHandler = async () => {
      view.on('click', (event) => {
        if (activeWidget?.state === 'active' && activeWidget?.buttonId !== 'bufferButton')
          return;
        executeIdentifyTask(event);
      });
    };

    function userAlert() {
      let ac = document.getElementsByClassName('alert-container');
      if (ac.length === 0) {
        alertContainer.setAttribute('class', 'alert-container');
      }
      let alertDiv = document.createElement('div');
      alertDiv.style.opacity = 1;

      let button = document.createElement('button');
      button.setAttribute('type', 'button');
      button.setAttribute('class', 'close');
      button.setAttribute('data-dismiss', 'alert');

      let span = document.createElement('span');
      span.setAttribute('aria-hidden', 'true');
      span.innerHTML = '&times;';
      button.appendChild(span);

      span = document.createElement('span');
      span.setAttribute('class', 'sr-only');
      span.innerHTML = 'Close';
      button.appendChild(span);

      alertDiv.appendChild(button);

      switch (alertUser) {
        case AlertMessageOptions.AerialImageryNotAvailable:
          alertDiv.setAttribute(
            'class',
            'tab-alert alert-no-imagery alert alert-danger alert-dismissible fade in'
          );
          break;
        case AlertMessageOptions.MapLayersNotAvailable:
          alertDiv.setAttribute(
            'class',
            'tab-alert alert-no-layers alert alert-info alert-dismissible fade in'
          );
          break;
        case AlertMessageOptions.Default:
          return;
      }
      alertContainer.appendChild(alertDiv);
      if (ac.length === 0) {
        mapEl.appendChild(alertContainer);
      }
    }

    function executeIdentifyTask(event) {

      let doTask = function doTask(response) {
        let results = response.results; 

        paoDetails.context.sqft = 0;

        sortMineral(results);


        let paoPopupTemplate = new PaoPopupTemplate();

        paoPopupTemplate.contentType = 'default';

        paoPopupTemplate.IsGoToParcel = true;

        if (activeWidget?.buttonId === 'bufferButton') {
          if (chosenSelectionMethod === ChosenSelectionMethodOptions.None || chosenSelectionMethod === ChosenSelectionMethodOptions.ParcelId) {
            paoPopupTemplate.IsGoToBufferParcel = true;
          }
        }

        paoPopupTemplate.resultCount = results.length;
        let popupTemplate = paoPopupTemplate.template();

        try {

          if (paoDetails.gis.displayPage === 'fullaerial') {
            return results.map((result) => {
              let feature = result.feature;
              let layerName = result.layerName;
              feature.attributes.layerName = layerName;
              feature.popupTemplate = popupTemplate;
              if (result.feature.attributes.LAND_SQFT_CAMA) {
                paoDetails.context.sqft =
                  result.feature.attributes.LAND_SQFT_CAMA;
              }
              return feature;
            });

          } else {

            return results.map((result) => {
              let feature = result.feature;
              let layerName = result.layerName;
              feature.attributes.layerName = layerName;
              if (results.length && results.length > 1)
                feature.popupTemplate = popupTemplate;
              if (result.feature.attributes.LAND_SQFT_CAMA) {
                paoDetails.context.sqft =
                  result.feature.attributes.LAND_SQFT_CAMA;
              }
              return feature;
            });
          }
        } catch (error) {
          console.error(error);
        }
      };

      let showInfo = (featureSet) => {
        try {
          if (paoDetails.gis.displayPage === 'fullaerial') {
            if (featureSet && featureSet.length > 0) {
              showPopup(featureSet, event.mapPoint);
            }
          } else {
            if (featureSet && featureSet.length > 1) {
              showPopup(featureSet, event.mapPoint);
            } else {
              if (featureSet && featureSet[0]) {
                let item = featureSet[0];
                global_parid = item.attributes.PARID;
                queryGeometry();
              }
            } 
          } 
          doCursor('auto');
        } catch (error) {
          doCursor('auto');
          doLogException('showInfo', error);
        } 
      };

      let showPopup = async (featureSet, mapPoint) => {
        let parid = featureSet[0].attributes.PARID;

        await queryFeatureSet(parid);
        closeVisiblePopup();

        view.openPopup({
          features: featureSet,
          location: mapPoint   
        });
      };

      identifyParams.geometry = event.mapPoint;
      identifyParams.mapExtent = view.extent;

      let coords = {
        lat: event.mapPoint.latitude,
        lon: event.mapPoint.longitude,
      };

      paoDetails.context.datums.usesDefaults = false;
      paoDetails.context.datums.coordinates = coords;

      identify
        .identify(mapLayerAndLabelsUrl, identifyParams)
        .then(doTask)
        .then(showInfo)
      ['catch'](promiseRejected);
    }

    const doSwitchOwner = async () => {
      updateView({ showViewHeaderTitle: false });
      switchOwner(global_parid, chosenMapLayers, chosenPriorYearMapLayer, chosenStormLayerIndex);
      paoDetails.gis.ownerSwitched = false;
      return true;
    };

    const handleFullscreenButton = (event) => {
      return new Promise((resolve) => {
        let btn = document.getElementById('fullscreenButton');
        if (btn !== null) {
          let minmax = 'Minimize';
          let set_atts = false;

          if (btn.classList.contains('esri-icon-zoom-in-fixed')) {

            minmax = 'Maximize';
            btn.classList.remove('esri-icon-zoom-in-fixed');
            btn.classList.remove('active');
            btn.classList.add('esri-icon-zoom-out-fixed');
            set_atts = true;

          } else if (btn.classList.contains('esri-icon-zoom-out-fixed')) {

            if (paoDetails.gis.displayPage === 'details')
              return;

            btn.classList.remove('esri-icon-zoom-out-fixed');
            btn.classList.add('esri-icon-zoom-in-fixed');
            btn.classList.add('active');
            set_atts = true;
          }
          if (set_atts) {
            btn.setAttribute('title', minmax + ' aerial map (esc)');
            btn.setAttribute('aria-label', minmax + ' aerial map (esc)');
          }
        }
        resolve(true);
      }).catch((error) => doLogException('handleFullscreenButton', error));
    };

    const queryGeometryToNewWindow = async (parid) => {
      window.open(`${window.location.origin}/parcel/?parid=${parid}`, '_blank');
    };

    const queryGeometry = async () => {
      let queryObject = new Query({
        returnGeometry: true,
        outFields: ['*'],
        outSpatialReference: view.spatialReference,
        orderByFields: ['PARID'],
        where: `PARID='${global_parid}'`,
      });
      query
        .executeQueryJSON(parcelSearchUrl, queryObject)
        .then(await setParcelFeatures) 
        .then(await doSwitchOwner)
        .then(await updateView({ showViewHeaderTitle: false }))
        .then(await handleFullscreenButton)
        .then(doCursor('auto'))
      ['catch'](promiseRejected);
    };

    function layerListFormat(item) {
      let aerials = item.layer.parent.allLayers.filter((a) => {
        try {
          return a.title === 'Aerials';
        } catch (error) {
          console.error('aerials: ' + error);
        }
      });
      let maplayers = item.layer.parent.allLayers.filter((a) => {
        try {
          return (
            a.title === 'Map Layers & Labels' ||
            a.title === 'Districts & PLSS Layers'
          );
        } catch (error) {
          console.error('maplayers: ' + error);
        }
      });
      LayerListAdjustBasemapFont(aerials, maplayers);
      return true;
    }

    const trackVisibleMapLayers = () => {
      chosenMapLayers = [];
      map.layers.forEach((layer, index) => {
        if (layer.visible) chosenMapLayers.push(index);
      });
    };

    function LayerListAdjustBasemapFont(aerials, maplayers) {
      if (maplayers) {
        if (maplayers.length > 0) {
          if (maplayers.items[0].sublayers !== null) {
            if (maplayers.items[0].sublayers.items) {
              var black = maplayers.items[0].sublayers.items.filter((a) => {
                try {
                  return a.id === 3; 
                } catch (error) {
                  console.error('black: ' + error);
                }
              });
            }
            if (maplayers.items[0].sublayers.items) {
              var yellow = maplayers.items[0].sublayers.items.filter((a) => {
                try {
                  return a.id === 2; 
                } catch (error) {
                  console.error('yellow: ' + error);
                }
              });
            }
            if (black && black.length > 0 && yellow && yellow.length > 0) {
              if (aerials && aerials.length > 0) {
                black[0].visible = aerials.items[0].visible === false; 
                yellow[0].visible = aerials.items[0].visible === true; 
              } else {
                black[0].visible = true;
                yellow[0].visible = false;
              }
              black[0].listMode = black[0].visible ? 'show' : 'hide'; 
              yellow[0].listMode = yellow[0].visible ? 'show' : 'hide';
            }
          }
        }
      }
    } 

    const mapReady = async () => {

      addlayerListExpand();
      await setUpGraphicClickHandler();

      printExpand = addPrintWidget();

      primaryPanel = document.getElementById('pao-shell-panel-start');

      let el = document.getElementById('pao-parcel-export-method-block');
      if (!el) {
        buildBufferExportTool()
          .then(buildComponentContainer)
          .then(buildTaxParcelTypesComponent)
          .then(buildBufferSliderComponent)
          .then(buildBufferFooter)
          .then(determineResetActionState)
        ['catch'](promiseRejected);
      }

      if (global_parid?.length > 1) {
        queryFeatureSet(global_parid);
      }

      identifyParams = new IdentifyParameters();
      identifyParams.tolerance = 0.1;
      identifyParams.layerIds = [parcelSearchUrl];
      identifyParams.layerOption = 'top'; 

      reactiveUtils.on(
        () => view.popup,
        'visible',
        (event) => {
          let nomap = document.getElementsByClassName('map-not-found-popup');
          if (event) {
            if (nomap && nomap.length > 0) {
              let matches = document.getElementsByClassName(
                'esri-popup__pointer'
              );
              for (let i = 0; i < matches.length; i++) {
                matches[i].classList.add('d-none');
              }
            }
            closeExpanderWidgets(); 
          } else {
            if (nomap && nomap.length > 0) {
              closeVisiblePopup();
            }
          }
        });


      reactiveUtils.on(() => view.popup,
        'trigger-action',
        async (event) => {
          global_parid = view.popup.selectedFeature.attributes.PARID;
          paoDetails.context.parid = paoDetails.context.datums.parid = global_parid;

          if (paoDetails.gis.displayPage === 'fullaerial') closeVisiblePopup();


          switch (event.action.id) {
            case 'goto-parcel':
              await gotoParcelWorkflow();
              break;

            case 'goto-buffer-parcel':
              if (Object.keys(dgData)?.length >= MAX_DATAGRID_ITEMS)
                return notifyExceededMaxItems()

              doGotoBufferParcel();
              break;
          }

          function notifyExceededMaxItems() {
            PaoWarning.showAlert({
              title: `Only ${MAX_DATAGRID_ITEMS} subject parcels allowed.`,
              message: 'In order to buffer this parcel, please delete another parcel or continue in a new browser.',
              scale: 's',
              placement: 'bottom',
              auto_close: true,
              auto_close_speed: PaoAlertAutoDismissSpeed.Medium,
              icon: 'exclamation-mark-triangle'
            });
            return;
          }

          async function gotoParcelWorkflow() {

            if (activeWidget?.state === 'active' && activeWidget?.buttonId === 'bufferButton') {

              queryGeometryToNewWindow(global_parid);

            } else if (activeWidget?.state !== 'active' && activeWidget?.buttonId === 'bufferButton') {

              queryGeometry();
              if (chosenSelectionMethod === ChosenSelectionMethodOptions.ParcelId)
                searchParcel(global_parid);

            } else {

              if (paoDetails.gis.referer?.length > 0) {

                paoDetails.gis.referer = null;
                paoDetails.gis.ownerSwitched = true;

                destroyBufferTool();
              }
              await doSwitchOwner();
            }
          }
        });

      let dvFullscreen = document.createElement('div');
      dvFullscreen.setAttribute('id', 'fullscreenButton');
      let cls = [
        'esri-component',
        'esri-widget--button',
        'esri-widget',
        'esri-icon-zoom-out-fixed',
      ];
      dvFullscreen.classList = '';
      dvFullscreen.classList.add(...cls);

      dvFullscreen.addEventListener('click', (e) => {
        if (paoDetails.gis.referer?.length > 0) {
          view = null;
          replaceLocationFromReferer();
          return;
        }
        toggleFullscreen()
          .then(() => {
            toggleSearchWidget({ show: paoDetails.gis.displayPage === 'fullaerial' });
          })
      });

      let scaleBarWidget = new ScaleBar({
        view: view,
        unit: 'imperial', 
      });

      let base_widgets = [];

      base_widgets.push(dvFullscreen);
      base_widgets.push(layerListExpand);
      base_widgets.push(distanceButton);
      base_widgets.push(areaButton);
      base_widgets.push(bufferButton);
      base_widgets.push(printExpand);

      view.ui.add(measurement, "bottom-right");
      measurement.view = view;

      view.ui.add(base_widgets, { position: 'top-right' });

      view.ui.add(scaleBarWidget, { position: 'bottom-left' });

      let url = latestYearAerialUrl + '/?f=pjson';
      esriRequest(url, {
        responseType: 'json',
        timeout: 5000,
      })
        .then(function (response) {

          let aerial_year_label = document.createElement('div');
          aerial_year_label.id = 'aerial_year_label';
          var meta_description = response?.data?.description;
          if (meta_description?.length > 0)
            aerial_year_label.setAttribute('class', 'aerial-year');

          aerial_year_label.innerText = meta_description;


          view.ui.add(aerial_year_label, { position: 'bottom-right' });

          watchVisibleAerialLayer();

        }).catch((error) => {
          doLogException('aerial_year_label', error);
        });

      _bufferWidget.title(bufferWidgetInactiveTitle);
      _distanceMeasureWidget.title(
        'Measure the distance between two or more points.'
      );
      _areaMeasureWidget.title('Measure an area on the map.');

      setTimeout(() => {
        layerList?.operationalItems?.reverse();
      }, 1450);

      if (paoDetails.gis.displayPage === 'fullaerial') {
        handleFullscreenButton();
        await toggleSearchWidget({ show: true });
        let featureLayer = map.layers.getItemAt(1);
        if (featureLayer && featureLayer.fullExtent !== null) {
          featureLayer.when(() => {
            view.goTo({
              target: featureLayer.fullExtent
            });
          });
        }
      }
    }; 

    document.addEventListener('keydown', (e) => {
      if (e.isComposing)
        return;

      if (e.key === 'Escape') {
        if (e.cancelable) e.preventDefault();
        let modalEl = document.getElementById('pao-modal');
        if (modalEl?.hasAttribute('open')) {
          closeModal();
          shellAllowInteractions(true);
          return;
        }
        if (paoDetails.gis.displayPage === 'fullaerial') {
          if (paoDetails.gis.referer?.length > 0) {
            view = null;
            replaceLocationFromReferer();
            return;
          }
          if (current_parcel_feature) {
            toggleFullscreen()
              .then(() => {
                toggleSearchWidget({ show: paoDetails.gis.displayPage === 'fullaerial' });
              })
          }
        }
      }
    });

    if (paoDetails.gis.displayPage === 'fullaerial') {
      let isResponsiveSize = view.widthBreakpoint !== 'xsmall';
      updateView({ showViewHeaderTitle: isResponsiveSize });
      view.watch('widthBreakpoint', (breakpoint) => {
        switch (breakpoint) {
          case 'xsmall':
            view.ui.components = [];

            if (view.ui.components.length === 1) {
              view.ui.components = [
                'attribution',
                'navigation-toggle',
                'compass',
                'zoom',
              ];
            }
            updateView({ showViewHeaderTitle: false });
            break;
          case 'small': 
          case 'medium': 
          case 'large': 
          case 'xlarge': 
            updateView({ showViewHeaderTitle: false });
            break;
        }
      });
    }

    function resetBufferSlider({ hideBufferSlider: hide }) {
      disableEnableSlider(false);
      bufferSize = 0;
      let el = document.getElementById('pao-buffer-slider');
      if (el) {
        el.value = 0;
        if (hide) hideBufferSlider();
      }
    }

    function hideBufferSlider() {
      let el = document.getElementById('pao-buffer-slider-block');
      if (el) el.hidden = true;
    }

    function resetSubjectParcelLabel() {
      document
        .querySelectorAll('#pao-subject-parcel-group>calcite-segmented-control-item')
        .forEach((p) => {
          if (p.innerHTML === 'Include') p.checked = true;
        });
    }

    const subjectParcelsRadioGroupChanged = async (event) => {
      if (event.target.value != null) {
        let id = event.target.id;
        let v = event.target.selectedItem.value;
        includeSubjectParcelsOn = (v === 'include');
        updateSubjectParcelLabel(event.target.selectedItem);

        let el = document.getElementById(id);
        let children = Array.from(el?.children);
        children.forEach((item) => {
          if (item.attributes.icon.value === 'circle')
            item.attributes.icon.value = 'check-circle';
          else item.attributes.icon.value = 'circle';
        });


        let filtered = {
          cols: DG_ADDR_COLUMNS,
          rows: [],
        };

        filtered.rows = bufferedData.rows.filter((val, idx, arr) => {
          if (!lookupSubjectParid(val[0])) return true;
          return includeSubjectParcelsOn;
        });

        if (bufferedData?.rows?.length === 0 && includeSubjectParcelsOn) {
          subjectParcels.rows.forEach((e, i, a) => {
            filtered.rows.push(e);
          });
        }

        let unitTypeAbbrv = await getChosenBufferUnitTypeAbbrv();

        let dgKeyColection = {
          index: dgData[activeDataAccordionItem]?.index,
          cols: filtered.cols,
          rows: filtered.rows,
          subjects: subjectParcels.rows,
          taxParcelTypeList: dgData[activeDataAccordionItem].taxParcelTypeList,
          chosenSelectionMethod: chosenSelectionMethod,
          chosenMethodValue: chosenMethodValue,
          unitTypeAbbrv: unitTypeAbbrv,
          includeSubjectParcelsOn: includeSubjectParcelsOn,
          bufferSize: bufferSize,
          isRural: dgData[activeDataAccordionItem].isRural
        };
        loadAccordionDataTable(dgKeyColection);

        let table = $('#pao-table-buffer').DataTable();
        table.clear();
        table.rows.add(dgData[activeDataAccordionItem].rows).draw();
        queryLayerView();
      }
    };

    function toggleSubjectParcelsRadioGroup() {
      let el = document.getElementById('pao-subject-parcel-group');
      if (el) {
        if (dgData[activeDataAccordionItem]?.rows?.length) {
          let p = dgData[activeDataAccordionItem].includeSubjectParcelsOn;
          let _include = p ? 'include' : 'exclude';

          if (el.hasChildNodes()) {
            let children = el.childNodes;
            children.forEach((child) => {
              if (child.value === _include) {
                child.checked = true;
              }
            });
          }
          updateSubjectParcelLabel();
        }
      }
    }

    const checkBufferWidgetState = () => {
      if (activeWidget?.state === 'active' && activeWidget?.buttonId === 'bufferButton')
        _bufferWidget.close();
    };

    function replaceLocationFromReferer() {
      let tmp_ref = paoDetails.gis.referer;
      paoDetails.gis.referer = null;
      window.location.replace(tmp_ref);
    }

    function toggleFullscreen() {
      return new Promise((resolve) => {
        checkBufferWidgetState();

        let _max = paoDetails.gis.displayPage !== 'fullaerial';

        if (!_max && paoDetails.gis.referer && paoDetails.gis.referer.length > 0) {
          replaceLocationFromReferer();
          resolve(true);
        }

        if (!_max) {
          minimizeAerial().then(() => {
            resolve(true);
          });
        } else {
          goFullscreen().then(() => {
            resolve(true);
          });
        }
      }).catch((error) => { doLogException('toggleFullscreen', error); });
    }

    function goFullscreen() {
      return new Promise((resolve) => {
        document.getElementById('container').classList.add('d-none');
        document.getElementById('ZoneA').classList.add('d-none');
        document.getElementById('ZoneB').classList.add('d-none');
        document.getElementById('ZoneC').classList.add('d-none');

        updateView({ showViewHeaderTitle: true });

        mapEl.classList.remove('aerial-small');

        let shell = document.getElementById('pao-shell');

        document.body.appendChild(shell);

        paoDetails.gis.displayPage = 'fullaerial';

        handleFullscreenButton();
        resolve(true);

      }).catch((error) => { doLogException('goFullscreen', error); });
    }

    const toggleSearchWidget = async ({ show }) => {
      if (searchWidget) view?.ui.remove(searchWidget);
      if (show) {

        let popupTemplate = await createSearchWidgetPopupTemplate();

        let featureLayerSearch = new FeatureLayer({
          url: parcelSearchUrl,
          popupTemplate: popupTemplate
        });

        const theExtent = new Extent({
          xmin: 412198.71957017505,
          ymin: 1044628.12338194,
          xmax: 638866.493595924,
          ymax: 1209282.62510902,
          spatialReference: {
            wkid: 102659,
          },
        });

        const searchExtent = {
          geometry: theExtent,
          where: "SITUS_STATE='FL'",
        };


        const sources = [
          {
            layer: featureLayerSearch,
            placeholder: 'Find any part of address',
            suggestionTemplate:
              '{SITUS_ADDRESS} {SITUS_POSTAL_CITY} {SITUS_STATE}',
            maxResults: 4,
            maxSuggestions: 4,
            suggestionsEnabled: true,
            minSuggestCharacters: 2,
            exactMatch: false,
            prefix: '%',
            searchFields: ['SITUS_ADDRESS'],
            displayField: 'SITUS_ADDRESS',
            outFields: ['*'],
            name: 'Parcel Search',
            zoomScale: 2000,
          },
        ];

        searchWidget = new Search({
          view: view,
          includeDefaultSources: false,
          sources: sources,
        });

        searchWidget.viewModel.defaultSymbols = {
          point: pointSymbol,
          polygon: {
            type: 'simple-fill',
            outline: { color: [11, 53, 51, 1] },
            color: [94, 248, 241, 0.5],
          },
          polyline: polylineSymbol,
        };
        view.ui.add(searchWidget, { position: 'top-right', index: 0 });
      }
    };

    async function doGotoBufferParcel() {
      if (global_parid?.length > 0) {
        if (bufferLayerViewUpdatingFlag)
          await delay(350);

        let pli = document.getElementById('pao-by-parid');
        if (pli) await pli.setAttribute('selected', '');
        searchParcel(global_parid);
      }
    }

    function minimizeAerial() {
      return new Promise((resolve) => {
        closeVisiblePopup();


        mapEl.classList.add('aerial-small');

        document.getElementById('container').classList.remove('d-none');
        document.getElementById('ZoneA').classList.remove('d-none');
        document.getElementById('ZoneB').classList.remove('d-none');
        document.getElementById('ZoneC').classList.remove('d-none');

        updateView({ showViewHeaderTitle: false });

        view.ui.move({ component: 'zoom', position: 'top-left', index: 0 });

        let shell_clone = document.getElementById('pao-shell');
        let aerialMap = document.getElementById('aerialMap');
        aerialMap.appendChild(shell_clone);

        paoDetails.gis.displayPage = 'details';

        handleFullscreenButton();

        if (current_parcel_feature) {

          doViewGoto(current_parcel_feature)
            .then(() => {
              addGraphics(current_parcel_feature, symbolLineAcqua)
              resolve(true);
            })

        } else {
          resolve(true);
        }
      }).catch((error) => { doLogException('minimizeAerial', error); });
    }

    const showBufferSlider = async () => {
      return new Promise((resolve) => {
        showParcelSubjectOptions();
        if (Object.keys(dgData)?.length === 0) bufferSize = 0;

        let el = document.getElementById('pao-buffer-slider');
        if (el) {
          el.value = bufferSize;
          el = document.getElementById('pao-buffer-slider-block');
          if (el) {
            updateBufferSliderButtonLabel();
            el.hidden = false;
            if (!sliderBlockStateKeepClosed) el.setAttribute('open', '');
          }
        }
        resolve(true);
      }).catch((error) => {
        doLogException('showBufferSlider', error);
        resolve(false);
      });
    };

    function updateBufferSliderButtonLabel() {
      try {
        let btn = document.getElementById('pao-buffer-unit-button');
        if (btn) {
          let d = document.getElementById('pao-buffer-unit');
          if (d.selectedItems?.length > 0)
            btn.innerHTML = `Buffer distance in ${d.selectedItems[0].innerHTML}`;
        }
      } catch (error) {
        doLogException('updateBufferSliderButtonLabel', error);
      }
    }

    const addSwipeWidget = () => {
      try {
        if (swipeWidget) return;

        if (!_swipeTrailingLayer)
          _swipeTrailingLayer = priorYearAerials;

        swipeWidget = new Swipe({
          leadingLayers: [_swipeLeadingLayer],
          trailingLayers: [_swipeTrailingLayer],
          position: 50, 
          view: view,
          label: `${_swipeLeadingLayer?.title} & ${_swipeTrailingLayer?.title}`
        });
        view.ui.add(swipeWidget);
      } catch (error) {
        console.log(error);
      }
    };

    const removeSwipeWidget = () => {
      try {
        if (swipeWidget) {
          view.ui.remove(swipeWidget);
          if (swipeWidget?.constructed) swipeWidget.destroy();
          swipeWidget = null;
        }
      } catch (error) {
        console.log(error);
      }
    }

    const setSwipeWidgetSides = (leadingLayer, trailingLayer) => {
      swipeWidget.leadingLayers = [leadingLayer];
      swipeWidget.trailingLayers = [trailingLayer];
    };

    const addPrintWidget = () => {
      const printWidget = new Print({
        view: view,
        printServiceUrl: printServiceUrl,
      });

      printWidget.on("error", function (error) {
        console.error("Print Widget Error:", error);
      });

      return new Expand({
        content: printWidget,
        view: view,
        autoCollapse: true,
        expanded: false,
        expandTooltip: 'Print Map',
        group: 'top-right',
        mode: 'floating',
      });
    };

    function closeExpanderWidgets() {
      if (printExpand?.expanded) {
        printExpand?.collapse();
      }
      if (layerListExpand.expanded) {
        layerListExpand.collapse();
      }
    }


    let distanceButton = document.createElement('div');
    distanceButton.setAttribute('id', 'distanceButton');
    distanceButton.className =
      'esri-widget--button esri-widget esri-icon-measure-line esri-component';
    distanceButton.addEventListener('click', (event) => {
      event.stopPropagation();
      distanceMeasurement();
    });
    let areaButton = document.createElement('div');
    areaButton.setAttribute('id', 'areaButton');
    areaButton.className =
      'esri-widget--button esri-widget esri-icon-measure-area esri-component';
    areaButton.addEventListener('click', (event) => {
      event.stopPropagation();
      areaMeasurement();
    });
    let bufferButton = document.createElement('div');
    bufferButton.setAttribute('id', 'bufferButton');
    bufferButton.className =
      'esri-widget--button esri-widget esri-icon-review esri-component';
    bufferButton.addEventListener('click', (event) => {
      event.stopPropagation();
      bufferTool();
    });

    function distanceMeasurement() {

      measurement.clear();

      closeVisiblePopup();
      closeExpanderWidgets();

      if (!distanceButton.classList.contains('active')) {
        _distanceMeasureWidget.open();
      } else {
        _distanceMeasureWidget.close();
      }
    }

    function areaMeasurement() {

      measurement.clear();

      closeVisiblePopup();
      closeExpanderWidgets();

      if (!areaButton.classList.contains('active')) {
        _areaMeasureWidget.open();
      } else {
        _areaMeasureWidget.close();
      }
    }

    function bufferTool() {
      return new Promise((resolve) => {
        if (activeWidget?.buttonId !== 'bufferButton' && !detectSupportedDevice()) {
          document.getElementById('pao-parcel-export-method-block').removeAttribute('open');
          document.getElementById('pao-parcel-export-method-block').setAttribute('collapsible', '');

          let subtext = paoDetails.support.isMobileDevice
            ? 'Pinch to zoom'
            : '';
          PaoInfo.showAlert({
            title:
              'The Buffer tool works best on window sizes 1024 x 768 or larger',
            message: subtext,
            scale: 's',
            placement: 'bottom',
            auto_close: true,
            auto_close_speed: PaoAlertAutoDismissSpeed.Fast,
          });
        }

        if (activeWidget?.buttonId !== 'bufferButton' && paoDetails.gis.displayPage === 'fullaerial') {
          _bufferWidget.open();
          resolve(true);
        } else if (activeWidget?.buttonId !== 'bufferButton' && paoDetails.gis.displayPage === 'details') {
          _bufferWidget.open();
          goFullscreen().then(() => {

            if (!searchWidget?.visible)
              toggleSearchWidget({ show: true });

            doGotoBufferParcel();

            resolve(true);
          });
        } else if (activeWidget?.buttonId === 'bufferButton') {
          _bufferWidget.close();
          resolve(true);
        }
      }).catch((error) => { doLogException('bufferTool', error); });
    }

    function closeLastActiveWidget() {

      closeExpanderWidgets();

      let id = activeWidget?.buttonId;
      if (id?.length > 0) {
        if (activeWidget?.state === 'active') {
          switch (id) {
            case 'bufferButton':
              _bufferWidget.close();
              break;
            case 'distanceButton':
              _distanceMeasureWidget.close();
              break;
            case 'areaButton':
              _areaMeasureWidget.close();
              break;
          }
        }
      }
    }

    function resetActiveWidgetObject() {
      activeWidget = {
        buttonId: '',
        containerId: '',
        state: '',
        worksMinimized: false,
        showTitleBar: false,
      };
    }

    function getTaxParcelTypes() {
      return new Promise((resolve) => {
        let queryObject = new Query({
          outSpatialReference: view.spatialReference,
          returnGeometry: false,
          returnIdsOnly: false,
          returnCountOnly: false,
          returnZ: false,
          returnM: false,
          returnDistinctValues: true,
          returnExtentOnly: false,
          orderByFields: ['TAXPARCELTYPE'],
          outFields: ['TAXPARCELTYPE'],
          where: '1=1', 
        });
        query
          .executeQueryJSON(parcelSearchUrl, queryObject)
          .then((result) => {
            resolve(result);
          })
        ['catch']((error) => {
          doLogException('getTaxParcelTypes', error);
        });
      });
    }

    const getConveyanceTypesFromGIS = async (conveyanceType, url) => {
      return new Promise((resolve) => {
        const maxRecordCount = 2000;
        let queryObject = new Query({
          returnGeometry: false,
          returnIdsOnly: true,
          returnDistinctValues: true,
          outSpatialReference: view.spatialReference,
          outFields: ['OBJECTID'],
          where: `CONVEYANCETYPE='${conveyanceType}'`,
        });
        query
          .executeForCount(url, queryObject)
          .then((queryRecordCount) => {
            if (queryRecordCount) {
              const pageCount = Math.ceil(queryRecordCount / maxRecordCount);
              let resultPages = [];
              for (let i = 0; i < pageCount; i++) {
                resultPages.push(i * maxRecordCount);
              }
              return Promise.all(
                resultPages.map((resultPageStart) => {
                  queryObject = new Query({
                    returnGeometry: false,
                    orderByFields: ['NAME'],
                    outFields: ['OBJECTID', 'CONVEYANCEDESIGNATOR', 'NAME'],
                    returnDistinctValues: true,
                    outSpatialReference: view.spatialReference,
                    where: `CONVEYANCETYPE='${conveyanceType}'`,
                  });
                  queryObject.start = resultPageStart;
                  queryObject.num = maxRecordCount;
                  return query.executeQueryJSON(url, queryObject);
                })
              );
            } else {
              console.log('No records to query');
              return Promise.resolve([new FeatureSet()]);
            }
          })
          .then(function (featureSets) {
            stepProgressBar();

            let returnFeatureSet = featureSets.shift();
            featureSets.forEach(function (featureSet) {
              Array.prototype.push.apply(
                returnFeatureSet.features,
                featureSet.features
              );
            });
            resolve(returnFeatureSet);
          });
      })['catch']((error) => {
        doLogException('getConveyanceTypesFromGIS', error);
      });
    };

    function queryChosenSelectionMethod(
      chosenSelectionMethod,
      chosenMethodValue,
      bufferSize
    ) {
      let p1 = new Promise((resolve) => {
        switch (chosenSelectionMethod) {
          case ChosenSelectionMethodOptions.Condominium:
            break;
          case ChosenSelectionMethodOptions.Cooperative:
            break;
          case ChosenSelectionMethodOptions.ParcelId:
            resolve(searchParcel(chosenMethodValue));
            break;
          case ChosenSelectionMethodOptions.Sketch:
            break;
          case ChosenSelectionMethodOptions.Subdivision:
            break;
        }
      });

      p1.then((result) => {
        const e = new Event('calciteSliderInput');
        let el = document.getElementById('pao-buffer-slider');
        el.value = bufferSize;
        el.dispatchEvent(e);
      });
      p1.catch((result) => { doLogException('queryChosenSelectionMethod', error); });
    }

    function searchConveyanceFeatures(event, conveyanceType, url) {
      return new Promise((resolve) => {
        if (event.target.value != null) {
          if (event?.target?.value?.length > 0) {
            chosenMethodValue = event.target.value.toString();

            setChosenComboBoxAttributes(event.target);

            let label = getChosenSelectionMethodName(false);
            document.getElementById('pao-component-container').setAttribute('heading', `${label} selected`);

            document.getElementById(`pao-${conveyanceType}-cbo`).setAttribute('disabled', '');

            let el = document.getElementById(`pao-${conveyanceType.toLowerCase()}-list`);
            if (el) {
              el.setAttribute('disabled', '');
              el.style.height = '36px';
            }

            activeDataAccordionItem = `accd-${chosenMethodValue}`;

            let queryObject = new Query({
              geometryType: 'point',
              units: unitType,
              distance: 0,
              outSpatialReference: view.spatialReference,
              returnGeometry: true,
              outFields: ['*'],
              where: `CONVEYANCEDESIGNATOR='${chosenMethodValue}'`,
            });
            subjectParSubdivision = `PAR_SUBDIVISION='${chosenMethodValue}'`;

            getQueriedParidsInSubjectProperty(subjectParSubdivision)
              .then((result) => {
                queried_parids_in_subject_property = result;

                query
                  .executeQueryJSON(url, queryObject) 
                  .then(addGraphicModeSketchGeometry) 
                  .then(() => {
                    return getSubjectParidsFromGeometry(subjectParSubdivision)
                  })
                  .then(parcelQueryBuffer)
                  .then(showTaxParcelTypesList)
                  .then(showBufferSlider)
                  .then(buildAccordionContainer)
                  .then(getChosenBufferUnitTypeAbbrv)
                  .then(applyConveyanceRule)
                  .then(() => {
                    doCursor('auto');
                    resolve(true);
                  })
                ['catch'](promiseRejected);

              });
          }
        }
      }).catch((error) => {
        doLogException('searchConveyanceFeatures', error);
        resolve(false);
      });
    }

    const setChosenComboBoxAttributes = (elem) => {
      let items = elem.querySelectorAll('calcite-combobox-item');
      items.forEach((p) => {
        if (p.selected) {
          chosenMethodTextLabel = p.textLabel;
          let selected_component = document.getElementById('pao-component-container');
          if (selected_component) {
            selected_component.removeAttribute('open');
            selected_component.setAttribute('description', chosenMethodTextLabel);
          }
        }
        return;
      });
    };

    function searchParcel(parid) {
      return new Promise((resolve) => {
        chosenMethodValue = parid;
        activeDataAccordionItem = `accd-${chosenMethodValue}`;
        let lockBufferSize = Object.keys(dgData)?.length > 0;
        let queryObject = new Query({
          returnGeometry: true,
          geometryType: 'point',
          units: unitType,
          distance: lockBufferSize ? bufferSize : 0,
          outSpatialReference: view.spatialReference,
          outFields: [
            'PARID',
            'PAR_MAIL_LABEL1',
            'PAR_MAIL_LABEL2',
            'PAR_MAIL_LABEL3',
            'PAR_MAIL_LABEL4',
            'PAR_MAIL_LABEL5',
            'PAR_MAIL_LABEL6',
            'TAXPARCELTYPE'
          ],
          orderByFields: ['PARID'],
          where: `PARID='${chosenMethodValue}'`,
        });
        query.executeForCount(parcelSearchUrl, queryObject).then(
          (count) => {
            if (count > 0) {
              query
                .executeQueryJSON(parcelSearchUrl, queryObject)
                .then(addGraphicModeSketchGeometry) 
                .then(setConveyanceSubjectData)
                .then(parcelQueryBuffer)
                .then(showTaxParcelTypesList)
                .then(showBufferSlider)
                .then(buildAccordionContainer)
                .then(getChosenBufferUnitTypeAbbrv)
                .then(applyConveyanceRule)
                .then(() => {
                  doCursor('auto');
                  resolve(true);
                })
              ['catch'](promiseRejected);
            } else {
              labelErrorMessage(
                'pao-parcel-search-notfound',
                `${chosenMethodValue} was not found.`,
                5000
              );
            }
          },
          (error) => {
            doLogException('searchParcel->executeForCount', error);
          }
        );
      }).catch((error) => { doLogException('searchParcel', error); });
    }



    const setZoomConstraints = () => {
      try {
        let zm = 0;
        switch (chosenSelectionMethod) {
          case ChosenSelectionMethodOptions.Condominium:
          case ChosenSelectionMethodOptions.Cooperative:
          case ChosenSelectionMethodOptions.Subdivision:
            zm = paoDetails.gis.zoomLevelConveyanceType;
            break;
          case ChosenSelectionMethodOptions.ParcelId:
            zm = paoDetails.gis.zoomLevelParcelId;
            break;
          case ChosenSelectionMethodOptions.Sketch:
            zm = paoDetails.gis.zoomLevelSketch;
            break;
          default:
            zm = paoDetails.gis.zoomLevelDefault;
        }
        zoomConstraints(zm);
      } catch (error) {
        doLogException('setZoomConstraints', error);
      }
    };

    function determineResetActionState() {
      try {
        let active = false;


        let el = document.getElementById('pao-taxparceltypes-list');
        if (el) active = true;

        let el2 = document.getElementById('pao-maplayer-cbo');
        if (el2) active = true;

      } catch (error) {
        doLogException('determineResetActionState', error);
      }
    }

    function closeVisiblePopup() {
      if (view?.popup?.visible) view.popup.close();
    }

    function initMeasureWidget(measureType, defaultUnit) {
      switch (measureType) {
        case 'area':
          measurement.areaUnit = defaultUnit;
          break;
        case 'distance':
          measurement.linearUnit = 'feet';
          break;
      }
      measurement.activeTool = measureType;
      measurement.startMeasurement();
      watchMeasure(measurement);
    }

    async function resetBufferFiltersItem(id) {
      return await new Promise((resolve) => {
        try {
          resetBufferSlider({ hideBufferSlider: false });
          updateTablePageInfoHeader(null);
          bufferLayer.removeAll();
          view.graphics.removeAll();
        } catch (error) {
          doLogException('resetBufferFiltersItem', error);
        }
        resolve(true);
      }).catch((error) => { doLogException('resetBufferFiltersItem', error); });
    }

    async function resetBufferFiltersAll() {
      return await new Promise((resolve) => {
        try {
          bufferWasReset = true;

          activeDataAccordionItem = '';
          resetStateLength = 19;
          chosenSelectionMethod = ChosenSelectionMethodOptions.None;
          resetStateLength = 18;
          closeVisiblePopup();
          resetStateLength = 17;
          setupDataTableFlag = false;
          resetStateLength = 16;
          clearGeometry();
          resetStateLength = 15;
          let table = $('#pao-table-buffer').DataTable();
          table.clear();
          resetStateLength = 14;
          resetSubjectParcelLabel();
          resetStateLength = 13;
          resetBufferSlider({ hideBufferSlider: true });
          resetStateLength = 12;
          hideTaxParcelTypesList();
          resetStateLength = 11;
          hideComponentContainer();
          resetStateLength = 10;
          document.getElementById('pao-parcel-export-method-block').setAttribute('open', '');
          resetStateLength = 9;
          resetBufferUnit();
          resetStateLength = 8;
          dgData = [];
          resetStateLength = 7;
          accordionIdList = [];
          resetStateLength = 6;
          let accordion_item = document.getElementById(activeDataAccordionItem);
          if (accordion_item) accordion_item.description = ` `; 
          resetStateLength = 5;
          let el2 = document.getElementById('pao-parcel-search-block');
          if (el2) el2.remove();
          resetStateLength = 4;
          resetStateLength = 3;
          let pickListItems = document.querySelectorAll(
            '#pao-taxparceltypes-list > calcite-pick-list-item'
          );
          if (pickListItems) {
            pickListItems.forEach((item) => (item.selected = true));
          }
          resetStateLength = 2;
          let el4 = document.getElementById('pao-parcel-export-method');
          if (el4) {
            Object.keys(el4.children).forEach((key) => {
              if (
                el4.children[key].nodeName.toLowerCase() === 'calcite-pick-list-group') {
                Object.keys(el4.children[key].children).forEach((key2) => {
                  try {
                    el4.children[key].children[key2].selected = false;
                  } catch (error) {
                    doLogException('resetBufferFiltersAll->calcite-pick-list-group', error);
                  }
                });
              }
            });
          }
          resetStateLength = 1;
          let el5 = document.getElementById('pao-accordion-data-panel');
          if (el5) el5.remove();

          resetStateLength = 0;

          resolve(true);
        } catch (error) {
          doLogException('resetBufferFiltersAll', error);
        }
      }).catch((error) => { doLogException('resetBufferFiltersAll', error); });
    }

    const resetBufferFilters = async (resetId) => {
      try {
        bufferedData = {
          cols: [],
          rows: [],
        };
        subjectParcels = {
          cols: [],
          rows: [],
        };
        resetTaxParcelTypesBlock();
        disableEnableExportToolContainer(false);
        disableViewConstraintZoom();

        distanceConstraintSet = false;

        waitingForResults = false;

        let el = document.getElementById('pao-parcel-export-method-block');
        if (el) {
          el.removeAttribute('disabled')
          el.removeAttribute('collapsible');
        }

        el = document.getElementById('pao-measurements-widget');
        if (el) {
          el.classList.add('d-none');
          el.innerHTML = '';
        }

        document.getElementById('pao-component-container').description = ' ';

        taxParcelTypesSelectedString = taxParcelTypesDefaultString;

        subjectParSubdivision = '';
        includeSubjectParcelsOn = true;


        switch (resetId) {
          case 0: 
            await resetBufferFiltersAll();
            break;
          default:
            await resetBufferFiltersItem(resetId);
            break;
        }

        determineResetActionState();

      } catch (error) {
        doLogException('resetBufferFilters', error);
      }
    };

    function destroyBufferTool() {
      document.getElementById('pao-parcel-export-method-block').parentElement.remove();
    }

    function buildBufferExportTool() {
      return new Promise((resolve) => {
        let block = document.createElement('calcite-block');
        block.setAttribute('id', 'pao-parcel-export-method-block');
        block.setAttribute('heading', 'Choose a selection method');
        block.setAttribute('open', '');

        let slot = document.createElement('calcite-icon');
        slot.setAttribute('scale', 's');
        slot.setAttribute('slot', 'icon');
        slot.setAttribute('icon', 'magnifying-glass');
        block.appendChild(slot);

        let list = document.createElement('calcite-list');

        let item = null;
        let action = null;
        let pick = null;

        pick = document.createElement('calcite-pick-list');
        pick.setAttribute('id', 'pao-parcel-export-method');
        pick.addEventListener('calciteListChange', (event) => {
          if (resetStateLength === 0) generateRenderer(event);
        });


        let group1 = document.createElement('calcite-pick-list-group');
        group1.setAttribute('group-title', 'Use a map layer');

        item = document.createElement('calcite-pick-list-item');
        item.setAttribute('id', 'pao-by-parid');
        item.setAttribute('label', 'By Parcel Id');
        item.setAttribute('value', 'pao-by-parid');

        action = document.createElement('calcite-action');
        action.setAttribute('slot', 'actions-start');
        action.setAttribute('text', 'By Parcel Id');
        action.setAttribute('compact', '');
        action.innerHTML = '<span class="pao-icon-parid"></span>';
        action.setAttribute('appearance', 'transparent');
        action.addEventListener('click', (event) => {
          showInstructionModal('pao-by-parid');
        });
        let tooltip = document.createElement('calcite-tooltip');
        tooltip.setAttribute('reference-element', 'pao-by-parid');
        tooltip.setAttribute('overlay-positioning', 'fixed');
        tooltip.setAttribute('placement', 'left-start');
        tooltip.setAttribute('offset-distance', '-120');
        tooltip.setAttribute('label', 'Click icon on left for instructions on how to use the Parcel Id map layer.');
        tooltip.innerHTML = 'Click <span class="pao-icon-parid"></span> icon on left for <span style="color:red;">instructions</span> on how to use the <b>By Parcel Id</b> map layer.';
        tooltip.style.width = '260px';
        action.appendChild(tooltip);
        item.appendChild(action);
        group1.appendChild(item);

        item = document.createElement('calcite-pick-list-item');
        item.setAttribute('id', 'pao-by-condo');
        item.setAttribute('label', 'Condominium');
        item.setAttribute('value', 'pao-by-condo');

        action = document.createElement('calcite-action');
        action.setAttribute('slot', 'actions-start');
        action.setAttribute('text', 'Condominium');
        action.setAttribute('compact', '');
        action.innerHTML = '<span class="pao-icon-condo"></span>';
        action.setAttribute('appearance', 'transparent');
        action.addEventListener('click', (event) => {
          showInstructionModal('pao-by-condo');
        });
        tooltip = document.createElement('calcite-tooltip');
        tooltip.setAttribute('reference-element', 'pao-by-condo');
        tooltip.setAttribute('overlay-positioning', 'fixed');
        tooltip.setAttribute('placement', 'left-start');
        tooltip.setAttribute('offset-distance', '-120');
        tooltip.setAttribute('label', 'Click icon on left for instructions on how to use the Condominium map layer.');
        tooltip.innerHTML = 'Click <span class="pao-icon-condo"></span> icon on left for <span style="color:red;">instructions</span> on how to use the <b>Condominium</b> map layer.';
        tooltip.style.width = '260px';
        action.appendChild(tooltip);
        item.appendChild(action);
        group1.appendChild(item);

        item = document.createElement('calcite-pick-list-item');
        item.setAttribute('id', 'pao-by-coop');
        item.setAttribute('label', 'Cooperative');
        item.setAttribute('value', 'pao-by-coop');

        action = document.createElement('calcite-action');
        action.setAttribute('slot', 'actions-start');
        action.setAttribute('text', 'Cooperative');
        action.setAttribute('compact', '');
        action.innerHTML = '<span class="pao-icon-coop"></span>';
        action.setAttribute('appearance', 'transparent');
        action.addEventListener('click', (event) => {
          showInstructionModal('pao-by-coop');
        });
        tooltip = document.createElement('calcite-tooltip');
        tooltip.setAttribute('reference-element', 'pao-by-coop');
        tooltip.setAttribute('overlay-positioning', 'fixed');
        tooltip.setAttribute('placement', 'left-start');
        tooltip.setAttribute('offset-distance', '-120');
        tooltip.setAttribute('label', 'Click icon on left for instructions on how to use the Cooperative map layer.');
        tooltip.innerHTML = 'Click <span class="pao-icon-coop"></span> icon on left for <span style="color:red;">instructions</span> on how to use the <b>Cooperative</b> map layer.';
        tooltip.style.width = '260px';
        action.appendChild(tooltip);
        item.appendChild(action);
        group1.appendChild(item);

        item = document.createElement('calcite-pick-list-item');
        item.setAttribute('id', 'pao-by-subdv');
        item.setAttribute('label', 'Subdivision');
        item.setAttribute('value', 'pao-by-subdv');

        action = document.createElement('calcite-action');
        action.setAttribute('slot', 'actions-start');
        action.setAttribute('text', 'Subdivision');
        action.setAttribute('compact', '');
        action.innerHTML = '<span class="pao-icon-subdv"></span>';
        action.setAttribute('appearance', 'transparent');
        action.addEventListener('click', (event) => {
          showInstructionModal('pao-by-subdv');
        });
        tooltip = document.createElement('calcite-tooltip');
        tooltip.setAttribute('reference-element', 'pao-by-subdv');
        tooltip.setAttribute('overlay-positioning', 'fixed');
        tooltip.setAttribute('placement', 'left-start');
        tooltip.setAttribute('offset-distance', '-120');
        tooltip.setAttribute('label', 'Click icon on left for instructions on how to use the Subdivision map layer.');
        tooltip.innerHTML = 'Click <span class="pao-icon-subdv"></span> icon on left for <span style="color:red;">instructions</span> on how to use the <b>Subdivision</b> map layer.';
        tooltip.style.width = '260px';
        action.appendChild(tooltip);
        item.appendChild(action);
        group1.appendChild(item);

        pick.appendChild(group1);

        let group2 = document.createElement('calcite-pick-list-group');
        group2.setAttribute('group-title', `${SKETCH_GROUP2_TITLE} ${SKETCH_GROUP2_TITLE_NOTIFY}`);

        item = document.createElement('calcite-pick-list-item');
        item.setAttribute('id', 'pao-point');
        item.setAttribute('label', 'Parcel By Point');
        item.setAttribute('value', 'point');
        item.setAttribute('disabled', '');

        action = document.createElement('calcite-action');
        action.setAttribute('slot', 'actions-start');
        action.setAttribute('text', 'Parcel By Point');
        action.setAttribute('compact', '');
        action.innerHTML = `<span class="pao-icon-point pao-icon-disabled"></span>`;
        action.setAttribute('appearance', 'transparent');
        action.addEventListener('click', (event) => {
          showInstructionModal('pao-point');
        });
        tooltip = document.createElement('calcite-tooltip');
        tooltip.setAttribute('reference-element', 'pao-point');
        tooltip.setAttribute('overlay-positioning', 'fixed');
        tooltip.setAttribute('placement', 'left-start');
        tooltip.setAttribute('offset-distance', '-120');
        tooltip.setAttribute('label', 'Click icon on left for instructions on how to use the Parcel By Point sketch tool.');
        tooltip.innerHTML = 'Click <span class="pao-icon-point"></span> icon on left for <span style="color:red;">instructions</span> on how to use the <b>Parcel By Point</b> sketch tool.';
        tooltip.style.width = '260px';
        action.appendChild(tooltip);
        item.appendChild(action);
        group2.appendChild(item);

        item = document.createElement('calcite-pick-list-item');
        item.setAttribute('id', 'pao-polygon');
        item.setAttribute('label', 'Parcels By Polygon');
        item.setAttribute('value', 'polygon');
        item.setAttribute('disabled', '');

        action = document.createElement('calcite-action');
        action.setAttribute('slot', 'actions-start');
        action.setAttribute('text', 'Parcels By Polygon');
        action.setAttribute('compact', '');
        action.innerHTML = `<span class="pao-icon-polygon pao-icon-disabled"></span>`;
        action.setAttribute('appearance', 'transparent');
        action.addEventListener('click', (event) => {
          showInstructionModal('pao-polygon');
        });
        tooltip = document.createElement('calcite-tooltip');
        tooltip.setAttribute('reference-element', 'pao-polygon');
        tooltip.setAttribute('overlay-positioning', 'fixed');
        tooltip.setAttribute('placement', 'left-start');
        tooltip.setAttribute('offset-distance', '-120');
        tooltip.setAttribute('label', 'Click icon on left for instructions on how to use the Parcel By Polygon sketch tool.');
        tooltip.innerHTML = 'Click <span class="pao-icon-polygon"></span> icon on left for <span style="color:red;">instructions</span> on how to use the <b>Parcel By Polygon</b> sketch tool.';
        tooltip.style.width = '260px';
        action.appendChild(tooltip);
        item.appendChild(action);
        group2.appendChild(item);

        item = document.createElement('calcite-pick-list-item');
        item.setAttribute('id', 'pao-rectangle');
        item.setAttribute('label', 'Parcels By Rectangle');
        item.setAttribute('value', 'rectangle');
        item.setAttribute('disabled', '');

        action = document.createElement('calcite-action');
        action.setAttribute('id', 'pao-action-rectangle');
        action.setAttribute('slot', 'actions-start');
        action.setAttribute('text', 'Parcels By Rectangle');
        action.setAttribute('compact', '');
        action.innerHTML = `<span class="pao-icon-rectangle pao-icon-disabled"></span>`;
        action.setAttribute('appearance', 'transparent');
        action.addEventListener('click', (event) => {
          showInstructionModal('pao-rectangle');
        });
        tooltip = document.createElement('calcite-tooltip');
        tooltip.setAttribute('reference-element', 'pao-rectangle');
        tooltip.setAttribute('overlay-positioning', 'fixed');
        tooltip.setAttribute('placement', 'left-start');
        tooltip.setAttribute('offset-distance', '-120');
        tooltip.setAttribute('label', 'Click icon on left for instructions on how to use the Parcel By Rectangle sketch tool.');
        tooltip.innerHTML = 'Click <span class="pao-icon-rectangle"></span> icon on left for <span style="color:red;">instructions</span> on how to use the <b>Parcel By Rectangle</b> sketch tool.';
        tooltip.style.width = '260px';
        action.appendChild(tooltip);
        item.appendChild(action);
        group2.appendChild(item);

        pick.appendChild(group2);


        list.appendChild(pick);
        block.appendChild(list);

        let container = document.createElement('div');
        container.setAttribute('id', 'pao-buffer-container');
        container.setAttribute('hidden', '');

        let instructions = document.createElement('calcite-block');
        instructions.setAttribute('id', 'pao-instruction-block');
        instructions.setAttribute('heading', `${containerInstructions(0)}`);
        instructions.style.backgroundColor = 'rgba(214, 246, 239, 0.5)';
        instructions.style.textAlign = 'left';

        container.appendChild(instructions);
        container.appendChild(block);
        if (primaryPanel) primaryPanel.appendChild(container);

        resolve(true);
      }).catch((error) => { doLogException('buildBufferExportTool', error); });
    }

    function disableBufferExportTool(updating, interacting, zoom) {
      if (!modalActive && chosenSelectionMethod === ChosenSelectionMethodOptions.None) {
        zoomIsFar = 15 > zoom;
        let parent = document.querySelector('calcite-pick-list-group:nth-child(2)');
        if (parent) {
          let children = parent.querySelectorAll('calcite-pick-list-item');
          if (children) {
            for (const [key, value] of Object.entries(children)) {
              switch (value?.id) {
                case 'pao-point':
                case 'pao-polygon':
                case 'pao-rectangle':
                  zoomIsFar = paoDetails.gis.zoomLevelSketch > zoom;
                  if (zoomIsFar) value.setAttribute('disabled', '');
                  if (!zoomIsFar) value.removeAttribute('disabled');
                  parent.groupTitle = SKETCH_GROUP2_TITLE;
                  if (zoomIsFar) {
                    parent.groupTitle = `${SKETCH_GROUP2_TITLE} ${SKETCH_GROUP2_TITLE_NOTIFY}`;
                    document.querySelector('.pao-icon-point').classList.add('pao-icon-disabled');
                    document.querySelector('.pao-icon-polygon').classList.add('pao-icon-disabled');
                    document.querySelector('.pao-icon-rectangle').classList.add('pao-icon-disabled');
                  } else {
                    document.querySelector('.pao-icon-point').classList.remove('pao-icon-disabled');
                    document.querySelector('.pao-icon-polygon').classList.remove('pao-icon-disabled');
                    document.querySelector('.pao-icon-rectangle').classList.remove('pao-icon-disabled');
                  }
                  break;
              }
              if (updating) value.setAttribute('disabled', '');
              if (!updating && !zoomIsFar) value.removeAttribute('disabled');
            }
          }
        }
        let pb = document.getElementById('pao-parcel-export-method-block');
        if (pb) {
          if (updating && interacting && !pb.hasAttribute('disabled'))
            pb.setAttribute('disabled', '');

          if (!updating && !interacting && pb.hasAttribute('disabled')) {
            setTimeout((chosenSelectionMethod) => {
              if (chosenSelectionMethod === ChosenSelectionMethodOptions.None) {
                pb.removeAttribute('disabled');
              }
            }, 125, chosenSelectionMethod)
          }
        }
        return;
      }
      disableEnableTaxParcelTypesBlock(updating); 
      disableEnableSubjectParcelGroupState(updating); 
    }

    function disableEnableExportToolContainer(disabled) {
      let el = document.getElementById('pao-parcel-export-method-block');
      if (el)
        if (disabled && !el.hasAttribute('disabled')) {
          el.setAttribute('disabled', '');
        } else {
          el.removeAttribute('disabled');
        }
    }

    function disableEnableParcelInputGoButton(disabled) {
      let btn = document.getElementById('pao-parcel-search-go');
      if (btn) {
        let input = document.getElementById('pao-parcel-search-input');
        if (disabled && !btn.hasAttribute('disabled')) {
          btn.setAttribute('disabled', '');
          input.setAttribute('disabled', '');
        }
        if (!disabled && btn.hasAttribute('disabled')) {
          setTimeout(() => {
            btn.removeAttribute('disabled');
            input.removeAttribute('disabled');
          }, 125);
        }
      }
    }

    function disableEnableTaxParcelTypesBlock(disabled) {
      let tb = document.getElementById('pao-taxparceltypes-block');
      if (tb) {
        if (disabled && !tb.hasAttribute('disabled'))
          tb.setAttribute('disabled', '');
        if (disabled && tb.hasAttribute('disabled')) {
          setTimeout(() => {
            tb.removeAttribute('disabled');
          }, 125);
        }
      }
    }

    function disableEnableSlider(disabled) {
      let el = document.getElementById('pao-buffer-slider');
      if (el) {
        if (!disabled) {
          if (el.hasAttribute('disabled')) {
            setTimeout(() => {
              el.removeAttribute('disabled');
            }, 125);
          }
        } else if (!el.hasAttribute('disabled')) {
          el.setAttribute('disabled', '');
        }
      }
    }

    function disableEnableSubjectParcelGroupState(disabled) {
      let el = document.getElementById('pao-subject-parcel-group');
      if (el) {
        if (!disabled) {
          if (el.hasAttribute('disabled'))
            el.removeAttribute('disabled');
        } else {
          el.setAttribute('disabled', '');
        }
      }
    }

    const shellAllowInteractions = async (allow) => {
      try {
        let buffer_controls = getBufferControlItemsByMethod();
        for (let item of buffer_controls) {
          await toggleControlDisabled(item, allow);
        }
      } catch (error) {
        doLogException('shellAllowInteractions', error);
      }
    };

    const toggleControlDisabled = async (item, allow) => {
      let el = document.getElementById(item);
      if (el) allow ? el.removeAttribute('disabled') : el.setAttribute('disabled', '');
    }

    function buildBufferFooter() {
      return new Promise((resolve) => {
        let footer = document.createElement('calcite-block');
        footer.setAttribute('id', 'pao-footer-block');
        footer.setAttribute('heading', ''); 
        footer.setAttribute('heading-level', '6');
        footer.setAttribute('scale', 's');
        footer.setAttribute('hidden', '');
        footer.style.backgroundColor = 'rgba(214, 246, 239, 0.5)';
        footer.style.textAlign = 'left';
        footer.style.borderTopStyle = 'solid';
        footer.style.borderTopColor = 'rgb(233, 233, 233)';
        footer.style.borderBlockStartWidth = '1px';

        if (primaryPanel) primaryPanel.appendChild(footer);
        resolve(true);
      }).catch((error) => {
        doLogException('buildBufferFooter', error);
      });
    }

    function buildComponentContainer() {
      let block = document.createElement('calcite-block');
      block.setAttribute('id', 'pao-component-container');
      block.setAttribute('heading-level', '4');
      block.setAttribute('intl-expand', 'Expand');
      block.setAttribute('intl-collapse', 'Collapse');
      block.setAttribute('hidden', '');

      let flx = document.createElement('div');

      let progress = document.createElement('div');
      progress.setAttribute('class', 'progress progress-label d-none');
      progress.setAttribute('id', 'progress-cbo');
      progress.style.height = '4px';
      progress.style.marginBottom = '2px';
      progress.style.marginLeft = '3px';

      let progressbar = document.createElement('progress-bar');
      progressbar.setAttribute('class', 'progress-bar');
      progressbar.setAttribute('role', 'progressbar');
      progressbar.setAttribute('data-progress', '0');
      progressbar.setAttribute('aria-valuenow', '0');
      progressbar.setAttribute('aria-valuemin', '0');
      progressbar.setAttribute('aria-valuemax', '100');
      progressbar.style.width = '0%';

      progress.appendChild(progressbar);
      flx.appendChild(progress);

      block.appendChild(flx);

      let slot = document.createElement('calcite-icon');
      slot.setAttribute('id', 'pao-component-container-icon');
      slot.setAttribute('scale', 's');
      slot.setAttribute('slot', 'icon');
      slot.setAttribute('icon', 'form-dropdown');
      block.appendChild(slot);

      document.getElementById('pao-buffer-container').appendChild(block);
    }

    function buildTaxParcelTypesComponent() {
      return new Promise((resolve) => {
        getTaxParcelTypes()
          .then((result) => {
            let block = document.createElement('calcite-block');
            let id = 'pao-taxparceltypes-block';
            block.setAttribute('id', id);
            block.setAttribute('heading', 'Filter by tax parcel type');
            block.setAttribute('collapsible', '');
            block.setAttribute('hidden', '');
            block.setAttribute('description', 'Click to open'); 
            block.addEventListener('calciteBlockToggle', (event) => {
              setBlockDescription(
                event.target.id,
                event.target?.open,
                'Click to open'
              );
              let info_el = document.getElementById(`${event.target.id}-info`)
              if (!event.target?.open) {
                if (info_el) {
                  info_el.remove();
                }
              } else {
                if (!info_el) {
                  info_el = buildInfoIconForBlock(event.target.id);
                  document.getElementById(event.target.id).appendChild(info_el);
                }
              }
            });

            let slot = document.createElement('calcite-icon');
            slot.setAttribute('scale', 's');
            slot.setAttribute('slot', 'icon');
            slot.setAttribute('icon', 'filter');
            block.appendChild(slot);

            let list = document.createElement('calcite-list');

            let taxparcelTypes = document.createElement('calcite-pick-list');
            taxparcelTypes.setAttribute('id', 'pao-taxparceltypes-list');
            taxparcelTypes.setAttribute('multiple', '');
            taxparcelTypes.setAttribute('selection-appearance', 'icon');
            taxparcelTypes.setAttribute('scale', 's');
            taxparcelTypes.setAttribute('heading-level', '1');

            taxparcelTypes.addEventListener('calciteListChange', (event) => {
              if (!bufferWasReset) handleTaxParcelTypesChange(event);
            });

            Object.keys(result.features).forEach((key) => {
              let tp = result.features[key].attributes['TAXPARCELTYPE'];
              let item = document.createElement('calcite-pick-list-item');
              item.setAttribute('overlay-positioning', 'absolute');
              item.setAttribute('selected', '');
              item.setAttribute('label', tp);
              item.setAttribute('value', tp);

              let action = document.createElement('calcite-action');
              action.setAttribute(
                'id',
                `${tp.replace(/ /g, '-').toLowerCase() + '-action'}`
              );
              action.setAttribute('slot', 'actions-start');
              action.setAttribute('appearance', 'transparent');

              let span = document.createElement('span');
              span.style.width = '16px';
              span.innerHTML = '&nbsp;'; 
              action.appendChild(span);
              item.appendChild(action);

              taxparcelTypes.appendChild(item);
              list.appendChild(taxparcelTypes);
            });

            if (taxParcelTypesDefaultString === '') {
              let taxParcelTypesArray = [];
              let children = Array.from(list.children[0].children);
              children.forEach((item) => {
                taxParcelTypesArray.push(item.value);
              });

              let ramp = {
                [0]: { rgb: '63,0,125' },
                [1]: { rgb: '251,154,153' },
                [2]: { rgb: '153,52,4' },
                [3]: { rgb: '31,120,180' },
                [4]: { rgb: '26,26,26' },
                [5]: { rgb: '227,26,28' },
                [6]: { rgb: '10,247,199' },
                [7]: { rgb: '166,206,227' },
                [8]: { rgb: '202,178,214' },
                [9]: { rgb: '106,61,154' },
                [10]: { rgb: '255,255,153' },
                [11]: { rgb: '177,89,40' },
                [12]: { rgb: '231,225,239' },
                [13]: { rgb: '201,148,199' },
                [14]: { rgb: '221,28,119' },
                [15]: { rgb: '241,238,246' },
              };

              if (taxParcelTypesArray?.length > 0) {
                let s = taxParcelTypesArray.map((v) => `'${v}'`);
                taxParcelTypesDefaultString = s.join(',');
                taxParcelTypesSelectedString = taxParcelTypesDefaultString;
                taxParcelTypeColors = taxParcelTypesArray.reduce(
                  (acc, cur, idx) => {
                    if (idx > Object.keys(ramp).length) idx--;
                    let obj = {};
                    obj[cur] = `rgba(${ramp[idx].rgb},0.4)`;
                    acc.push(obj);
                    return acc;
                  },
                  []
                );
              }

              children.forEach((item) => {
                item.childNodes.forEach((ch) => {
                  if (ch.nodeName.toLowerCase() === 'calcite-action') {
                    let id = `${item.value.replace(/ /g, '-').toLowerCase() + '-action'
                      }`;
                    if (ch.id === id) {
                      ch.childNodes.forEach((n) => {
                        if (n.nodeName === 'SPAN') {
                          let rgb = taxParcelTypeColors.filter((obj) => {
                            if (obj)
                              if (Object.keys(obj)[0] === item.value)
                                return obj[item.value];
                          });
                          if (rgb && rgb.length > 0)
                            n.style.backgroundColor = rgb[0][item.value];
                          n.style.borderRadius = '50%';
                        }
                      });
                    }
                  }
                });
              });
            }
            block.appendChild(list);
            let panel = document.getElementById('pao-buffer-container');
            if (panel) panel.appendChild(block);

            removeButtonOutline('pao-taxparceltypes-block');

            resolve(true);
          })
          .catch((error) => { doLogException('buildTaxParcelTypesComponent->getTaxParcelTypes', error); });
      });
    }

    function buildSubjectParcelOptions() {
      return new Promise((resolve) => {
        let block = document.createElement('calcite-block');
        block.setAttribute('id', 'pao-subject-parcel-option-block');

        let label = document.createElement('calcite-label');
        label.setAttribute('id', 'pao-subject-parcel-label');
        label.style.fontWeight = 'bolder';

        let rg = document.createElement('calcite-segmented-control');
        rg.setAttribute('id', 'pao-subject-parcel-group');
        rg.setAttribute('width', 'full');
        rg.setAttribute('disabled', '');
        rg.setAttribute('scale', 'm');
        rg.style.marginTop = '2px';
        rg.addEventListener('calciteSegmentedControlChange', (event) => {
          subjectParcelsRadioGroupChanged(event);
        });

        let item = document.createElement('calcite-segmented-control-item');
        item.setAttribute('value', 'include');
        item.setAttribute('icon', 'check-circle');
        item.setAttribute('checked', '');
        item.innerHTML = 'Include';
        rg.appendChild(item);

        item = document.createElement('calcite-segmented-control-item');
        item.setAttribute('value', 'exclude');
        item.setAttribute('icon', 'circle');
        item.innerHTML = 'Exclude';
        rg.appendChild(item);

        block.appendChild(label);
        block.appendChild(rg);

        let panel = document.getElementById('pao-buffer-slider-block');
        if (panel) panel.appendChild(block);

        resolve(true);
      }).catch((error) => { doLogException('buildSubjectParcelOptions', error); });
    }

    function buildBufferUnitsOption() {
      return new Promise((resolve) => {
        let opt = document.createElement('calcite-dropdown');
        opt.setAttribute('id', 'pao-buffer-unit');
        opt.setAttribute('overlay-positioning', 'fixed');
        opt.setAttribute('placement', 'bottom-start');
        opt.setAttribute('type', 'click');
        opt.setAttribute('scale', 'm');
        opt.style.whiteSpace = 'nowrap';
        opt.addEventListener('calciteDropdownSelect', getBufferUnitType);

        let btn = document.createElement('calcite-button');
        btn.setAttribute('slot', 'trigger');
        btn.setAttribute('id', 'pao-buffer-unit-button');
        btn.setAttribute('scale', 'm');
        btn.setAttribute('icon-end', 'chevron-down');
        opt.appendChild(btn);

        let grp = document.createElement('calcite-dropdown-group');
        grp.setAttribute('id', 'pao-buffer-unit-group1');
        grp.setAttribute('selection-mode', 'single');

        let opt_item = document.createElement('calcite-dropdown-item');
        opt_item.setAttribute('id', 'pao-unit-feet');
        opt_item.setAttribute('selected', '');
        opt_item.setAttribute('data-unit-abrv', 'ft');
        opt_item.innerHTML = 'Feet';
        grp.appendChild(opt_item);
        unitType = 'feet'; 


        opt_item = document.createElement('calcite-dropdown-item');
        opt_item.setAttribute('id', 'pao-unit-meters');
        opt_item.setAttribute('data-unit-abrv', 'm');
        opt_item.innerHTML = 'Meters';
        grp.appendChild(opt_item);

        opt_item = document.createElement('calcite-dropdown-item');
        opt_item.setAttribute('id', 'pao-unit-miles');
        opt_item.setAttribute('data-unit-abrv', 'mi');
        opt_item.innerHTML = 'Miles';
        grp.appendChild(opt_item);

        opt_item = document.createElement('calcite-dropdown-item');
        opt_item.setAttribute('id', 'pao-unit-kilometers');
        opt_item.setAttribute('data-unit-abrv', 'km');
        opt_item.innerHTML = 'Kilometers';
        grp.appendChild(opt_item);

        opt.appendChild(grp);
        resolve(opt);
      }).catch((error) => { doLogException('buildBufferUnitsOption', error); });
    }

    function buildInfoIconForBlock(id) {
      let action = document.createElement('calcite-action');
      action.setAttribute('text', 'Information');
      action.setAttribute('icon', 'information');
      action.addEventListener('click', (event) => {
        showInstructionModal(`${id}-info`);
      });
      let slot = document.createElement('div');
      slot.setAttribute('id', `${id}-info`);
      slot.setAttribute('scale', 'm');
      slot.setAttribute('slot', 'control');
      slot.appendChild(action);
      return slot;
    }

    function buildBufferSliderComponent() {
      return new Promise((resolve) => {
        let block = document.createElement('calcite-block');
        let id = 'pao-buffer-slider-block';
        block.setAttribute('id', id);
        block.setAttribute('collapsible', '');
        block.setAttribute('heading', `Buffer Distance`);
        block.setAttribute('hidden', '');
        block.addEventListener('calciteBlockToggle', (event) => {
          sliderBlockStateKeepClosed = event.target?.open === false;
          setBlockDescription(
            event.target.id,
            event.target?.open,
            'Click to open'
          );
          let info_el = document.getElementById(`${event.target.id}-info`)
          if (!event.target?.open) {
            if (info_el) {
              info_el.remove();
            }
          } else {
            if (!info_el) {
              info_el = buildInfoIconForBlock(event.target.id);
              document.getElementById(event.target.id).appendChild(info_el);
            }
          }
        });
        let slot = document.createElement('calcite-icon');
        slot.setAttribute('scale', 's');
        slot.setAttribute('slot', 'icon');
        slot.setAttribute('icon', 'measure');
        block.appendChild(slot);

        let info = buildInfoIconForBlock(id);
        block.appendChild(info);

        let panel = document.getElementById('pao-buffer-container');
        if (panel) {
          panel.appendChild(block);
          buildBufferUnitsOption()
            .then((results) => {
              let p = document.getElementById('pao-buffer-slider-block');
              if (p) p.appendChild(results);
              return true;
            })
            .then(buildSubjectParcelOptions)
            .then(buildBufferSliderScale);
        }
        removeButtonOutline('pao-buffer-slider-block');
        resolve(true);
      }).catch((error) => { doLogException('buildBufferSliderComponent', error); });
    }

    function buildBufferSliderScale() {
      return new Promise((resolve) => {
        let obj = new PaoSliderScale(unitType);
        createBufferSlider(...obj.scale()); 
        resolve(true);
      }).catch((error) => { doLogException('buildBufferSliderScale', error); });
    }

    async function sliderComponentTemplate(obj) {
      try {
        let slider = document.createElement('calcite-slider');
        slider.setAttribute('id', 'pao-buffer-slider');

        if (obj.labelHandles) slider.setAttribute('label-handles', '');
        if (obj.labelTicks) slider.setAttribute('label-ticks', '');

        slider.setAttribute('max', obj.max);
        slider.setAttribute('min-label', obj.minLabel);
        slider.setAttribute('page-step', obj.pageStep);
        slider.setAttribute('step', obj.step);
        slider.setAttribute('ticks', obj.ticks);
        slider.setAttribute('value', obj.value);
        slider.setAttribute('scale', 'm');
        slider.setAttribute('snap', '');

        if (slider.getAttribute('listener') !== 'true') {
          slider.setAttribute('listener', 'true');
          slider.addEventListener('calciteSliderInput', bufferValueChanged);
        }
        return slider;
      } catch (error) {
        return console.error('sliderComponentTemplate: ' + error);
      }
    }

    async function changeBufferSliderValues(obj) {
      try {
        let list = document.getElementById('pao-buffer-slider-list');
        if (list) {
          let new_list = document.createElement('calcite-list');
          new_list.setAttribute('id', 'pao-buffer-slider-list');
          new_list.className = 'd-none';
          let slider = await sliderComponentTemplate(obj);
          new_list.appendChild(slider);
          let panel = document.getElementById('pao-buffer-slider-block');
          if (panel) {
            list.remove();
            new_list.classList.remove('d-none');
            panel.appendChild(new_list);
          }
        }
      } catch (error) {
        doLogException('changeBufferSliderValues', error);
      }
    }

    async function createBufferSlider(obj) {
      try {
        let list = document.createElement('calcite-list');
        list.setAttribute('id', 'pao-buffer-slider-list');
        let slider = await sliderComponentTemplate(obj);
        list.appendChild(slider);
        let panel = document.getElementById('pao-buffer-slider-block');
        if (panel) panel.appendChild(list);
      } catch (error) {
        doLogException('createBufferSlider', error);
      }
    }

    function buildConveyanceComponent(block, conveyanceTypeGIS, conveyanceTypeCBO, url) {
      return new Promise((resolve, reject) => {
        getConveyanceTypesFromGIS(conveyanceTypeGIS, url)
          .then((result) => {
            stepProgressBar();
            fillComboBoxFromResult(block, result, conveyanceTypeCBO, url);
            return true;
          })
          .then(() => {
            resolve(true);
          })
          .catch((error) => {
            toggleProgressBarVisibility(1);
            doLogException(
              'buildConveyanceComponent->getConveyanceTypesFromGIS',
              error
            );
            reject(error);
          });
      }).catch((error) => { doLogException('buildConveyanceComponent', error); });
    }

    const fillComboBoxFromResult = (block, result, comboBoxFor, url) => {
      return new Promise((resolve) => {

        let list = document.createElement('calcite-list');
        list.setAttribute('id', `pao-${comboBoxFor}-list`);
        list.style.height = '170px'; 

        let cbo = document.createElement('calcite-combobox');
        cbo.setAttribute('id', `pao-${comboBoxFor}-cbo`);
        cbo.setAttribute('open', '');
        cbo.setAttribute('selection-mode', 'single');
        cbo.setAttribute('overlay-positioning', 'absolute');
        cbo.setAttribute('visible', '');
        cbo.setAttribute('max-items', '6'); 
        cbo.setAttribute('scale', 's'); 
        cbo.setAttribute('placeholder', `Search ${comboBoxFor}`);
        cbo.addEventListener('calciteComboboxChange', (event) =>
          searchConveyanceFeatures(event, comboBoxFor, url)
        );

        cbo.addEventListener('click', (event) => {
          event.target.open = true;
        });

        Object.keys(result.features).forEach((key) => {
          let item = document.createElement('calcite-combobox-item');
          item.value = result.features[key].attributes['CONVEYANCEDESIGNATOR'];
          let name = result.features[key].attributes['NAME'];

          item.setAttribute('text-label', name);
          cbo.appendChild(item);
        });

        list.appendChild(cbo);
        block.appendChild(list);

        cbo.setFocus();

        let selected_component = document.getElementById('pao-component-container');

        if (selected_component)
          selected_component.description = `${selectedComponentCountLabel(
            result?.features?.length.toLocaleString('en-US')
          )} ${getChosenSelectionMethodName(result?.features?.length > 1)}`;

        resolve(true);

      }).catch((error) => { doLogException('fillComboBoxFromResult', error); });
    };

    function selectedComponentCountLabel(total) {
      return ` ${total}`;
    }

    function labelErrorMessage(element, msg, duration) {
      let el = document.getElementById(element);
      if (el) {
        el.innerHTML = msg;
        el.classList.add('shake');
        setTimeout(() => {
          el.innerHTML = '';
          el.classList.remove('shake');
        }, duration);
      }
    }

    const logKey = (event) => {
      let e = event;
      if (
        $.inArray(e.keyCode, [46, 8]) !== -1 ||
        ((e.keyCode == 65 ||
          e.keyCode == 86 ||
          e.keyCode == 67 ||
          e.keyCode == 88) &&
          (e.ctrlKey === true || e.metaKey === true)) ||
        (e.keyCode >= 35 && e.keyCode <= 40)
      ) {
        return;
      } else {
        if (
          (e.ctrlKey === false || e.metaKey === false) &&
          e.keyCode !== 17 &&
          e.keyCode !== 13 &&
          (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
          (e.keyCode < 96 || e.keyCode > 105)
        ) {
          if (e.cancelable) e.preventDefault();
          labelErrorMessage(
            'pao-parcel-search-notfound',
            'Numbers only.',
            3000
          );
        }
        if (e.key === 'Enter')
          document.getElementById('pao-parcel-search-go').click();
      }
    };

    const getSubmittedParcel = ({ target }) => {
      try {
        if (Object.keys(dgData)?.length >= MAX_DATAGRID_ITEMS)
          return notifyExceededMaxItems();

        let i = document.getElementById('pao-parcel-search-input');
        if (i && i?.value) {
          let n = i.value.trim();
          if (n?.length > 10) {
            labelErrorMessage(
              'pao-parcel-search-notfound',
              'Maximum 10 characters reached.',
              5000
            );
            return false;
          }
        }


        activeAccordionId = ''; 
        let parid = document.getElementById('pao-parcel-search-input');
        if (!(parid?.value.length > 0)) return;
        let val = parid.value.trim();
        parid.value = '';
        global_parid = val;
        paoDetails.context.parid = paoDetails.context.datums.parid = val;
        searchParcel(val);

      } catch (error) {
        doLogException('getSubmittedParcel', error);
      }
    };

    const logKeyPaste = (event) => {
      window.setTimeout(() => {
        let characters = event.target.value;
        window.setTimeout(() => {
          if (!(/^\d+$/.test(characters))) {
            event.target.value = event.target.value.replace(/\D/g, '');
            labelErrorMessage(
              'pao-parcel-search-notfound',
              'Numbers only.',
              3000
            );
          }
        });
      });
    };

    function buildParcelComponent(block) {
      return new Promise((resolve) => {
        let div = document.createElement('div');
        div.setAttribute('id', 'pao-parcel-search-block');

        let label = document.createElement('calcite-label');
        label.innerHTML = 'Search by Parcel ID (Numbers only)';
        label.style.marginBottom = '0';

        let input = document.createElement('calcite-input');
        input.setAttribute('id', 'pao-parcel-search-input');
        input.setAttribute('icon', 'search');
        input.setAttribute('placeholder', 'Enter a Parcel Id');
        input.setAttribute('clearable', '');


        input.setAttribute('maxLength', '10');
        input.setAttribute('value', '');

        input.addEventListener('keydown', logKey);
        input.addEventListener('paste', logKeyPaste);

        let button = document.createElement('calcite-button');
        button.setAttribute('id', 'pao-parcel-search-go');
        button.setAttribute('slot', 'action');
        button.innerHTML = 'GO';
        button.addEventListener('click', getSubmittedParcel);

        input.appendChild(button);
        label.appendChild(input);

        div.appendChild(label);

        let span = document.createElement('span');
        span.setAttribute('id', 'pao-parcel-search-notfound');
        span.setAttribute('class', 'pao-parcel-search-notfound');
        div.appendChild(span);

        block.appendChild(div);
        block.setAttribute('open', '');

        resolve(true);
      })
        .then(determineResetActionState)
        .catch((error) => {
          doLogException('buildParcelComponent', error);
        });
    }

    function buildComponentResetButton(block) {

      let manager = document.createElement('div');
      manager.setAttribute('id', 'pao-control-reset-manager');
      manager.setAttribute('slot', 'control');

      let action = document.createElement('calcite-action');
      action.setAttribute('id', 'pao-control-reset');
      action.setAttribute('icon', 'trash'); 
      action.addEventListener('click', () => {
        resetBufferFilters(0);
      });
      manager.appendChild(action);

      let tooltip = document.createElement('calcite-tooltip');
      tooltip.setAttribute('reference-element', 'pao-control-reset');
      tooltip.setAttribute('overlay-positioning', 'absolute');
      tooltip.setAttribute('placement', 'auto');
      tooltip.setAttribute('label', 'Reset to defaults');
      tooltip.innerHTML = 'Reset to defaults';
      manager.appendChild(tooltip);

      block.appendChild(manager);
    }

    const geometryButtonsClickHandler = (geometryType) => {
      geometryType = geometryType.replace('pao-', '')
      parcelQueryBuffer();
      sketchViewModel.create(geometryType, { mode: 'click' });
      view.map.add(sketchLayer);
    };

    const showTaxParcelTypesList = async () => {
      return new Promise((resolve) => {
        let el = document.getElementById('pao-taxparceltypes-block');
        if (el) {
          el.hidden = false;
        }
        resolve(true);
      }).catch((error) => {
        doLogException('showTaxParcelTypesList', error);
        resolve(false);
      });
    };

    const hideTaxParcelTypesList = () => {
      document
        .getElementById('pao-taxparceltypes-block')
        .setAttribute('hidden', '');
    };

    const showComponentContainer = async () => {
      let el = document.getElementById('pao-component-container');
      if (el) el.removeAttribute('hidden');
    };

    const hideComponentContainer = async () => {
      try {
        let el = document.getElementById('pao-component-container');
        if (el) {
          el.setAttribute('hidden', '');
          if (el.hasChildNodes()) {
            let node = el.querySelector(`#pao-${chosenConveyanceType}-list`);
            node?.remove();
          }
        }
      } catch (error) {
        doLogException('hideComponentContainer', error);
      }
    };

    const showParcelSubjectOptions = () => {
      let el = document.getElementById('pao-subject-parcel-option-block');
      if (el) {
        el.removeAttribute('hidden');
        el.setAttribute('open', '');
      }
    };

    const updateSubjectParcelLabel = (obj = null) => {
      try {
        let i = subjectParcels?.rows?.length;
        disableEnableSubjectParcelGroupState(!(i > 0)); 

        let label = 'No subject parcels found.';
        if (!obj)
          obj = document.querySelectorAll('#pao-subject-parcel-group>calcite-segmented-control-item[checked]')[0];

        let p = i > 1 ? 's' : '';
        label = `${obj.innerHTML} ${subjectParcels?.rows?.length} subject parcel${p}.`;
        document.getElementById('pao-subject-parcel-label').innerHTML = label;
      } catch (error) {
        doLogException('updateSubjectParcelLabel', error);
      }
    };

    const getChosenBufferUnitTypeAbbrv = () => {
      return new Promise((resolve) => {
        let g = document.getElementById('pao-buffer-unit-group1');
        if (g) {
          getBufferUnitAbbreviation(g)
            .then((result) => {
              resolve(result);
            })
        }
      }).catch((error) => {
        doLogException('getChosenBufferUnitTypeAbbrv', error);
        resolve(false);
      });
    };

    async function getBufferUnitType(event) {
      try {
        updateBufferSliderButtonLabel();
        let id = document.getElementById('pao-buffer-unit');
        if (id) {
          let _unitLabel = event.target.selectedItems[0].innerHTML;
          dgData[activeDataAccordionItem].unitTypeAbbrv = event.target.selectedItems[0].attributes['data-unit-abrv'].value;
          await updateAccordionItemDescription();
          let oldVal = unitType;
          unitType = _unitLabel.toLowerCase();
          updateSliderScaleUnits(_unitLabel, oldVal);
        }
      } catch (error) {
        doLogException('getBufferUnitType', error);
      }
    }

    const getBufferUnitAbbreviation = (el) => {
      return new Promise((resolve) => {
        let tmp = '';
        let items = el.querySelectorAll('calcite-dropdown-item');
        let i = Array.from(items).findIndex(x => x.selected);
        if (i > -1)
          tmp = el.querySelectorAll('calcite-dropdown-item')[i].attributes['data-unit-abrv'].value;

        resolve(tmp);

      }).catch((error) => {
        doLogException('getBufferUnitAbbreviation', error);
        resolve(false);
      });
    };

    function updateSliderScaleUnits(_unitType, oldType) {
      let slider = document.getElementById('pao-buffer-slider');
      if (slider) {
        let obj = new PaoSliderScale(_unitType);
        changeBufferSliderValues(...obj.scale());
        bufferSize = obj.convert(_unitType, oldType, bufferSize);
        bufferSize = fixedBufferSizeScale(bufferSize);
        let el = document.getElementById('pao-buffer-slider');
        el.value = bufferSize;
      }
    }

    async function resetBufferUnit() {
      try {
        let oldVal = unitType;

        document.querySelector('#pao-buffer-unit').remove();
        let results = await buildBufferUnitsOption();
        let p = document.getElementById('pao-buffer-slider-block');
        if (p) p.insertBefore(results, p.firstChild);

        updateSliderScaleUnits(unitType, oldVal);
      } catch (error) {
        doLogException('resetBufferUnit', error);
      }
    }

    function fixedBufferSizeScale(value) {
      if (value === Math.floor(value)) {
      } else {
        return parseFloat((Math.floor(value * 100) / 100).toFixed(2));
      }
      return value;
    }

    function generateRenderer() {
      let p1 = new Promise((resolve) => {
        event.target
          .getSelectedItems()
          .then((elements) => {
            if (elements.size > 0) {
              const iterator1 = elements.values();
              userSelectedMethod = iterator1.next().value;

              let id = userSelectedMethod.id;

              bufferWasReset = false;

              document.getElementById('pao-parcel-export-method-block').setAttribute('disabled', '');

              document.getElementById('pao-parcel-export-method-block').setAttribute('collapsible', '');

              let block = document.getElementById('pao-component-container');

              switch (id) {
                case 'pao-point':
                case 'pao-polygon':
                case 'pao-rectangle':
                  chosenSelectionMethod = ChosenSelectionMethodOptions.Sketch;
                  block.description = 'Click your subject parcel on map.';
                  break;
                case 'pao-by-parid':
                  chosenSelectionMethod = ChosenSelectionMethodOptions.ParcelId;
                  block.description = ' ';
                  distanceConstraintSet = false; 
                  break;
                case 'pao-by-condo':
                  chosenSelectionMethod = ChosenSelectionMethodOptions.Condominium;
                  break;
                case 'pao-by-coop':
                  chosenSelectionMethod = ChosenSelectionMethodOptions.Cooperative;
                  break;
                case 'pao-by-subdv':
                  chosenSelectionMethod = ChosenSelectionMethodOptions.Subdivision;
                  break;
              }

              if (chosenSelectionMethod !== ChosenSelectionMethodOptions.None) {

                block.setAttribute('heading', `${userSelectedMethod.label} selected`);

                let reset = document.getElementById('pao-control-reset-manager');
                if (!reset) buildComponentResetButton(block);

                chosenMethodTextLabel = userSelectedMethod.label;

                let conveyanceTypeGIS = '';
                let url = '';
                let content_title = '';
                let content_text = '';
                let notice_text = '';
                disableViewConstraintZoom();

                switch (id) {
                  case 'pao-point':
                  case 'pao-polygon':
                  case 'pao-rectangle':
                    chosenMethodValue = `${id.toLowerCase()}`; 
                    activeDataAccordionItem = `pao-accordion-item-${id.toLowerCase()}`;
                    geometryButtonsClickHandler(id.replace('pao-', ''));
                    break;
                }

                switch (id) {
                  case 'pao-by-condo':
                    chosenSelectionMethod =
                      ChosenSelectionMethodOptions.Condominium;
                    conveyanceTypeGIS = 'Condominium';
                    chosenConveyanceType = ConveyanceTypes.Condominiums;
                    url = condominiumsUrl;
                    break;
                  case 'pao-by-coop':
                    chosenSelectionMethod =
                      ChosenSelectionMethodOptions.Cooperative;
                    conveyanceTypeGIS = 'Cooperative';
                    chosenConveyanceType = ConveyanceTypes.Cooperatives;
                    url = cooperativesUrl;
                    break;
                  case 'pao-by-subdv':
                    chosenSelectionMethod =
                      ChosenSelectionMethodOptions.Subdivision;
                    conveyanceTypeGIS = 'Subdivision';
                    chosenConveyanceType = ConveyanceTypes.Subdivisions;
                    url = subdivisionsUrl;
                    break;
                  case 'pao-by-parid':
                    chosenSelectionMethod = ChosenSelectionMethodOptions.ParcelId;
                    buildParcelComponent(block);
                    break;
                }

                switch (id) {
                  case 'pao-by-condo':
                  case 'pao-by-coop':
                  case 'pao-by-subdv':
                    currentProgressBar = 'progress-cbo';
                    totalProgressSteps = 7;
                    toggleProgressBarVisibility(1);
                    stepProgressBar();
                    block.setAttribute('open', '');
                    buildConveyanceComponent(
                      block,
                      conveyanceTypeGIS,
                      chosenConveyanceType,
                      url
                    )
                      .then(() => {
                        resolve(true);
                      })
                      .catch((error) => {
                        doLogException('buildConveyanceComponent->renderToolEvent', error);
                        stepProgressBar(true);
                      });
                    break;
                  default:
                    resolve(true);
                }

              }
            }
          });
      });

      p1.then((result) => {
        if (!setupDataTableFlag) setupDataTable();
        document.getElementById('pao-parcel-export-method-block').removeAttribute('open');
        showComponentContainer();
        determineResetActionState();
        stepProgressBar(true);
      });
      p1.catch((result) => {
        doLogException('renderToolEvent', error);
      });
    }


    const zoomConstraints = (zoom) => {
      view.constraints.minZoom = zoom;        
    }

    const enableViewConstraintZoom = () => {
      view.constraints.minScale = view.scale;
      view.constraints.minZoom = view.zoom; 
      view.constraints.maxZoom = view.zoom; 
      view.ui.components = ["attribution"]  
    }
    const disableViewConstraintZoom = () => {
      view.constraints = {};
      view.ui.components = ["attribution", "zoom"]
      zoomIsFar = false;
    }

    const gotoZoom = async (zoom) => {
      return new Promise((resolve) => {

        view.goTo({
          target: view.extent,
          zoom: zoom
        }, animationOptions)
          .then(() => {
            resolve(true);
          });

      }).catch((error) => {
        doLogException('gotoZoom', error);
        resolve(false);
      });
    };

    const closeModal = () => {
      modalActive = false;
      document.querySelector('[id=pao-modal]')?.remove();
    };

    const getChosenMethodTextLabel = (value) => {
      switch (chosenSelectionMethod) {
        case ChosenSelectionMethodOptions.ParcelId:
          return `Parcel ${value}`;
        case ChosenSelectionMethodOptions.Condominium:
        case ChosenSelectionMethodOptions.Cooperative:
        case ChosenSelectionMethodOptions.Sketch:
        case ChosenSelectionMethodOptions.Subdivision:
          return chosenMethodTextLabel;
        default:
          return '';
      }
    };

    const confirmDeleteModal = (id) => {
      if (id != null) {
        id = id.replace('trash-', '');

        let subject = getChosenSelectionMethodName();

        if (chosenSelectionMethod === ChosenSelectionMethodOptions.ParcelId)
          subject = id.replace('accd-', '');

        let label = getChosenMethodTextLabel(subject);

        let modal = document.createElement('calcite-modal');
        modal.setAttribute('aria-labelledby', 'modal-title');
        modal.setAttribute('id', 'pao-modal');
        modal.setAttribute('width', 's');
        modal.setAttribute('open', '');

        let slot = document.createElement('div');
        slot.setAttribute('slot', 'header');
        slot.setAttribute('id', 'modal-title');
        slot.innerHTML = `Delete Buffer Data`;
        modal.appendChild(slot);

        let content_slot = document.createElement('div');
        content_slot.setAttribute('slot', 'content');
        content_slot.style.color = 'var(--calcite-ui-text-1)';
        content_slot.innerHTML = `Are you sure you want to delete ${label} results?`;

        let img = document.createElement('img');
        img.setAttribute('src', '');
        img.style.border = '0';
        img.style.width = '40';
        img.style.height = '40';
        content_slot.appendChild(img);
        modal.appendChild(content_slot);

        let button = document.createElement('calcite-button');
        button.setAttribute('slot', 'secondary');
        button.setAttribute('width', 'full');
        button.innerHTML = 'Cancel';
        button.addEventListener('click', closeModal);
        modal.appendChild(button);

        button = document.createElement('calcite-button');
        button.setAttribute('slot', 'primary');
        button.setAttribute('width', 'full');
        button.innerHTML = 'Ok';
        button.addEventListener(
          'click',
          () => {
            deleteAccordionItem(id);
          },
          false
        );
        modal.appendChild(button);

        let shell = document.getElementById('pao-shell');
        if (shell) shell.appendChild(modal);
      }
    };


    const showInstructionModal = async (id) => {
      try {
        closeModal();
        modalActive = true;

        await shellAllowInteractions(false);

        let content = await user_instructions_content(id);

        let modal = document.createElement('calcite-modal');
        modal.setAttribute('aria-labelledby', 'modal-title');
        modal.setAttribute('id', 'pao-modal');
        modal.setAttribute('focus-trap-disabled', '');
        modal.setAttribute('width', 'm');
        modal.setAttribute('open', '');
        modal.addEventListener(
          'calciteModalClose',
          async () => {
            closeModal();
            await shellAllowInteractions(true);
          },
          false
        );

        let slot = document.createElement('div');
        slot.setAttribute('slot', 'header');
        slot.setAttribute('id', 'modal-title');
        slot.innerHTML = content.title;
        modal.appendChild(slot);

        let content_slot = document.createElement('div');
        content_slot.setAttribute('slot', 'content');
        content_slot.style.color = 'rgb(21, 21, 21)';
        content_slot.innerHTML = content.text;

        let notice = document.createElement('calcite-notice');
        notice.setAttribute('open', '');
        notice.setAttribute('width', 'full');

        let link = document.createElement('calcite-link');
        link.setAttribute('icon-end', 'launch');
        link.setAttribute('rel', 'help');
        link.setAttribute('target', '_blank');
        link.setAttribute('href', content.href);
        link.innerHTML = `${content.linkText}.`;

        slot = document.createElement('div');
        slot.setAttribute('slot', 'message');
        slot.innerHTML = `Step-by-step <b><a href='/label-requests/' target='_blank' alt='Step-by-step 2-minute tutorial videos'>2-minute tutorial video</a></b>`;
        notice.appendChild(slot);
        content_slot.appendChild(notice);

        let img = '';

        let fragment = document.createDocumentFragment();
        let dv = document.createElement('div');
        dv.style.display = 'inline-block';

        content.images.forEach((item) => {
          img = `<br /><img slot="thumbnail" src="/wp-content/themes/frontier-child/images/${item.image}" alt="${item.label}" width="268px">`
          slot = document.createElement('div');
          slot.setAttribute('slot', 'message');
          slot.innerHTML = `${img}`;
          dv.appendChild(slot);
          fragment.appendChild(dv);
        })
        content_slot.appendChild(fragment);


        modal.appendChild(content_slot);

        let button = document.createElement('calcite-button');
        button.setAttribute('slot', 'secondary');
        button.setAttribute('width', 'full');
        button.setAttribute('appearance', 'outline');
        button.innerHTML = 'Cancel';
        button.addEventListener(
          'click',
          async () => {
            closeModal();
            await shellAllowInteractions(true);
          },
          false
        );
        modal.appendChild(button);

        if (content.showStart) {
          button = document.createElement('calcite-button');
          button.setAttribute('slot', 'primary');
          button.setAttribute('width', 'full');
          button.innerHTML = 'Start';
          button.addEventListener(
            'click',
            async () => {
              await closeModal();
              await shellAllowInteractions(true);
            },
            false
          );
          modal.appendChild(button);
        }
        let shell = document.getElementById('pao-shell');
        if (shell) shell.appendChild(modal);
      } catch (error) {
        doLogException('showInstructionModal', error);
      }
    };

    const handleTaxParcelTypesChange = async (event) => {
      taxParcelTypesSelectedString = '';
      const selectedItems = event.currentTarget.querySelectorAll('calcite-pick-list-item');
      const selectedKeys = [];
      if (selectedItems?.length > 0) {
        selectedItems.forEach((e) => {
          if (e.selected)
            selectedKeys.push(e.attributes.value.value);
        });
        let s = selectedKeys.map((v) => `'${v}'`);
        taxParcelTypesSelectedString = s.join(',');
      }
      queryLayerView();
    };

    const accordionLabelText = () => {
      let msg = '';
      let item = '';

      switch (chosenSelectionMethod) {
        case ChosenSelectionMethodOptions.Condominium:
        case ChosenSelectionMethodOptions.Cooperative:
        case ChosenSelectionMethodOptions.Subdivision:
          item = `${userSelectedMethod.label.toLowerCase()}`;

          msg = `First, choose a ${item} from the list of available ${item}s. The map will automatically locate and move the ${item} into focus. 
								Next, drag the buffer slider to find adjacent parcels at your desired distance. 
								The map highlights the parcels according to type. Use the filter to exclude parcel types.`;
          break;
        case ChosenSelectionMethodOptions.Sketch:
          item = `${userSelectedMethod.value}`;
          msg = `Place the sketch ${item} on your parcel of interest, then drag the buffer slider to find adjacent parcels at your desired distance. 
								The map highlights the parcels according to type. Use the filter to exclude parcel types.`;
          break;
        case ChosenSelectionMethodOptions.ParcelId:
          msg = `Entery the parcel number in the text box and click GO., then drag the buffer slider to find adjacent parcels at your desired distance. 
								The map highlights the parcels according to type. Use the filter to exclude parcel types.`;
          break;
      }
      msg = 'Results will appear here.';
      return msg;
    };

    const buildToolbarItemTrash = () => {

      let container = null;

      if (chosenSelectionMethod === ChosenSelectionMethodOptions.ParcelId) {
        container = document.createElement('div');
        container.setAttribute(
          'class',
          'pao-buffer-data-tools-container tools-right'
        );

        let action = document.createElement('calcite-action');
        action.setAttribute('id', `trash-${activeDataAccordionItem}`);
        action.setAttribute('scale', 's');
        action.setAttribute('alignment', 'end');
        action.setAttribute('text-enabled', '');
        action.setAttribute('text', 'Delete');
        action.setAttribute('icon', 'trash');
        action.style.cursor = 'pointer';
        action.addEventListener('click', (event) => {
          let target = event.currentTarget;
          confirmDeleteModal(target.id);
        });
        container.appendChild(action);
      }
      return container;
    };

    const buildToolbar = () => {

      let container = document.createElement('div');
      container.setAttribute(
        'class',
        'pao-buffer-data-tools-container tools-right'
      );


      let btn = document.createElement('calcite-button');
      btn.setAttribute('id', `export-pdf-${activeDataAccordionItem}`);
      btn.setAttribute('alignment', 'center');
      btn.setAttribute('appearance', 'solid');
      btn.setAttribute('icon-start', 'file-pdf');
      btn.innerHTML = 'Save as PDF';
      btn.style.cursor = 'pointer';
      btn.style.marginRight = '3px';
      btn.setAttribute('scale', 's');
      btn.addEventListener('click', (event) => {
        exportToFile(event, 'PDF', true);
      });
      container.appendChild(btn);


      btn = document.createElement('calcite-button');
      btn.setAttribute('id', `export-csv-${activeDataAccordionItem}`);
      btn.setAttribute('alignment', 'center');
      btn.setAttribute('appearance', 'solid');
      btn.setAttribute('icon-start', 'file-csv');
      btn.innerHTML = 'Save as CSV';
      btn.style.cursor = 'pointer';
      btn.style.marginRight = '3px';
      btn.setAttribute('scale', 's');
      btn.addEventListener('click', (event) => {
        exportToFile(event, 'CSV', true);
      });
      container.appendChild(btn);
      return container;
    };

    function containerInstructions(id) {

      let tip = 'Start to measure by clicking in the map to place your first point. Dragging the map is not available during measuring. Zoom is enabled.';

      switch (id) {
        case 0:
          return 'Buffer parcels and create mailing labels';
          break;
        case 1:
          return 'Prior year aerials';
          break;
        case 'measuredist':
          return `Calculate and display the distance between two or more points.\n${tip}\nUse the erase button to remove the current measurements.`;
          break;
        case 'measurearea':
          return `Calculate and display the area and perimeter of a polygon.\n${tip}\nUse the erase button to remove the current measurements.`;
          break;
        case 'print':
          return 'Print.';
          break;
      }
    }

    function createDownloadLinkCsv(data, fileName) {
      return new Promise((resolve, reject) => {
        try {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            let blob = new Blob([data], { type: 'text/csv' });
            window.navigator.msSaveOrOpenBlob(blob, fileName);
            return;
          } else {
            let blob = new Blob([data], { type: 'text/csv' });
            let blobURL = URL.createObjectURL(blob, fileName);
            setTimeout(() => {
              downloadFile(blobURL);
              window.URL.revokeObjectURL(blobURL);
            }, 1000);
            window.downloadFile = (url) => {
              if (
                window.downloadFile.isChrome ||
                window.downloadFile.isSafari ||
                window.downloadFile.isNetscape
              ) {
                let link = document.createElement('a');
                link.href = url;
                link.setAttribute('target', '_blank');

                if (link.download !== undefined) {
                  link.download = fileName;
                  link.innerHTML = fileName;
                }
                if (document.createEvent) {
                  let event = new MouseEvent('click', {
                    bubbles: true,
                    cancelable: true,
                    view: window,
                  });
                  link.dispatchEvent(event);
                  resolve(true);
                  return true;
                }
              } 
              if (url.indexOf('?') === -1) {
                url += '?download';
              }
              window.open(url, '_blank');
              resolve(true);
              return true;
            };
            window.downloadFile.isChrome = checkDeviceBrand('Chromium');
            window.downloadFile.isSafari = checkDeviceBrand('Safari');
            window.downloadFile.isNetscape = checkDeviceBrand('Firefox');
          }
        } catch (error) {
          doLogException('createDownloadLinkCsv', error);
          reject(error);
          return false;
        }
      }).catch((error) => { doLogException('createDownloadLinkCsv', error); });
    } 

    function createDownloadLinkPdf(data, fileName) {
      return new Promise(function (resolve, reject) {
        try {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            let blob = new Blob([data], { type: 'application/pdf' });
            window.navigator.msSaveOrOpenBlob(blob, fileName);
            return;
          } else {
            let blob = new Blob([data], { type: 'application/pdf' });
            let blobURL = URL.createObjectURL(blob, fileName);
            setTimeout(() => {
              downloadFile(blobURL);
              window.URL.revokeObjectURL(blobURL);
            }, 1000);
            window.downloadFile = (url) => {
              if (
                window.downloadFile.isChrome ||
                window.downloadFile.isSafari ||
                window.downloadFile.isNetscape
              ) {
                let link = document.createElement('a');
                link.href = url;
                link.setAttribute('target', '_blank');

                if (link.download !== undefined) {
                  link.download = fileName;
                  link.innerHTML = fileName;
                }
                if (document.createEvent) {
                  let event = new MouseEvent('click', {
                    bubbles: true,
                    cancelable: true,
                    view: window,
                  });
                  link.dispatchEvent(event);
                  resolve(true);
                  return true;
                }
              } 
              if (url.indexOf('?') === -1) {
                url += '?download';
              }
              window.open(url, '_blank');
              resolve(true);
              return true;
            };
            window.downloadFile.isChrome = checkDeviceBrand('Chromium');
            window.downloadFile.isSafari = checkDeviceBrand('Safari');
            window.downloadFile.isNetscape = checkDeviceBrand('Firefox');
          }
        } catch (error) {
          doLogException('createDownloadLinkPdf', error);
          reject(error);
          return false;
        }
      }).catch((error) => {
        doLogException('createDownloadLinkPdf', error);
      });
    } 

    function isParcelRural(lat, lon) {
      let i = lon.toFixed(6) * -1;
      let is_rural = i < 82.306223 && i > 82.049964;
      return is_rural;
    }

    function toggleDistanceConstraints(tf) {
      let g = document.getElementById('pao-buffer-unit-group1');
      g.querySelectorAll('calcite-dropdown-item').forEach((p) => {
        if (p.id === 'pao-unit-miles' || p.id === 'pao-unit-kilometers')
          !tf ? p.classList.add('d-none') : p.classList.remove('d-none');
      });
      if (tf)
        view.constraints.minZoom = view.constraints.minZoom - 4;

      distanceConstraintSet = true;
    }

    function getBlobArray(options) {
      return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        xhr.open(options.method, options.url, true);
        xhr.responseType = 'arraybuffer';
        xhr.onload = () => {
          if (xhr?.status >= 200 && xhr?.status < 300) {
            let responseArray = new Uint8Array(xhr.response);
            resolve(responseArray);
          } else {
            reject({
              status: xhr?.status,
              statusText: xhr?.statusText,
            });
          }
        };
        xhr.onerror = () => {
          reject({
            status: xhr?.status,
            statusText: xhr?.statusText,
          });
        };
        if (options.headers) {
          Object.keys(options.headers).forEach((key) => {
            xhr.setRequestHeader(key, options.headers[key]);
          });
        }
        let paramsObject = options.params;
        xhr.send(paramsObject);
      }).catch((error) => { doLogException('getBlobArray', error); });
    }

    function getDistinctAddressesByParid(options) {
      return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        xhr.open(options.method, options.url, true);
        xhr.responseType = 'json';
        xhr.onload = () => {
          if (xhr?.status >= 200 && xhr?.status < 300) {
            resolve(xhr.response);
          } else {
            reject({
              status: xhr?.status,
              statusText: xhr?.statusText,
            });
          }
        };
        xhr.onerror = () => {
          reject({
            status: xhr?.status,
            statusText: xhr?.statusText,
          });
        };
        if (options.headers) {
          Object.keys(options.headers).forEach((key) => {
            xhr.setRequestHeader(key, options.headers[key]);
          });
        }
        let paramsObject = options.params;
        xhr.send(paramsObject);
      }).catch((error) => { doLogException('getDistinctAddressesByParid', error); });
    }

    function exportLabels(json, contentType) {
      return new Promise((resolve, reject) => {
        stepProgressBar();

        let http = '/wp-content/themes/frontier-child/models';
        let url = '';

        switch (contentType.toUpperCase()) {
          case 'CSV':
            url = `${http}/pao-model-bulklabels.php`;
            break;
          default:
            url = `${http}/pao-model-bulkmail.php`;
        }
        getBlobArray({
          url: url,
          method: 'POST',
          params: json,
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
          },
        })
          .then((data) => {
            let obj = JSON.parse(json);
            let p1 = new Promise((resolve, reject) => {
              if (contentType === 'CSV') {
                resolve(createDownloadLinkCsv(data, obj.file_name));
              } else {
                resolve(createDownloadLinkPdf(data, obj.file_name));
              }
            });
            p1.then((result) => {
              stepProgressBar();
              resolve(result);
            });
            p1.catch((result) => {
              doLogException('exportLabels', error);
              reject(result);
            });
          })
          .catch((result) => {
            doLogException('exportLabels', error);
            reject(result);
          });
      }).catch((error) => doLogException('exportLabels', error));
    }

    async function distinctAddressCount(json) {
      return new Promise((resolve, reject) => {

        let http = '/wp-content/themes/frontier-child/models';
        let url = `${http}/pao-model-unique-addresses-by-parid.php`;

        getDistinctAddressesByParid({
          url: url,
          method: 'POST',
          params: json,
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
          },
        })
          .then((data) => {
            let i = data;
            if (!i) i = 0;
            resolve(i);
          })
          .catch((result) => {
            console.log(result)
            reject(result);
          });
      }).catch((error) => doLogException('distinctAddressCount', error));
    }

    const _bufferWidget = {
      close: function () {
        resetBufferFilters(0);

        activeWidget.lastActiveButton = 'bufferButton';
        activeWidget.state = 'inactive';

        document.querySelector('#pao-buffer-container').active = false;
        document.querySelector('#pao-buffer-container').hidden = true;
        document.querySelector('#pao-footer-block').hidden = true;
        document.querySelector('#pao-buffer-container').removeAttribute('indicator');

        bufferButton.classList.add('esri-icon-review');
        bufferButton.classList.remove('esri-icon-trash');

        resetActiveWidgetObject();

        toggleSearchWidget({ show: paoDetails.gis.displayPage === 'fullaerial' });

        this.title(bufferWidgetInactiveTitle);
      },
      open: function () {

        closeVisiblePopup();

        closeLastActiveWidget();

        bufferButton.classList.remove('esri-icon-review');
        bufferButton.classList.add('esri-icon-trash');
        bufferButton.classList.add('active');
        activeWidget.buttonId = 'bufferButton';

        activeWidget.containerId = 'pao-buffer-container';
        activeWidget.worksMinimized = false;
        activeWidget.showTitleBar = true;

        view.ui.move({ component: 'zoom', position: 'top-right', index: 1 });


        this.title('Click or use escape to cancel mailing labels/list.');

        let id = activeWidget?.containerId;
        if (id?.length > 0) {
          let el = document.getElementById('pao-buffer-container');
          if (el) {
            el.active = true;
            el.hidden = false;
            el.setAttribute('indicator', '');
          }
          el = document.querySelector('#pao-footer-block');
          if (el) el.hidden = false;
        }

        activeWidget.state = 'active';

        toggleSearchWidget({ show: true });

      },
      title: function (title) {
        bufferButton.setAttribute('title', title);
        bufferButton.setAttribute('aria-label', title);
      },
    };

    const watchMeasure = (_widget) => {


      let dragEventObject = null;
      let activeMeasureLastState = null;

      reactiveUtils.watch(
        () => [
          _widget?.viewModel?.activeViewModel?.active,
          _widget?.viewModel?.activeViewModel?.state,
          _widget?.activeTool
        ],
        ([active, state, activeTool]) => {

          if (active && state === 'measuring') {
            let el = document.querySelector(`.esri-${activeTool}-measurement-2d__container`);
            if (el) el.parentElement.hidden = true;

            activeMeasureLastState = state;
          }
          if (!dragEventObject && (active && state === 'ready')) {

            let hint_class = null;
            let hint_text = '';

            if (activeTool === 'area') {
              hint_text = `To measure an area, touch the map to add two or more points to create a polygon (do not drag the point). Double tap on your final point to complete the polygon.`;
            }
            if (activeTool === 'distance') {
              hint_text = `To measure a distance, touch the map to add two or more points for a straight or segmented line (do not drag the point). Double tap on your final point to complete the line.`;
            }
            if (hint_text.length > 0) {
              setTimeout(() => {
                hint_class = `esri-${activeTool}-measurement-2d__hint-text`;
                let el = document.querySelector(`.${hint_class}`);
                if (el) el.innerText = hint_text;
              }, 100);
            }

            const stopEvtPropagation = (event) => {
              event.stopPropagation();
            };
            dragEventObject = view.on('drag', stopEvtPropagation);
          }
          if (!active && state === 'measured' || state === 'disabled') {

            if (state === 'measured') {
              let el = document.querySelector(`.esri-${activeTool}-measurement-2d__container`);
              if (el) el.parentElement.hidden = false;
            }
            dragEventObject?.remove();
            dragEventObject = null;
          }
        });
    }


    let pointerType = 'mouse';
    let swipeTimerHandle;

    mapEl.addEventListener('touchstart', e => {
      pointerType = 'touch';
      [...e.changedTouches].forEach(touch => {

        if (e.target instanceof HTMLCanvasElement) {
          if (e.type === 'touchstart' && e.touches.length === 1) {

            let state = measurement?.viewModel?.activeViewModel?.state;

            if (e.currentTarget.classList.contains('measure-canceled')) {
              e.currentTarget.classList.remove('measure-canceled');
              return;
            }
            if (state === 'ready') {
              enableViewConstraintZoom();
            }
          }
        }
      })
    })
    mapEl.addEventListener('touchmove', (e) => {
      [...e.changedTouches].forEach(touch => {
        if (e.target instanceof HTMLCanvasElement) {
          if (e.type === 'touchmove' && e.touches.length > 0) {

            let state = measurement?.viewModel?.activeViewModel?.state;
            let activeTool = measurement?.activeTool;

            if (!state) {
              if (e.touches.length > 1)
                e.currentTarget.classList.add('swiping');
            }


            if (state === 'ready') {

              let hint_text = '';
              if (activeTool === 'area') {
                _areaMeasureWidget.close();
                hint_text = `1. To measure an area, create a polygon by placing points on the map
                  <br />2. Ensure your entire subject is visible 
                  <br />3. Select the Area Measurement widget
                  <br />4. Touch the map to add two or more points. <u>Do not drag the point</u>
                  <br />5. Double tap on your final point to complete the polygon`;
              }
              if (activeTool === 'distance') {
                _distanceMeasureWidget.close();
                hint_text = `1. To measure a distance, create a straight or segmented line on your subject property
                <br />2. Pan the map to ensure your entire subject is visible
                <br />3. Select the Distance Measurement Widget
                <br />4. Touch the map to add two or more points. <u>Do not drag the point</u>
                <br />5. Double tap on your final point to complete the line`;
              }
              let msg = `<span style='color:red;'>The map may not be moved, pinched, or rotated during an active measurement.</span><br />${hint_text}`;
              const firstLetter = activeTool?.charAt(0);
              const firstLetterCap = firstLetter?.toUpperCase();
              const remainingLetters = activeTool?.slice(1);
              const title_tool = firstLetterCap + remainingLetters;

              e.currentTarget.classList.add('measure-canceled');

              let evt = e.currentTarget;
              setTimeout(() => {
                evt.classList.remove('measure-canceled');
              }, 6000);

            }
          }
          if (e.type === 'touchmove' && e.touches.length > 1) {
            clearTimeout(swipeTimerHandle);
            e.currentTarget.classList.remove('swiping');
          }
        }
      })
    })
    mapEl.addEventListener('touchend', e => {
      [...e.changedTouches].forEach(touch => {
        if (e.target instanceof HTMLCanvasElement) {

          if (swipeTimerHandle)
            clearTimeout(swipeTimerHandle);

          e.currentTarget.classList.remove('swiping');
          e.currentTarget.classList.remove('zooming');

          let state = measurement?.viewModel?.activeViewModel?.state;

          let allowed = ['measured', 'disabled'];
          if (state?.includes(allowed)) {
            disableViewConstraintZoom();
          }
        }
      })
    })

    const _distanceMeasureWidget = {
      close: function () {

        measurement.clear();

        disableViewConstraintZoom();

        activeWidget.lastActiveButton = 'distanceButton';

        document.querySelector('#distanceButton').active = false;
        document.querySelector('#distanceButton').classList.remove('active');
        document.querySelector('#distanceButton').removeAttribute('indicator');

        document
          .querySelector('#distanceButton')
          .classList.remove('esri-icon-trash');
        document
          .querySelector('#distanceButton')
          .classList.add('esri-icon-measure-line');

        if (measure_widget) {
          view.ui.remove(measure_widget);
          if (measure_widget?.constructed) widget.destroy();
          measure_widget = null;
        }

        resetActiveWidgetObject();

        this.title('Measure the distance between two or more points.');
      },
      open: function () {

        enableViewConstraintZoom();

        initMeasureWidget('distance', 'feet');

        closeVisiblePopup();

        closeLastActiveWidget();

        distanceButton.classList.remove('esri-icon-measure-line');
        distanceButton.classList.add('esri-icon-trash');
        distanceButton.classList.add('active');
        $('div.esri-component.esri-area-measurement-2d.esri-widget.esri-widget--panel').hide();

        activeWidget.containerId = activeWidget.buttonId = 'distanceButton';
        activeWidget.worksMinimized = true;

        view.focus();

        this.title('Click or use escape to cancel measurement.');

        activeWidget.state = 'active';

        watchMeasure(measurement);
      },
      title: function (title) {
        distanceButton.setAttribute('title', title);
        distanceButton.setAttribute('aria-label', title);
      },
    };

    const _areaMeasureWidget = {
      close: function () {

        measurement.clear();

        disableViewConstraintZoom();

        activeWidget.lastActiveButton = 'areaButton';

        document.querySelector('#areaButton').active = false;
        document.querySelector('#areaButton').classList.remove('active');
        document.querySelector('#areaButton').removeAttribute('indicator');

        document.querySelector('#areaButton').classList.remove('esri-icon-trash');
        document.querySelector('#areaButton').classList.add('esri-icon-measure-area');

        resetActiveWidgetObject();

        this.title('Measure an area on the map.');
      },
      open: function () {

        enableViewConstraintZoom();

        initMeasureWidget('area', 'square-us-feet');

        closeVisiblePopup();
        closeLastActiveWidget();

        areaButton.classList.remove('esri-icon-measure-area');
        areaButton.classList.add('esri-icon-trash');
        areaButton.classList.add('active');

        $('div.esri-component.esri-direct-line-measurement-2d.esri-widget.esri-widget--panel').hide();

        activeWidget.containerId = activeWidget.buttonId = 'areaButton';
        activeWidget.worksMinimized = true;

        view.focus();

        this.title('Click or use escape to cancel measurement.');

        activeWidget.state = 'active';
      },
      clearMeasurements: function () { },
      title: function (title) {
        areaButton.setAttribute('title', title);
        areaButton.setAttribute('aria-label', title);
      },
    };

    const user_instructions_content = (id) => {
      let content = {
        title: '',
        text: '',
        notice: '',
        images: [],
        href: '',
        linkText: '',
        showCancel: true,
        showStart: false
      };

      let temp_boiler = `When your subject parcel is highlighted, the Buffer Slider tool can be used to create an offset, and the Tax Parcel Type filter can be used to 
        exclude unwanted parcels. <b>Buffering involves measuring the distance outward in all directions from your subject parcel at a specified distance to create an
        offset.</b> The data about each parcel, such as its Situs Address and Owner(s), is returned in the offset, which can be exported to PDF and CSV files. The subject 
        parcel is always the starting point for an offset and can be excluded from the exported data if necessary. Offset distances are available in Feet, Meters, 
        and sometimes Miles and Kilometers.<br />`;

      switch (id) {
        case 'pao-point':
          content.href = '/wp-content/uploads/mailing-labels-pao-point.mp4';
          content.linkText = 'Select a subject parcel with a point';
          content.title = `Parcels By Point - Getting started using the point sketch tool`;
          content.text = `This sketch tool allow you to locate your subject parcel by dropping a point on the map. The subject parcel will change color indicating 
            that buffering is active. ${temp_boiler}<br />`;
          content.notice = 'Note: The maximum zoom level for Parcels By Point is already set and disabled. Click Start to add your point now.';
          content.showStart = false;
          content.images.push({
            label: 'Using the Buffer Distance Settings',
            image: 'settings-buffer-distance.gif'
          });
          break;
        case 'pao-polygon':
          content.href = '/wp-content/uploads/mailing-labels-pao-polygon.mp4';
          content.linkText = 'Select your subject parcel with a polygon';
          content.title = `Parcels By Polygon - Getting started using the polygon sketch tool.`;
          content.text = `This sketch tool allow you to locate your subject parcel by drawing a polygin on the map. Before beginning your polygon sketch, pan the map 
            by dragging it so that the area where your polygon will be drawn is centered. When your area is centered, add the polygon by clicking the crosshair cursor 
            in the map to place your first vertex point. Move the cursor over the location and click the map where you want the vertex to end. Now move the cursor to 
            the next position and draw the second vertex. You will see sketch visualizations to help identify perpendicular and parallel lines. Continue this procedure 
            until your final point is set. Double-click the mouse to close the polygon. Any parcels within the polygon will change color indicating that buffering is active. ${temp_boiler}<br />`;
          content.notice = 'Note: The maximum zoom level for Parcels By Polygon is already set and disabled. Click Start to add your polygon now.';
          content.showStart = false;
          content.images.push({
            label: 'Parcels By Polygon',
            image: 'getting-started-by-polygon.gif'
          });
          break;
        case 'pao-rectangle':
          content.href = '/wp-content/uploads/mailing-labels-pao-rectangle.mp4';
          content.linkText = 'Select your subject parcel with a rectangle';
          content.title = `Parcels By Rectangle - Getting started using the rectangle sketch tool.`;
          content.text = `This sketch tool allow you to locate your subject parcel by drawing a rectangle on the map. Before beginning your rectangle sketch, pan the map 
            by dragging it so that the area where your rectangle will be drawn is centered. When your area is centered, add the rectangle by clicking the crosshair 
            cursor in the map to place your first point. Begin dragging your mouse on the map. As you move your mouse, you will see the area of the rectangle next 
            to your cursor. Finish the rectangle by releasing your mouse. Any parcels within the rectangle will change color indicating that buffering is active.`;
          content.notice = 'Note: The maximum zoom level for Parcels By Rectangle is already set and disabled. Click Start to add your rectangle now.<br /><br />';
          content.showStart = false;
          content.images.push({
            label: 'Parcels By Rectangle',
            image: 'getting-started-by-rectangle.gif'
          });
          break;
        case 'pao-by-condo':
          content.href = '/wp-content/uploads/mailing-labels-pao-by-condo.mp4';
          content.linkText = 'Selecting a Condominium as your subject parcel';
          content.title = `Condominium - Getting started using a map layer by Condominium.`;
          content.text = `This map layer option allows you to choose a single condominium from a list as your subject parcel. The map will navigate to your chosen condominium and highlight it. ${temp_boiler}<br />`;
          content.notice = '';
          content.showStart = false;
          content.images.push({
            label: 'Condominium',
            image: 'getting-started-by-condo.gif'
          });
          break;
        case 'pao-by-coop':
          content.href = '/wp-content/uploads/mailing-labels-pao-by-coop.mp4';
          content.linkText = 'Selecting a Cooperative as your subject parcel';
          content.title = `Cooperative - Getting started using a map layer by Cooperative.`;
          content.text = `This map layer option allows you to choose a single cooperative from a list as your subject parcel. The map will navigate to your chosen cooperative and highlight it. ${temp_boiler}<br />`;
          content.notice = '';
          content.showStart = false;
          content.images.push({
            label: 'Cooperative',
            image: 'getting-started-by-coop.gif'
          });
          break;
        case 'pao-by-subdv':
          content.href = '/wp-content/uploads/mailing-labels-pao-by-subdv.mp4';
          content.linkText = 'Selecting a Subdivision as your subject parcel';
          content.title = `Subdivision - Getting started using a map layer by Subdivision.`;
          content.text = `This map layer option allows you to choose a single subdivision from a list as your subject parcel. The map will navigate to your chosen subdivision and highlight it. ${temp_boiler}<br />`;
          content.notice = '';
          content.showStart = false;
          content.images.push({
            label: 'Subdivision',
            image: 'getting-started-by-subdv.gif'
          });
          break;
        case 'pao-by-parid':
          content.href = '/wp-content/uploads/mailing-labels-pao-by-parid.mp4';
          content.linkText = 'Using a Parcel Id as your subject parcel';
          content.title = `By Parcel Id - Getting started using a map layer by parcel Id.`;
          content.text = `Use the Parcel Id map layer option to input a valid Parcel Id. The map will navigate to your parcel and highlight it. You have the option to 
            set the buffer offset distance on the first parcel, or add additional parcels and set the offset distance individually. If you choose to set 
            the buffer distance, any additional parcels you add will inherit the same offset distance. ${temp_boiler}<br />`;
          content.notice = 'You can add up to 15 parcels.';
          content.showStart = false;
          content.images.push({
            label: 'By Parcel Id',
            image: 'getting-started-by-parid.gif'
          });
          break;
        case 'pao-taxparceltypes-block-info':
          content.href = '/wp-content/uploads/mailing-labels-pao-taxparceltypes-block-inf.mp4';
          content.linkText = 'Filtering by tax parcel type';
          content.title = content.linkText;
          content.text = `The Tax parcel types filter lets you leave out parcels that do not fit your mailing labels requirement.`;
          content.notice = '';
          content.showStart = false;
          break;
        case 'pao-buffer-slider-block-info':
          content.href = '/wp-content/uploads/buffer-distance-settings.mp4';
          content.linkText = 'Buffer Distance Settings';
          content.title = `Buffer Distance Settings.`;
          content.text = `<b>Buffer distance units</b> are available in Feet, Meters, and sometimes Miles and Kilometers.<br />
                            <b>Include / Exclude</b> subject parcel defaults to include the subject parcel.<br />
                            <b>Offset distance slider</b> sets the offset distance around the subject parcel.`;
          content.notice = '';
          content.showStart = false;
          break;
      }
      return content;
    };

    function doLogException(handler, error, tf = false) {
      if (!tf)
        tf = !(window.location.origin.indexOf('www') > -1);

      throw new PaoException(handler, tf, error);
    }

    return true;
  }); 





  function PaoSliderScale(unitType) {
    this.unitType = unitType.toLowerCase();
    this.labelHandles = true;
    this.labelTicks = true;
    this.max = 0;
    this.minLabel = 0;
    this.pageStep = 0;
    this.step = 0;
    this.ticks = 0;
    this.value = 0;

    this.scaleFeet = [
      {
        labelHandles: true,
        labelTicks: true,
        max: '750',
        minLabel: '0',
        pageStep: '20',
        step: '5',
        ticks: '125',
        value: '0',
      },
    ];
    this.scaleMeters = [
      {
        labelHandles: true,
        labelTicks: true,
        max: '228',
        minLabel: '0',
        pageStep: '20',
        step: '5',
        ticks: '60',
        value: '0',
      },
    ];
    this.scaleKilometers = [
      {
        labelHandles: true,
        labelTicks: true,
        max: '3.22',
        minLabel: '0',
        pageStep: '4',
        step: '0.644',
        ticks: '0.644',
        value: '0',
      },
    ];
    this.scaleMiles = [
      {
        labelHandles: true,
        labelTicks: true,
        max: '2',
        minLabel: '0',
        pageStep: '.5',
        step: '.25',
        ticks: '.25',
        value: '0',
      },
    ];
    this.assignScale = (scale) => {
      this.labelHandles = scale.labelHandles;
      this.labelTicks = scale.labelTicks;
      this.max = scale.max;
      this.minLabel = scale.minLabel;
      this.pageStep = scale.pageStep;
      this.step = scale.step;
      this.ticks = scale.ticks;
      this.value = scale.value;
    };
    this.scale = () => {
      switch (this.unitType) {
        case 'feet':
          this.assignScale(...this.scaleFeet);
          return [...this.scaleFeet];
        case 'meters':
          this.assignScale(...this.scaleMeters);
          return [...this.scaleMeters];
        case 'kilometers':
          this.assignScale(...this.scaleKilometers);
          return [...this.scaleKilometers];
        case 'miles':
          this.assignScale(...this.scaleMiles);
          return [...this.scaleMiles];
      }
    };

    this.getUnitType = (_type) => {
      switch (_type.toLowerCase()) {
        case 'feet':
          return 'ft';
        case 'meters':
          return 'm';
        case 'kilometers':
          return 'km';
        case 'miles':
          return 'mi';
      }
    };

    this.convert = (newType, oldType, size) => {
      if (!(size > 0)) return size;

      let matrixFeet = {
        yds: 0.333333,
        km: 0.0003048,
        m: 0.3048,
        mi: 0.0001893939,
      };
      let matrixMeters = {
        mi: 0.000621,
        ft: 3.28084,
        yds: 1.09361,
        km: 0.001,
      };
      let matrixMiles = { ft: 5280, km: 1.609344, m: 1.609344 };

      let t = this.getUnitType(newType.toLowerCase());
      let x = this.getUnitType(oldType.toLowerCase());
      let _matrix = null;
      switch (x) {
        case 'ft':
          _matrix = matrixFeet;
          break;
        case 'km':
          _matrix = matrixKilometers;
          break;
        case 'm':
          _matrix = matrixMeters;
          break;
        case 'mi':
          _matrix = matrixMiles;
          break;
      }
      if (_matrix) return size * _matrix[t];

    };
  }

  class PaoPopupTemplate {
    constructor() { }
    _goToContent = null;
    _isGoToBufferParcel = false;
    _isGoToParcel = false;
    _goToActions = [];
    _resultCount = 0;

    set IsGoToParcel(value) {
      this._isGoToParcel = value;
    }
    set IsGoToBufferParcel(value) {
      this._isGoToBufferParcel = value;
    }
    get resultCount() {
      return this._resultCount;
    }
    set resultCount(value) {
      this._resultCount = value;
    }

    set contentType(value) {
      switch (value) {
        case 'default':

          this._goToContent = "<div class='pao-esri-pop-content'><div><span class='pao-black'>Owner:</span><span class='pao-blue'> {PAR_OWNER_NAME1}</span></div>" +
            "<div><span class='pao-black'>Neighborhood:</span><span class='pao-blue'> {PAR_NBHD_NAME}</span></div>" +
            "<div><span class='pao-black'>Situs:</span><span class='pao-blue'> {SITUS_ADDRESS}</span></div>" +
            "<div><span class='pao-black'>{expression/SALE_DATE_LQ-label}</span><span class='pao-blue'>{expression/SALE_DATE_LQ}</span></div>" +
            "<div><span class='pao-black'>{expression/SALE_PRICE_LQ-label}</span><span class='pao-blue'>{expression/SALE_PRICE_LQ}</span></div>" +
            "<div><span class='pao-black'>{expression/SALE_VORI_LQ-label}</span><span class='pao-blue'>{expression/SALE_VORI_LQ}</span></div>" +
            "<div><span class='pao-black'>{expression/SALE_CODE_LQ-label}</span><span class='pao-blue'>{expression/SALE_CODE_LQ}</span></div>" +
            '</div>'
          break;
      }
    }
    buildGoToActions = () => {



      if (this._isGoToBufferParcel) {
        this._goToActions.push({
          title: 'Buffer Parcel',
          id: 'goto-buffer-parcel',
          image: '/wp-content/themes/frontier-child/images/buffer.png',
        });
      }


      if (this._isGoToParcel) {
        let image = '/wp-content/themes/frontier-child/images/view-parcel.png';
        if (this._isGoToBufferParcel)
          image = '/wp-content/themes/frontier-child/images/external-link.png';

        this._goToActions.push({
          title: ' View Parcel',
          id: 'goto-parcel',
          image: image
        });
      }

    };
    template = () => {
      this.buildGoToActions();
      let _menu_content = '';
      _menu_content = `<span class='pao-black'>Parcel ID:</span><span class='pao-blue'> {PARID}</span>`;

      return {
        title: `<div class='pao-esri-pop-title'>${_menu_content}</div>`,
        content: this._goToContent,
        actions: this._goToActions,
        expressionInfos: [
          {
            name: 'SALE_DATE_LQ-label',
            expression:
              "IIf(IsEmpty($feature.SALE_DATE_LQ), '', 'Last Qualified Sale Date: ')",
          },
          {
            name: 'SALE_DATE_LQ',
            expression:
              "IIf(IsEmpty($feature.SALE_DATE_LQ), '', Text(Date($feature.SALE_DATE_LQ), 'M/D/YYYY'))",
          },
          {
            name: 'SALE_PRICE_LQ-label',
            expression:
              "IIf(IsEmpty($feature.SALE_PRICE_LQ), '', 'Last Qualified Sale Price: ')",
          },
          {
            name: 'SALE_PRICE_LQ',
            expression:
              "IIf(IsEmpty($feature.SALE_PRICE_LQ), '', Text(Number($feature.SALE_PRICE_LQ *1, 0), '$###,###.##'))",
          },
          {
            name: 'SALE_VORI_LQ-label',
            expression:
              "IIf(IsEmpty($feature.SALE_VORI_LQ), '', 'Vacant or Improved: ')",
          },
          {
            name: 'SALE_VORI_LQ',
            expression:
              "IIf(IsEmpty($feature.SALE_VORI_LQ), '', IIf(Upper($feature.SALE_VORI_LQ) == 'V', 'Vacant', 'Improved'))",
          },
          {
            name: 'SALE_CODE_LQ-label',
            expression:
              "IIf(IsEmpty($feature.SALE_CODE_LQ), '', 'Qualification Code: ')",
          },
          {
            name: 'SALE_CODE_LQ',
            expression:
              "IIf(IsEmpty($feature.SALE_CODE_LQ), '', $feature.SALE_CODE_LQ)",
          },
        ],
      };
    }
  }
  class PaoException extends Error {
    constructor(name, showAlert, error, ...params) {
      super(...params);
      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, PaoException);
      }
      this.errorName = name;
      this.errorText = error;
      this.showAlert = showAlert;
      this.errorDate = new Date().toLocaleString('en-US');
      this.friendlyName = '';
      this.errorMessage = error?.message ? error.message : '';
      const PaoAlertAutoDismissSpeed = Object.freeze({
        Fast: 'fast',
        Medium: 'medium',
        Slow: 'slow',
      });
      switch (this.errorName) {
        case 'ExportToFileException':
          this.friendlyName = `Sorry. An unexpected error occurred while creating your download. Try refreshing the page and try again.`;
          break;
        default:
          this.friendlyName = 'Sorry. An unexpected error occurred. Try refreshing the page and try again.';
      }
      this.friendlyMessage = `Reported: ${this.errorDate.toLocaleString('en-US')}`;
      if (this.showAlert) {
        PaoError.showAlert({
          title: this.friendlyName,
          message: this.friendlyMessage,
          scale: 's',
          placement: 'bottom',
          auto_close: false,
          auto_close_speed: PaoAlertAutoDismissSpeed.Fast,
        });
      }

      this.logError();
    }
    logError = () => {
      let plog = new PaoLogger();
      let options = {
        date: this.errorDate,
        location: this.errorName,
        message: this.errorMessage,
        text: this.errorName,
        type: 'error'
      };
      plog.logAdd(options);
    };
  }

  class AlertKind {
    constructor() { }
    static Brand = 'brand';
    static Danger = 'danger';
    static Info = '';
    static Success = 'success';
    static Warning = 'warning';
  }

  class PaoAlert extends AlertKind {
    constructor() { }
    static calciteAlert = (
      id,
      kind,
      icon,
      scale = 'm',
      placement = 'top',
      title,
      message,
      auto_close = false,
      auto_close_speed = 'fast'
    ) => {

      let el = document.querySelectorAll('#calcite-alert');
      if (el?.length > 1)
        id = `${id}-${el?.length + 1}`;

      if (!icon)
        icon = '';

      let pao_alert = document.createElement('calcite-alert');
      pao_alert.setAttribute('id', id);
      pao_alert.setAttribute('open', '');
      pao_alert.setAttribute('kind', kind);
      pao_alert.setAttribute('placement', placement);
      pao_alert.setAttribute('icon', icon);
      pao_alert.setAttribute('scale', scale);
      if (auto_close) {
        pao_alert.setAttribute('auto-close', null);
        pao_alert.setAttribute('auto-close-duration', auto_close_speed);
      }
      pao_alert.setFocus();
      pao_alert.addEventListener('calciteAlertClose', (event) => {
        if (event?.target?.id != null) {
          let id = event.target.id;
          let el = document.getElementById(id);
          if (el) el.remove();
        }
      });

      let _title = document.createElement('div');
      _title.setAttribute('slot', 'title');
      _title.innerHTML = `${title}`;

      pao_alert.appendChild(_title);

      let _message = document.createElement('div');
      _message.setAttribute('slot', 'message');
      _message.innerHTML = `${message}`;

      pao_alert.appendChild(_message);

      let shell = document.getElementById('pao-shell');
      if (shell) shell.appendChild(pao_alert);
      return id;
    };
  }

  class PaoError extends PaoAlert {
    constructor() { }
    static showAlert = ({
      title,
      message,
      scale,
      placement,
      auto_close,
      auto_close_speed,
    }) => {
      this.calciteAlert(
        'pao-shell-error-alert',
        this.Danger,
        'exclamation-mark-triangle',
        scale,
        placement,
        title,
        message,
        auto_close,
        auto_close_speed
      );
    };
  }
  class PaoWarning extends PaoAlert {
    constructor() { }
    static showAlert = ({
      title,
      message,
      scale,
      placement,
      auto_close,
      auto_close_speed,
    }) => {
      this.calciteAlert(
        'pao-shell-warning-alert',
        this.Warning,
        'exclamation-mark-triangle',
        scale,
        placement,
        title,
        message,
        auto_close,
        auto_close_speed
      );
    };
  }
  class PaoSuccess extends PaoAlert {
    constructor() { }
    static showAlert = ({
      title,
      message,
      scale,
      placement,
      auto_close,
      auto_close_speed,
    }) => {
      this.calciteAlert(
        'pao-shell-success-alert',
        this.Success,
        'check-circle',
        scale,
        placement,
        title,
        message,
        auto_close,
        auto_close_speed
      );
    };
  }
  class PaoInfo extends PaoAlert {
    constructor() { }
    static showAlert = ({
      title,
      message,
      scale,
      placement,
      auto_close,
      auto_close_speed,
      icon
    }) => {
      return this.calciteAlert(
        'pao-shell-info-alert',
        this.Info,
        icon, 
        scale,
        placement,
        title,
        message,
        auto_close,
        auto_close_speed
      );
    };
  }

  class PaoLogger {
    constructor() { }
    logAdd = (options) => {
      let xhr = new XMLHttpRequest();
      let http = '/wp-content/themes/frontier-child/models';
      let url = `${http}/pao-model-logger.php`;

      options['visitorip'] = paoDetails.client.visitorIP;

      xhr.open('POST', url, true);

      xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');

      xhr.onreadystatechange = () => {
        if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
        }
      };
      let data = JSON.stringify(options);
      xhr.send(data);
    };
  }
};